import React__default, { Component, createElement, PureComponent, Fragment } from 'react';

var ProfileContext = React__default.createContext({});
var ProfileProvider = ProfileContext.Provider,
    ProfileConsumer = ProfileContext.Consumer;

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var MembershipCategory;

(function (MembershipCategory) {
  MembershipCategory["AARP"] = "AARP";
  MembershipCategory["EMPIRE"] = "EMPIRE";
  MembershipCategory["EXCHANGE"] = "EXCHANGE";
  MembershipCategory["EXPATRIATE"] = "EXPATRIATE";
  MembershipCategory["JPMC"] = "JPMC";
  MembershipCategory["MEDICA"] = "MEDICA";
  MembershipCategory["OXFORD"] = "OXFORD";
  MembershipCategory["PCP"] = "PCP";
  MembershipCategory["PUBLIC_EXCHANGE"] = "PUBLIC_EXCHANGE";
  MembershipCategory["RETIREE"] = "RETIREE";
  MembershipCategory["SMALL_BUSINESS"] = "SMALL_BUSINESS";
  MembershipCategory["TEXAS_ERS"] = "TEXAS_ERS";
  MembershipCategory["UHC_MEDICA"] = "UHC_MEDICA";
  MembershipCategory["UHC_WEST"] = "UHC_WEST";
  MembershipCategory["UHC"] = "UHC";
})(MembershipCategory || (MembershipCategory = {}));

var Aco;

(function (Aco) {
  Aco["CDP"] = "CDP";
})(Aco || (Aco = {}));

var LineOfBusiness;

(function (LineOfBusiness) {
  LineOfBusiness["EI"] = "E&I";
  LineOfBusiness["MR"] = "M&R";
  LineOfBusiness["CS"] = "C&S";
})(LineOfBusiness || (LineOfBusiness = {}));

var MemberFeature;

(function (MemberFeature) {
  MemberFeature["ActivateEligible"] = "activateEligible";
  MemberFeature["HsaEligible"] = "hsaEligible";
  MemberFeature["ViewRestricted"] = "viewRestricted";
  MemberFeature["PcpEligible"] = "pcpEligible";
  MemberFeature["PcdEligible"] = "pcdEligible";
  MemberFeature["HasPcpReferrals"] = "hasPcpReferrals";
  MemberFeature["PremiumPaymentEligible"] = "premiumPaymentEligible";
  MemberFeature["FpcEligible"] = "fpcEligible";
  MemberFeature["IsDsnp"] = "isDsnp";
})(MemberFeature || (MemberFeature = {}));

var CoverageStatus;

(function (CoverageStatus) {
  CoverageStatus["Future"] = "FUTURE";
  CoverageStatus["Active"] = "ACTIVE";
  CoverageStatus["Termed"] = "TERMED";
})(CoverageStatus || (CoverageStatus = {}));

var CoverageTypeCode;

(function (CoverageTypeCode) {
  CoverageTypeCode["MA"] = "MA";
  CoverageTypeCode["SSP"] = "SSP";
  CoverageTypeCode["MAPD"] = "MAPD";
  CoverageTypeCode["PDP"] = "PDP";
  CoverageTypeCode["HospitalIndemnity"] = "HIP";
  CoverageTypeCode["HospitalIndemnityRider"] = "HIPRIDER";
  CoverageTypeCode["MedicareSupplement"] = "MEDSUPP";
  CoverageTypeCode["MedicareSupplementRider"] = "MEDSUPPRIDER";
  CoverageTypeCode["PHIP"] = "PHIP";
})(CoverageTypeCode || (CoverageTypeCode = {}));

var CoverageType;

(function (CoverageType) {
  CoverageType["Medical"] = "MEDICAL";
  CoverageType["Vision"] = "VISION";
  CoverageType["Dental"] = "DENTAL";
  CoverageType["Rx"] = "RX";
  CoverageType["BehaviorHealth"] = "BEHAVIORAL_HEALTH";
})(CoverageType || (CoverageType = {}));

var PrimaryPolicyNumber;

(function (PrimaryPolicyNumber) {
  PrimaryPolicyNumber["masco"] = "MASCO";
})(PrimaryPolicyNumber || (PrimaryPolicyNumber = {}));

var ProductType;

(function (ProductType) {
  ProductType["RallyConnect"] = "RALLYCONNECT";
  ProductType["RallyEngage"] = "RALLYENGAGE";
  ProductType["NurseChat"] = "NURSECHAT";
  ProductType["NurseLine"] = "NURSELINE";
  ProductType["EasyConnect"] = "EASYCONNECT";
  ProductType["ClickToChat"] = "CLICKTOCHAT";
  ProductType["SecureMessage"] = "SECUREMESSAGE";
  ProductType["W500"] = "W500";
  ProductType["DVCN"] = "DVCN";
  ProductType["MemberSupport"] = "MEMBERSUPPORT";
  ProductType["RX"] = "RX";
  ProductType["LAWW"] = "LAWW";
  ProductType["IHR"] = "IHR";
})(ProductType || (ProductType = {}));

var ProductKey;

(function (ProductKey) {
  ProductKey["RallyConnect"] = "rallyConnect";
  ProductKey["RallyEngage"] = "rallyEngage";
  ProductKey["NurseChat"] = "nurseChat";
  ProductKey["NurseLine"] = "nurseLine";
  ProductKey["EasyConnect"] = "easyConnect";
  ProductKey["ClickToChat"] = "clickToChat";
  ProductKey["SecureMessage"] = "secureMessage";
  ProductKey["MedicalSupport"] = "medicalSupport";
  ProductKey["TechnicalSupport"] = "technicalSupport";
  ProductKey["Rx"] = "rx";
  ProductKey["IndividualHealthRecord"] = "individualHealthRecord";
  ProductKey["LiveAndWorkWell"] = "liveAndWorkWell";
  ProductKey["NurseHealthLine"] = "nurseHealthLine";
  ProductKey["SilverSneakers"] = "silverSneakers";
  ProductKey["VisionDiscount"] = "visionDiscount";
  ProductKey["AtYourBest"] = "atYourBest";
  ProductKey["Dime"] = "dime";
  ProductKey["Dime2"] = "dime2";
  ProductKey["ProviderDiscountNetwork"] = "providerDiscountNetwork";
  ProductKey["MyCarePath"] = "myCarePath";
})(ProductKey || (ProductKey = {}));

var State;

(function (State) {
  State["AL"] = "AL";
  State["AK"] = "AK";
  State["AZ"] = "AZ";
  State["AR"] = "AR";
  State["CA"] = "CA";
  State["CO"] = "CO";
  State["CT"] = "CT";
  State["DE"] = "DE";
  State["FL"] = "FL";
  State["GA"] = "GA";
  State["HI"] = "HI";
  State["ID"] = "ID";
  State["IL"] = "IL";
  State["IN"] = "IN";
  State["IA"] = "IA";
  State["KS"] = "KS";
  State["KY"] = "KY";
  State["LA"] = "LA";
  State["ME"] = "ME";
  State["MD"] = "MD";
  State["MA"] = "MA";
  State["MI"] = "MI";
  State["MN"] = "MN";
  State["MS"] = "MS";
  State["MO"] = "MO";
  State["MT"] = "MT";
  State["NE"] = "NE";
  State["NV"] = "NV";
  State["NH"] = "NH";
  State["NJ"] = "NJ";
  State["NM"] = "NM";
  State["NY"] = "NY";
  State["NC"] = "NC";
  State["ND"] = "ND";
  State["OH"] = "OH";
  State["OK"] = "OK";
  State["OR"] = "OR";
  State["PA"] = "PA";
  State["RI"] = "RI";
  State["SC"] = "SC";
  State["SD"] = "SD";
  State["TN"] = "TN";
  State["TX"] = "TX";
  State["UT"] = "UT";
  State["VT"] = "VT";
  State["VA"] = "VA";
  State["WA"] = "WA";
  State["WV"] = "WV";
  State["WI"] = "WI";
  State["WY"] = "WY";
})(State || (State = {}));

function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


  var length = prev.length;

  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;
  var lastArgs = null;
  var lastResult = null; // we reference arguments instead of spreading them for performance reasons

  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return _typeof(dep);
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      return memoizedResultFunc.apply(null, params);
    });
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;

    selector.recomputations = function () {
      return recomputations;
    };

    selector.resetRecomputations = function () {
      return recomputations = 0;
    };

    return selector;
  };
}
var createSelector = createSelectorCreator(defaultMemoize);

var getAcos = function getAcos(profile) {
  if (!profile) {
    return [];
  }

  return profile.currentUser.planCoverages.map(function (c) {
    return c.additionalCoverageInfo.aco;
  }).filter(function (c) {
    return c !== undefined;
  });
};
var getClientInfo = function getClientInfo(profile) {
  if (!profile) {
    return undefined;
  }

  return profile.clientInfo;
};
var getMembershipCategory = function getMembershipCategory(profile) {
  if (!profile) {
    return undefined;
  }

  return profile.currentUser.membershipCategory;
};
var getLineOfBusiness = function getLineOfBusiness(profile) {
  if (!profile) {
    return undefined;
  }

  return profile.currentUser.lineOfBusiness;
};
var isCdp = createSelector(getAcos, function (acos) {
  return Boolean(acos.find(function (aco) {
    return aco === 'CDP';
  }));
});

var ImageKey;

(function (ImageKey) {
  ImageKey["Rally"] = "Rally";
  ImageKey["UnitedHealth"] = "UnitedHealth";
  ImageKey["AARP"] = "AARP";
  ImageKey["CDP"] = "CDP";
  ImageKey["CVSCaremark"] = "CVSCaremark";
  ImageKey["ERS"] = "ERS";
  ImageKey["ExpressScripts"] = "ExpressScripts";
  ImageKey["IconHelp"] = "IconHelp";
  ImageKey["Medica"] = "Medica";
  ImageKey["MedicaHealthcare"] = "MedicaHealthcare";
  ImageKey["OptumBank"] = "OptumBank";
  ImageKey["OptumRx"] = "OptumRx";
  ImageKey["PreferredCare"] = "PreferredCare";
  ImageKey["UHCCommunity"] = "UHCCommunity";
  ImageKey["UHCGlobal"] = "UHCGlobal";
  ImageKey["UHCOxford"] = "UHCOxford";
  ImageKey["UnitedHealthMobile"] = "UnitedHealthMobile";
  ImageKey["Walgreens"] = "Walgreens";
})(ImageKey || (ImageKey = {}));

var defaultBaseUrls = {
  myUhcBaseUrl: 'https://test1.myuhc.com',
  myUhcLegacyEnBaseUrl: 'https://systest1.myuhc.com',
  myUhcLegacyEsBaseUrl: 'https://es-systest1.myuhc.com',
  connectUrl: 'https://connect.dev.werally.in',
  healthRecordUrl: 'https://ihr.dev.werally.in',
  engageUrl: 'https://dev.werally.in',
  surveyUrl: 'https://survey.dev.werally.in',
  rewardsUrl: 'https://rewards.dev.werally.in',
  rxUrl: 'https://rx.dev.werally.in',
  arcadeUrl: 'https://arcade.dev.werally.in'
};

var _React$createContext = React__default.createContext({
  baseUrls: defaultBaseUrls,
  imageUrls: {}
}),
    UrlProvider = _React$createContext.Provider,
    UrlConsumer = _React$createContext.Consumer;

var SourceType;

(function (SourceType) {
  SourceType["Image"] = "image";
  SourceType["String"] = "string";
})(SourceType || (SourceType = {}));

var stringSrc = function stringSrc(src) {
  return {
    kind: SourceType.String,
    src: src
  };
};
var keySrc = function keySrc(key) {
  return {
    kind: SourceType.Image,
    imageKey: key
  };
};

var srcToString = function srcToString(imageUrls, src) {
  if (!src || typeof src === 'string') {
    return src;
  }

  switch (src.kind) {
    case SourceType.Image:
      return imageUrls[src.imageKey];

    case SourceType.String:
      return src.src;
  }
};

var Image = function Image(_ref) {
  var src = _ref.src,
      props = _objectWithoutProperties(_ref, ["src"]);

  return React__default.createElement(UrlConsumer, null, function (_ref2) {
    var imageUrls = _ref2.imageUrls;
    var imageUrl = srcToString(imageUrls, src);
    return React__default.createElement("img", _extends({}, props, {
      src: imageUrl
    }));
  });
};

var _lineOfBusinessDefaul;
var defaultLogo = {
  alt: 'United Healthcare',
  src: keySrc(ImageKey.UnitedHealth)
};
var defaultCsLogo = {
  alt: 'United Healthcare Community Plan',
  src: keySrc(ImageKey.UHCCommunity)
};
var lineOfBusinessDefaults = (_lineOfBusinessDefaul = {}, _defineProperty(_lineOfBusinessDefaul, LineOfBusiness.EI, defaultLogo), _defineProperty(_lineOfBusinessDefaul, LineOfBusiness.CS, defaultCsLogo), _defineProperty(_lineOfBusinessDefaul, LineOfBusiness.MR, defaultLogo), _lineOfBusinessDefaul);
var mr = [LineOfBusiness.MR];
var ei = [LineOfBusiness.CS, LineOfBusiness.EI];
var brandDefinitions = [{
  id: MembershipCategory.AARP,
  logo: {
    src: keySrc(ImageKey.AARP),
    alt: 'AARP: Medicare Plans from United Healthcare'
  },
  overridesPrimary: true,
  linesOfBusiness: mr
}, {
  id: MembershipCategory.MEDICA,
  logo: {
    src: keySrc(ImageKey.MedicaHealthcare),
    alt: 'Medica Healthcare'
  },
  overridesPrimary: true,
  linesOfBusiness: mr
}, {
  id: MembershipCategory.PCP,
  logo: {
    src: keySrc(ImageKey.PreferredCare),
    alt: 'Preferred Care Partners'
  },
  overridesPrimary: true,
  linesOfBusiness: mr
}, {
  id: MembershipCategory.TEXAS_ERS,
  logo: {
    src: keySrc(ImageKey.ERS),
    alt: 'Health Select Medicare RX of Texas'
  },
  overridesPrimary: true,
  linesOfBusiness: mr
}, {
  id: MembershipCategory.OXFORD,
  logo: {
    src: keySrc(ImageKey.UHCOxford),
    alt: 'United Healthcare Oxford'
  },
  overridesPrimary: true,
  linesOfBusiness: ei
}, {
  id: MembershipCategory.EXPATRIATE,
  logo: {
    src: keySrc(ImageKey.UHCGlobal),
    alt: 'United Healthcare Global'
  },
  overridesPrimary: true,
  linesOfBusiness: ei
}, {
  id: MembershipCategory.UHC_MEDICA,
  logo: {
    src: keySrc(ImageKey.Medica),
    alt: 'Medica'
  },
  overridesPrimary: false,
  mobilePrimary: true,
  linesOfBusiness: ei
}, {
  id: Aco.CDP,
  logo: {
    src: keySrc(ImageKey.CDP),
    alt: 'Centura Health'
  },
  overridesPrimary: false,
  mobilePrimary: true,
  linesOfBusiness: ei
}];
var findBrand = function findBrand(lob, membershipCategory) {
  return brandDefinitions.find(function (b) {
    return b.linesOfBusiness.indexOf(lob) !== -1 && b.id === membershipCategory;
  });
};

var getLineOfBusinessLogo = createSelector(getLineOfBusiness, function (lineOfBusiness) {
  if (!lineOfBusiness) {
    return undefined;
  }

  return lineOfBusinessDefaults[lineOfBusiness];
});
var getSecondaryBrand = createSelector(isCdp, getLineOfBusiness, getMembershipCategory, function (cdp, lineOfBusiness, membershipCategory) {
  if (!lineOfBusiness || !membershipCategory && !cdp) {
    return undefined;
  }

  var category = cdp ? Aco.CDP : membershipCategory;
  return category && findBrand(lineOfBusiness, category);
});
var getClientLogo = createSelector(getClientInfo, function (clientInfo) {
  if (!clientInfo || !clientInfo.logo) {
    return undefined;
  }

  return {
    src: clientInfo.logo && stringSrc(clientInfo.logo),
    alt: clientInfo.displayName
  };
});
var getLogos = createSelector(getLineOfBusinessLogo, getSecondaryBrand, getClientLogo, function (lineOfBusinessLogo, secondaryBrand, clientLogo) {
  var primaryOverridden = secondaryBrand && secondaryBrand.overridesPrimary;
  var includeMobile = secondaryBrand && secondaryBrand.mobilePrimary;
  var logos = [!primaryOverridden && lineOfBusinessLogo, secondaryBrand && secondaryBrand.logo, clientLogo];
  var definedLogos = logos.filter(function (logo) {
    return !!logo;
  });

  if (includeMobile) {
    var _definedLogos = _toArray(definedLogos),
        firstLogo = _definedLogos[0],
        restOfLogos = _definedLogos.slice(1);

    var mobileFirstLogo = _objectSpread({
      mobileSrc: keySrc(ImageKey.UnitedHealthMobile)
    }, firstLogo);

    return [mobileFirstLogo].concat(_toConsumableArray(restOfLogos));
  }

  return definedLogos;
});

var _React$createContext$1 = React__default.createContext({
  handleTrack: function handleTrack() {
    return undefined;
  }
}),
    TrackingProvider = _React$createContext$1.Provider,
    TrackingConsumer = _React$createContext$1.Consumer;

var FeatureContext = React__default.createContext({
  features: []
});
var FeatureProvider = FeatureContext.Provider,
    FeatureConsumer = FeatureContext.Consumer;

var trackFun = function trackFun(handleTrack, features) {
  return function (track, onClick, href) {
    return function (event) {
      if (href) {
        handleTrack({
          track: track,
          href: href,
          features: features,
          event: event.nativeEvent
        });
      } else {
        handleTrack({
          track: track,
          features: features,
          event: event.nativeEvent
        });
      }

      if (onClick) {
        onClick(event);
      }
    };
  };
};

var Tracked = function Tracked(_ref) {
  var children = _ref.children;
  return React__default.createElement(TrackingConsumer, null, function (_ref2) {
    var handleTrack = _ref2.handleTrack;
    return React__default.createElement(FeatureConsumer, null, function (_ref3) {
      var features = _ref3.features;
      return children({
        handleTrack: trackFun(handleTrack, features)
      });
    });
  });
};

var makeTrackedClickable = function makeTrackedClickable(type) {
  var Component$$1 = function Component$$1(props) {
    var children = props.children,
        href = props.href,
        track = props.track,
        onClick = props.onClick;
    var ref = props.innerRef;
    return React__default.createElement(Tracked, null, function (_ref) {
      var handleTrack = _ref.handleTrack;

      var finalProps = _extends({}, props, {
        ref: ref
      });

      if (track) {
        var trackedOnClick = handleTrack(track, onClick, href);
        finalProps = _extends({}, finalProps, {
          onClick: trackedOnClick
        });
        delete finalProps.track;
      }

      delete finalProps.innerRef;
      return React__default.createElement(type, finalProps, children);
    });
  };

  Component$$1.displayName = "Tracked(".concat(type, ")");
  return Component$$1;
};

var LinkTarget;

(function (LinkTarget) {
  LinkTarget["Self"] = "_self";
  LinkTarget["Blank"] = "_blank";
})(LinkTarget || (LinkTarget = {}));

var LinkItemType; // only add showForLob or requiresEligibility if you want to make the FooterItem
// exclusive, default behavior is to display.

(function (LinkItemType) {
  LinkItemType["Text"] = "text";
  LinkItemType["Link"] = "link";
  LinkItemType["Button"] = "button";
})(LinkItemType || (LinkItemType = {}));

var Anchor = makeTrackedClickable('a');

var TargetAwareAnchor = function TargetAwareAnchor(props) {
  var rel = props.target === LinkTarget.Blank ? 'noopener noreferrer' : undefined;
  return React__default.createElement(Anchor, _extends({
    rel: rel
  }, props));
};

var Button = makeTrackedClickable('button');

var Input = makeTrackedClickable('input');

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var PrimaryLogo = function PrimaryLogo(props) {
  var src = props.src,
      alt = props.alt,
      mobileSrc = props.mobileSrc;
  var className = 'primary-logo';

  if (!mobileSrc) {
    return createElement(Image, {
      src: src,
      alt: alt,
      className: className
    });
  }

  return createElement(Fragment, null, createElement(Image, _extends({
    src: src,
    alt: alt
  }, {
    className: classnames(className, 'hide-mobile')
  })), createElement(Image, _extends({
    src: mobileSrc,
    alt: alt
  }, {
    className: classnames(className, 'hide-desktop')
  })));
};

var defaultFeatureFlags = {
  isHeaderFooterPhaseTwoOn: false,
  isRallyRxOn: false
};

var _React$createContext$2 = React__default.createContext(defaultFeatureFlags),
    FeatureFlagProvider = _React$createContext$2.Provider,
    FeatureFlagConsumer = _React$createContext$2.Consumer;

var FeatureFlagGate = function FeatureFlagGate(_ref) {
  var flag = _ref.flag,
      flaggedFeature = _ref.flaggedFeature,
      defaultFeature = _ref.defaultFeature;
  return React__default.createElement(FeatureFlagConsumer, null, function (value) {
    if (value[flag]) {
      return flaggedFeature;
    } else {
      return defaultFeature ? defaultFeature : null;
    }
  });
};

var _links;

var withLegacyUrl = function withLegacyUrl(f) {
  return function (props) {
    var myUhcLegacyBaseUrl = props.id !== 'es-US' ? props.baseUrls.myUhcLegacyEnBaseUrl : props.baseUrls.myUhcLegacyEsBaseUrl;
    return f(_objectSpread({
      myUhcLegacyBaseUrl: myUhcLegacyBaseUrl
    }, props));
  };
};

function isObject(item) {
  return !!item && _typeof(item) === 'object' && !Array.isArray(item);
}
function parseUrl(href) {
  var uri = document.createElement('a');
  uri.href = href; // IE fix for converting relative to absolute paths

  if (uri.host === '') {
    uri.href = uri.href;
  }

  return uri;
}

function mergeDeep(target, source) {
  var output = _extends({}, target);

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      if (isObject(source[key])) {
        if (!(key in target)) {
          output[key] = mergeDeep({}, source[key]);
        } else {
          output[key] = mergeDeep(target[key], source[key]);
        }
      } else {
        var val = target[key] || source[key];

        _extends(output, _defineProperty({}, key, val));
      }
    });
  }

  return output;
}

var baseLinks = mergeDeep({}, {
  FOOTER: {
    ACCESSIBILITY: function ACCESSIBILITY() {
      return "https://www.uhc.com/legal/accessibility";
    },
    LEGAL_NOTICES: function LEGAL_NOTICES() {
      return 'https://www.uhc.com/legal';
    },
    LEGAL: {
      PRELOGIN_COMPANY_INFO: withLegacyUrl(function (_ref) {
        var myUhcLegacyBaseUrl = _ref.myUhcLegacyBaseUrl;
        return "".concat(myUhcLegacyBaseUrl, "/member/preLoginCompanyInfoLayout.do") + "?psnName=link.nav.footer.companyinfo.prelogin&requestor=/footerPreLogin";
      }),
      PRELOGIN_EXTERNAL_URI: withLegacyUrl(function (_ref2) {
        var myUhcLegacyBaseUrl = _ref2.myUhcLegacyBaseUrl;
        return "".concat(myUhcLegacyBaseUrl, "/member/preLoginExternalURLLayout.do") + "?psnName=link.footer.legalentity&requestor=/footerPreLogin";
      }),
      PRELOGIN_PRIVACY_LAYOUT: withLegacyUrl(function (_ref3) {
        var myUhcLegacyBaseUrl = _ref3.myUhcLegacyBaseUrl;
        return "".concat(myUhcLegacyBaseUrl, "/member/preLoginPrivacyLayout.do") + "?psnName=link.nav.footer.privacy.prelogin&requestor=/footerPreLogin";
      }),
      PRELOGIN_LEGAL_LAYOUT: withLegacyUrl(function (_ref4) {
        var myUhcLegacyBaseUrl = _ref4.myUhcLegacyBaseUrl;
        return "".concat(myUhcLegacyBaseUrl, "/member/preLoginLegalLayout.do") + "?psnName=link.nav.footer.legal.prelogin&requestor=/footerPreLogin";
      }),
      NON_DISCRIMINATION_ENG: function NON_DISCRIMINATION_ENG() {
        return 'https://www.uhc.com/legal/nondiscrimination-and-language-assistance-notices';
      },
      NON_DISCRIMINATION_SPA: function NON_DISCRIMINATION_SPA() {
        return 'https://www.uhc.com/legal/nondiscrimination-and-language-assistance-notices#spa';
      },
      NON_DISCRIMINATION_CHI: function NON_DISCRIMINATION_CHI() {
        return 'https://www.uhc.com/legal/nondiscrimination-and-language-assistance-notices#Chi';
      }
    },
    PROVIDER_DATA_INFO: function PROVIDER_DATA_INFO() {
      return 'https://www.uhc.com/legal/provider';
    },
    LEGAL_ENTITIES: function LEGAL_ENTITIES() {
      return 'https://www.uhc.com/legal/legal-entities';
    }
  },
  HEADER: {
    PREMIUM_PAYMENTS: function PREMIUM_PAYMENTS(_ref5) {
      var arcadeUrl = _ref5.arcadeUrl;
      return "".concat(arcadeUrl, "/premium-payments");
    },
    SECURE_CLAIMS_ACCOUNT: function SECURE_CLAIMS_ACCOUNT(_ref6) {
      var myUhcBaseUrl = _ref6.myUhcBaseUrl,
          language = _ref6.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/claims-account.html");
    },
    SECURE_BENEFITS_COVERAGE: function SECURE_BENEFITS_COVERAGE(_ref7) {
      var myUhcBaseUrl = _ref7.myUhcBaseUrl,
          language = _ref7.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/benefits-coverage.html");
    },
    SECURE_PHARMACIES_PRESCRIPTIONS: function SECURE_PHARMACIES_PRESCRIPTIONS(_ref8) {
      var arcadeUrl = _ref8.arcadeUrl;
      return "".concat(arcadeUrl, "/pharmacy");
    },
    EXT_FIND_CARE: function EXT_FIND_CARE(_ref9) {
      var connectUrl = _ref9.connectUrl,
          id = _ref9.id;
      return "".concat(connectUrl, "?locale=").concat(id);
    },
    RALLY_RX: function RALLY_RX(_ref10) {
      var rxUrl = _ref10.rxUrl,
          id = _ref10.id;
      return "".concat(rxUrl, "?locale=").concat(id);
    },
    DASHBOARD: function DASHBOARD(_ref11) {
      var arcadeUrl = _ref11.arcadeUrl;
      return "".concat(arcadeUrl, "/dashboard");
    }
  },
  SHARED: {
    ACCOUNT_SETTINGS: function ACCOUNT_SETTINGS(_ref12) {
      var myUhcBaseUrl = _ref12.myUhcBaseUrl,
          language = _ref12.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/account-profile.html");
    },
    HEALTH_CHECKLIST: function HEALTH_CHECKLIST(_ref13) {
      var connectUrl = _ref13.connectUrl,
          id = _ref13.id;
      return "".concat(connectUrl, "/health-checklist?locale=").concat(id);
    },
    HELP: function HELP(_ref14) {
      var arcadeUrl = _ref14.arcadeUrl;
      return "".concat(arcadeUrl, "/help");
    },
    MESSAGES: function MESSAGES(_ref15) {
      var myUhcBaseUrl = _ref15.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/content/myuhc/en/secure/message-center.html");
    },
    SAVED: function SAVED(_ref16) {
      var connectUrl = _ref16.connectUrl,
          id = _ref16.id;
      return "".concat(connectUrl, "/saved-providers/gallery?locale=").concat(id);
    }
  }
});
var mrLinks = mergeDeep({
  FOOTER: {
    LEGAL_NOTICES: function LEGAL_NOTICES(_ref17) {
      var myUhcBaseUrl = _ref17.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/reference/disclaimers.html");
    },
    LEGAL: {
      PRELOGIN_COMPANY_INFO: function PRELOGIN_COMPANY_INFO(_ref18) {
        var myUhcBaseUrl = _ref18.myUhcBaseUrl;
        return "".concat(myUhcBaseUrl, "/member/reference/about-us.html");
      },
      PRELOGIN_EXTERNAL_URI: function PRELOGIN_EXTERNAL_URI(_ref19) {
        var myUhcBaseUrl = _ref19.myUhcBaseUrl;
        return "".concat(myUhcBaseUrl, "/member/reference/disclaimers.html");
      },
      PRELOGIN_PRIVACY_LAYOUT: function PRELOGIN_PRIVACY_LAYOUT(_ref20) {
        var myUhcBaseUrl = _ref20.myUhcBaseUrl;
        return "".concat(myUhcBaseUrl, "/member/reference/privacy-policy.html");
      },
      PRELOGIN_LEGAL_LAYOUT: function PRELOGIN_LEGAL_LAYOUT(_ref21) {
        var myUhcBaseUrl = _ref21.myUhcBaseUrl;
        return "".concat(myUhcBaseUrl, "/member/reference/terms-of-use.html");
      },
      NON_DISCRIMINATION_ENG: function NON_DISCRIMINATION_ENG(_ref22) {
        var myUhcBaseUrl = _ref22.myUhcBaseUrl;
        return "".concat(myUhcBaseUrl, "/content/dam/UCP/Individual/Non-Discrimination_Form_English.pdf");
      },
      NON_DISCRIMINATION_SPA: function NON_DISCRIMINATION_SPA(_ref23) {
        var myUhcBaseUrl = _ref23.myUhcBaseUrl;
        return "".concat(myUhcBaseUrl, "/content/dam/UCP/Individual/Non-Discrimination_Form_Spanish.pdf");
      },
      NON_DISCRIMINATION_CHI: function NON_DISCRIMINATION_CHI(_ref24) {
        var myUhcBaseUrl = _ref24.myUhcBaseUrl;
        return "".concat(myUhcBaseUrl, "/content/dam/UCP/Individual/Non-Discrimination_Form_Chinese.pdf");
      }
    }
  },
  HEADER: {
    SECURE_CLAIMS_ACCOUNT: function SECURE_CLAIMS_ACCOUNT(_ref25) {
      var myUhcBaseUrl = _ref25.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/claims.html");
    },
    SECURE_BENEFITS_COVERAGE: function SECURE_BENEFITS_COVERAGE(_ref26) {
      var myUhcBaseUrl = _ref26.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/benefits-coverage.html");
    },
    PREMIUM_PAYMENTS: function PREMIUM_PAYMENTS(_ref27) {
      var myUhcBaseUrl = _ref27.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/premium-payments.html");
    },
    HEALTH: function HEALTH(_ref28) {
      var myUhcBaseUrl = _ref28.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/health-and-wellness.html");
    },
    FORMS_AND_RESOURCES: function FORMS_AND_RESOURCES(_ref29) {
      var myUhcBaseUrl = _ref29.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/documents/overview.html");
    },
    RECOMMENDATION: function RECOMMENDATION(_ref30) {
      var arcadeUrl = _ref30.arcadeUrl;
      return "".concat(arcadeUrl, "/recommendations");
    }
  },
  SHARED: {
    ACCOUNT_SETTINGS: function ACCOUNT_SETTINGS(_ref31) {
      var myUhcBaseUrl = _ref31.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/account/profile.html");
    },
    HELP: function HELP(_ref32) {
      var myUhcBaseUrl = _ref32.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/contact-us/overview.html");
    },
    MESSAGES: function MESSAGES(_ref33) {
      var myUhcBaseUrl = _ref33.myUhcBaseUrl;
      return "".concat(myUhcBaseUrl, "/member/contact-us/overview.html");
    }
  }
}, baseLinks);
var csLinks = mergeDeep({
  FOOTER: {
    FACEBOOK: function FACEBOOK() {
      return 'https://www.facebook.com/UnitedHealthcareCommunityPlan';
    },
    LEGAL_NOTICES: function LEGAL_NOTICES() {
      return 'https://www.uhc.com/legal';
    }
  },
  HEADER: {
    SECURE_CLAIMS_ACCOUNT: function SECURE_CLAIMS_ACCOUNT(_ref34) {
      var myUhcBaseUrl = _ref34.myUhcBaseUrl,
          language = _ref34.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/communityplan/claims-account/claims-summary.html");
    },
    SECURE_BENEFITS_COVERAGE: function SECURE_BENEFITS_COVERAGE(_ref35) {
      var myUhcBaseUrl = _ref35.myUhcBaseUrl,
          language = _ref35.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/communityplan/benefits-coverage.html");
    },
    SECURE_PHARMACIES_PRESCRIPTIONS: function SECURE_PHARMACIES_PRESCRIPTIONS(_ref36) {
      var myUhcBaseUrl = _ref36.myUhcBaseUrl,
          language = _ref36.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/communityplan/rx.html");
    },
    HEALTH: function HEALTH(_ref37) {
      var myUhcBaseUrl = _ref37.myUhcBaseUrl,
          language = _ref37.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/communityplan/health-wellness.html");
    },
    RECOMMENDATION: function RECOMMENDATION(_ref38) {
      var myUhcBaseUrl = _ref38.myUhcBaseUrl,
          language = _ref38.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/communityplan/recommended-care.html");
    }
  },
  SHARED: {
    ACCOUNT_SETTINGS: function ACCOUNT_SETTINGS(_ref39) {
      var myUhcBaseUrl = _ref39.myUhcBaseUrl,
          language = _ref39.language;
      return "".concat(myUhcBaseUrl, "/content/myuhc/").concat(language, "/secure/communityplan/account-profile.html");
    }
  }
}, baseLinks);
var links = (_links = {}, _defineProperty(_links, LineOfBusiness.EI, baseLinks), _defineProperty(_links, LineOfBusiness.MR, mrLinks), _defineProperty(_links, LineOfBusiness.CS, csLinks), _links);

var getUrl = function getUrl(linkConfiguration, _ref) {
  var lineOfBusiness = _ref.lineOfBusiness,
      products = _ref.products,
      baseUrls = _ref.baseUrls,
      locale = _ref.locale;
  var dependentProducts = linkConfiguration.dependentProducts;

  if (dependentProducts && !dependentProducts.every(function (p) {
    var target = products[p];
    return !!(target && target.productId);
  })) {
    return null;
  }

  var linkProps = _objectSpread({
    resources: links[lineOfBusiness],
    baseUrls: baseUrls,
    language: locale && locale.split('-')[0],
    id: locale
  }, baseUrls);

  var resource = linkConfiguration.getLink(linkProps);

  if (resource) {
    return resource(linkProps);
  } else {
    return '#';
  }
};

var ProductContext = React__default.createContext({
  products: {}
});
var ProductProvider = ProductContext.Provider,
    ProductConsumer = ProductContext.Consumer;

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function warn() {
  if (console && console.warn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
    console.warn.apply(null, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function deprecated() {
  if (process && process.env && (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')) {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    if (typeof args[0] === 'string') args[0] = "deprecation warning -> ".concat(args[0]);
    warnOnce.apply(void 0, args);
  }
}
var initializedLanguageOnce = false;
var initializedStoreOnce = false;
function initSSR(props, setIsInitialSSR) {
  // nextjs / SSR: getting data from next.js or other ssr stack
  if (!initializedStoreOnce && props.initialI18nStore) {
    props.i18n.services.resourceStore.data = props.initialI18nStore;
    if (setIsInitialSSR) props.i18n.options.isInitialSSR = true;
    if (props.i18nOptions) props.i18nOptions.wait = false; // we got all passed down already

    initializedStoreOnce = true;
  }

  if (!initializedLanguageOnce && props.initialLanguage) {
    props.i18n.changeLanguage(props.initialLanguage);
    initializedLanguageOnce = true;
  }
} // --------------

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose$1;

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties$1;

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty$1;

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread$1;

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck$1;

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass$1;

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized$1;

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn$1;

var getPrototypeOf = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

var setPrototypeOf = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits = _inherits$1;

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment$$1 = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment$$1;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}
});

unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf$1(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty$1(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false,
  omitBoundRerender: true,
  transEmptyNodeValue: ''
};
var i18nInstance;
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = objectSpread({}, defaultOptions, options);
}
function getDefaults() {
  return defaultOptions;
}
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var reactI18nextModule = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
var I18nContext = React__default.createContext(); // hoc for context

function withContext() {
  return function Wrapper(WrappedComponent) {
    var WithContext =
    /*#__PURE__*/
    function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        classCallCheck(this, WithContext);

        return possibleConstructorReturn(this, getPrototypeOf(WithContext).apply(this, arguments));
      }

      createClass(WithContext, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              innerRef = _this$props.innerRef,
              rest = objectWithoutProperties(_this$props, ["innerRef"]);

          if (innerRef) rest.ref = innerRef;
          return React__default.createElement(I18nContext.Consumer, null, function (ctx) {
            return React__default.createElement(WrappedComponent, objectSpread({}, ctx, rest));
          });
        }
      }]);

      return WithContext;
    }(Component);

    return WithContext;
  };
}

function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}
/* eslint-disable react/no-multi-comp */


function withI18n() {
  return function Wrapper(WrappedComponent) {
    var WithMergedOptions =
    /*#__PURE__*/
    function (_Component2) {
      inherits(WithMergedOptions, _Component2);

      function WithMergedOptions() {
        classCallCheck(this, WithMergedOptions);

        return possibleConstructorReturn(this, getPrototypeOf(WithMergedOptions).apply(this, arguments));
      }

      createClass(WithMergedOptions, [{
        key: "render",
        value: function render() {
          var _this = this;

          var _this$props2 = this.props,
              innerRef = _this$props2.innerRef,
              rest = objectWithoutProperties(_this$props2, ["innerRef"]);

          if (innerRef) rest.ref = innerRef; // merged extra props

          var extraProps = {};
          var i18nOptions = this.props.i18nOptions || this.i18nOptions; // as default we add i18n, basic t function and i18nOptions from setI18n
          // those get overridden by values passed by I18nContext.Provider <- eg. set in I18nextProvider

          var i18n = this.props.i18n || getI18n();

          if (!i18nOptions) {
            var possibleI18nOptionsFromProps = Object.keys(defaultOptions).reduce(function (mem, k) {
              if (_this.props[k]) mem[k] = _this.props[k];
              return mem;
            }, {});
            i18nOptions = objectSpread({}, getDefaults(), i18n && i18n.options && i18n.options.react, possibleI18nOptionsFromProps);
            this.i18nOptions = i18nOptions;
          }

          if (i18n) {
            extraProps.i18n = i18n;
            extraProps.t = i18n.t.bind(i18n);
            extraProps.lng = i18n.language;
            extraProps.i18nOptions = i18nOptions;
          }

          return React__default.createElement(WrappedComponent, objectSpread({}, extraProps, rest));
        }
      }]);

      return WithMergedOptions;
    }(Component);

    var WithMergedOptionsWithContext = withContext()(WithMergedOptions);
    WithMergedOptionsWithContext.WrappedComponent = WrappedComponent;
    WithMergedOptionsWithContext.displayName = "WithMergedOptions(".concat(getDisplayName(WrappedComponent), ")");
    return hoistNonReactStatics_cjs(WithMergedOptionsWithContext, WrappedComponent);
  };
}

var removedIsInitialSSR = false;
var NamespacesConsumerComponent =
/*#__PURE__*/
function (_Component) {
  inherits(NamespacesConsumerComponent, _Component);

  function NamespacesConsumerComponent(props) {
    var _this;

    classCallCheck(this, NamespacesConsumerComponent);

    _this = possibleConstructorReturn(this, getPrototypeOf(NamespacesConsumerComponent).call(this, props));

    if (!props.i18n) {
      _this.state = {
        i18nLoadedAt: null,
        ready: false
      };
      return possibleConstructorReturn(_this, warnOnce('You will need pass in an i18next instance either by props, using I18nextProvider or by using i18nextReactModule. Learn more https://react.i18next.com/components/overview#getting-the-i-18-n-function-into-the-flow'));
    }

    if (typeof props.i18n.then === 'function') {
      _this.state = {
        i18nLoadedAt: null,
        ready: false
      };
      return possibleConstructorReturn(_this, warnOnce('Detected a promise instead of an i18next instance. Probably you passed the return value of the i18next.init() function, this is not possible anymore with v13 of i18next. Just pass in the i18next instance directly.'));
    } // nextjs / SSR: getting data from next.js or other ssr stack


    initSSR(props); // provider SSR: data was set in provider and ssr flag was set

    if (props.i18n.options && props.i18n.options.isInitialSSR) {
      props.i18nOptions.wait = false;
    } // reportNS if needed for SSR


    var namespaces = _this.getNamespaces();

    if (props.reportNS) {
      namespaces.forEach(props.reportNS);
    } // check if we could flag this ready already as all is loaded


    var language = props.i18n.languages && props.i18n.languages[0];
    var ready = !!language && namespaces.every(function (ns) {
      return props.i18n.hasResourceBundle(language, ns);
    });
    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };
    _this.t = _this.getI18nTranslate();
    _this.onI18nChanged = _this.onI18nChanged.bind(assertThisInitialized(assertThisInitialized(_this)));
    _this.getI18nTranslate = _this.getI18nTranslate.bind(assertThisInitialized(assertThisInitialized(_this)));
    _this.namespaces = _this.getNamespaces.bind(assertThisInitialized(assertThisInitialized(_this)));
    return _this;
  }

  createClass(NamespacesConsumerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadNamespaces();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Note that dynamically loading additional namespaces after the initial mount will not block rendering – even if the `wait` option is true.
      if (this.props.ns && prevProps.ns !== this.props.ns) this.loadNamespaces();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      var _this$props = this.props,
          i18n = _this$props.i18n,
          i18nOptions = _this$props.i18nOptions;
      this.mounted = false;

      if (this.onI18nChanged) {
        if (i18nOptions.bindI18n) {
          var p = i18nOptions.bindI18n.split(' ');
          p.forEach(function (f) {
            return i18n.off(f, _this2.onI18nChanged);
          });
        }

        if (i18nOptions.bindStore) {
          var _p = i18nOptions.bindStore.split(' ');

          _p.forEach(function (f) {
            return i18n.store && i18n.store.off(f, _this2.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: "onI18nChanged",
    value: function onI18nChanged() {
      var i18nOptions = this.props.i18nOptions;
      var ready = this.state.ready;
      if (!this.mounted) return;
      if (!ready && i18nOptions.omitBoundRerender) return;
      this.t = this.getI18nTranslate();
      this.setState({
        i18nLoadedAt: new Date()
      }); // rerender
    }
  }, {
    key: "getI18nTranslate",
    value: function getI18nTranslate() {
      var _this$props2 = this.props,
          i18n = _this$props2.i18n,
          i18nOptions = _this$props2.i18nOptions;
      var namespaces = this.getNamespaces();
      return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces && namespaces.length ? namespaces[0] : 'translation');
    }
  }, {
    key: "getNamespaces",
    value: function getNamespaces() {
      var _this$props3 = this.props,
          i18n = _this$props3.i18n,
          ns = _this$props3.ns,
          defaultNS = _this$props3.defaultNS;
      var namespaces = typeof ns === 'function' ? ns(this.props) : ns || defaultNS || i18n.options && i18n.options.defaultNS;
      return typeof namespaces === 'string' ? [namespaces] : namespaces || [];
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces$$1() {
      var _this3 = this;

      var _this$props4 = this.props,
          i18n = _this$props4.i18n,
          i18nOptions = _this$props4.i18nOptions;
      var ready = this.state.ready;

      var bind = function bind() {
        if (i18nOptions.bindI18n && i18n) i18n.on(i18nOptions.bindI18n, _this3.onI18nChanged);
        if (i18nOptions.bindStore && i18n.store) i18n.store.on(i18nOptions.bindStore, _this3.onI18nChanged);
      };

      this.mounted = true;
      i18n.loadNamespaces(this.getNamespaces(), function () {
        var handleReady = function handleReady() {
          if (_this3.mounted && !ready) {
            _this3.setState({
              ready: true
            }, function () {
              if (!i18nOptions.wait) _this3.onI18nChanged();
            });
          }

          if (i18nOptions.wait && _this3.mounted) bind();
        };

        if (i18n.isInitialized) {
          handleReady();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              i18n.off('initialized', initialized);
            }, 1000);
            handleReady();
          };

          i18n.on('initialized', initialized);
        }
      });
      if (!i18nOptions.wait) bind();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          i18n = _this$props5.i18n,
          defaultNS = _this$props5.defaultNS,
          reportNS = _this$props5.reportNS,
          i18nOptions = _this$props5.i18nOptions;

      var _ref = this.state || {
        ready: false
      },
          ready = _ref.ready; // fallback if state is null...unknown edge case https://github.com/i18next/react-i18next/issues/615


      var t = this.t;
      if (!ready && i18nOptions.wait) return null; // remove ssr flag set by provider - first render was done from now on wait if set to wait

      if (i18n.options && i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete i18n.options.isInitialSSR;
        }, 100);
      }

      return React__default.createElement(I18nContext.Provider, {
        value: {
          i18n: i18n,
          t: t,
          defaultNS: defaultNS,
          reportNS: reportNS,
          lng: i18n && i18n.language
        }
      }, children(this.t, {
        i18n: i18n,
        t: t,
        lng: i18n.language,
        ready: ready
      }));
    }
  }]);

  return NamespacesConsumerComponent;
}(Component);
var NamespacesConsumer = withI18n()(NamespacesConsumerComponent);

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

var voidElements = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;


var parseTag = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key=match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key=undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;

// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if ((!ignoreWhitespace && end > -1 && level + list.length >= 0) || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

var parse = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== ('</' + current.name + '>')) {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
    case 'text':
        return buff + doc.content;
    case 'tag':
        buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
        if (doc.voidElement) {
            return buff;
        }
        return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

var stringify_1 = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};

var htmlParseStringify2 = {
    parse: parse,
    stringify: stringify_1
};

function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];
  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = "".concat(i);

    if (typeof child === 'string') {
      mem = "".concat(mem).concat(child);
    } else if (hasChildren(child)) {
      mem = "".concat(mem, "<").concat(elementKey, ">").concat(nodesToString('', getChildren(child), i + 1), "</").concat(elementKey, ">");
    } else if (React__default.isValidElement(child)) {
      mem = "".concat(mem, "<").concat(elementKey, "></").concat(elementKey, ">");
    } else if (_typeof_1(child) === 'object') {
      var clone = objectSpread({}, child);

      var format = clone.format;
      delete clone.format;
      var keys = Object.keys(clone);

      if (format && keys.length === 1) {
        mem = "".concat(mem, "{{").concat(keys[0], ", ").concat(format, "}}");
      } else if (keys.length === 1) {
        mem = "".concat(mem, "{{").concat(keys[0], "}}");
      } else {
        // not a valid interpolation object (can only contain one value plus format)
        warn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === '') return [];
  if (!children) return [targetString]; // v2 -> interpolates upfront no need for "some <0>{{var}}</0>"" -> will be just "some {{var}}" in translation file

  var data = {};

  function getData(childs) {
    if (Object.prototype.toString.call(childs) !== '[object Array]') childs = [childs];
    childs.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (_typeof_1(child) === 'object' && !React__default.isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  targetString = i18n.services.interpolator.interpolate(targetString, data, i18n.language); // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes

  var ast = htmlParseStringify2.parse("<0>".concat(targetString, "</0>"));

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];
    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = React__default.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!

          mem.push(React__default.cloneElement(child, objectSpread({}, child.props, {
            key: i
          }), inner));
        } else if (_typeof_1(child) === 'object' && !isElement) {
          var content = node.children[0] ? node.children[0].content : null; // v1
          // as interpolation was done already we just have a regular content node
          // in the translation AST while having an object in reactNodes
          // -> push the content no need to interpolate again

          if (content) mem.push(content);
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }

      return mem;
    }, []);
  } // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result


  var result = mapAST([{
    dummy: true,
    children: children
  }], ast);
  return getChildren(result[0]);
}

var TransComponent =
/*#__PURE__*/
function (_React$Component) {
  inherits(TransComponent, _React$Component);

  function TransComponent() {
    classCallCheck(this, TransComponent);

    return possibleConstructorReturn(this, getPrototypeOf(TransComponent).apply(this, arguments));
  }

  createClass(TransComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          count = _this$props.count,
          parent = _this$props.parent,
          i18nKey = _this$props.i18nKey,
          tOptions = _this$props.tOptions,
          values = _this$props.values,
          defaults = _this$props.defaults,
          components = _this$props.components,
          namespace = _this$props.ns,
          i18n = _this$props.i18n,
          tFromContextAndProps = _this$props.t,
          defaultNS = _this$props.defaultNS,
          reportNS = _this$props.reportNS,
          lng = _this$props.lng,
          i18nOptions = _this$props.i18nOptions,
          additionalProps = objectWithoutProperties(_this$props, ["children", "count", "parent", "i18nKey", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "defaultNS", "reportNS", "lng", "i18nOptions"]);

      var t = tFromContextAndProps || i18n.t.bind(i18n);
      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
      var defaultValue = defaults || nodesToString('', children, 0) || reactI18nextOptions.transEmptyNodeValue;
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var interpolationOverride = values ? {} : {
        interpolation: {
          prefix: '#$?',
          suffix: '?$#'
        }
      };
      var translation = key ? t(key, objectSpread({}, tOptions, values, interpolationOverride, {
        defaultValue: defaultValue,
        count: count,
        ns: namespace
      })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];

        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }

        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({
          ns: ns
        });
      }

      if (!useAsParent) return renderNodes(components || children, translation, i18n);
      return React__default.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n));
    }
  }]);

  return TransComponent;
}(React__default.Component);
var Trans = withI18n()(TransComponent);

var I18nextProvider =
/*#__PURE__*/
function (_Component) {
  inherits(I18nextProvider, _Component);

  function I18nextProvider(props) {
    var _this;

    classCallCheck(this, I18nextProvider);

    _this = possibleConstructorReturn(this, getPrototypeOf(I18nextProvider).call(this, props)); // nextjs / SSR: getting data from next.js or other ssr stack

    initSSR(props, true);
    return _this;
  }

  createClass(I18nextProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          i18n = _this$props.i18n,
          defaultNS = _this$props.defaultNS,
          reportNS = _this$props.reportNS;
      return React__default.createElement(I18nContext.Provider, {
        value: {
          i18n: i18n,
          defaultNS: defaultNS,
          reportNS: reportNS,
          lng: i18n && i18n.language,
          t: i18n && i18n.t.bind(i18n)
        }
      }, children);
    }
  }]);

  return I18nextProvider;
}(Component);

var InterpolateComponent =
/*#__PURE__*/
function (_Component) {
  inherits(InterpolateComponent, _Component);

  function InterpolateComponent(props) {
    var _this;

    classCallCheck(this, InterpolateComponent);

    _this = possibleConstructorReturn(this, getPrototypeOf(InterpolateComponent).call(this, props));
    deprecated('Interpolate is deprecated and will be removed in the next major version (v9.0.0). Usage can be replaced by the "Trans" component');
    return _this;
  }

  createClass(InterpolateComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          i18n = _this$props.i18n,
          t = _this$props.t,
          i18nKey = _this$props.i18nKey,
          options = _this$props.options,
          className = _this$props.className,
          style = _this$props.style;
      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || i18n.services.interpolator.regexp; // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = objectSpread({}, {}, options, {
        interpolation: {
          prefix: '#$?',
          suffix: '?$#'
        }
      });

      var format = t(i18nKey, tOpts);
      if (!format || typeof format !== 'string') return React__default.createElement('noscript', null);
      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) i18n.services.logger.warn("interpolator: missed to pass in variable ".concat(key, " for interpolating ").concat(format));
          return props[key];
        }

        var p = key.split(i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(i18n.options.interpolation.formatSeparator).trim();
        if (props[k] === undefined) i18n.services.logger.warn("interpolator: missed to pass in variable ".concat(k, " for interpolating ").concat(format));
        return i18n.options.interpolation.format(props[k], f, i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;

          if (useDangerouslySetInnerHTML) {
            child = React__default.createElement(dangerouslySetInnerHTMLPartElement, {
              dangerouslySetInnerHTML: {
                __html: match
              }
            });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);
      var additionalProps = {};

      if (i18n.options.react && i18n.options.react.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];

        if (i18nKey && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }

        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({
          ns: ns
        });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;
      return React__default.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return InterpolateComponent;
}(Component);
var Interpolate = withI18n()(InterpolateComponent);

var urlSearchParams_node = createCommonjsModule(function (module) {

function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else if (query.forEach) {
      query.forEach(addEach, dict);
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function addEach(value, key) {
  /* jshint validthis:true */
  appendTo(this, key, value);
}

function appendTo(dict, name, value) {
  var res = isArray(value) ? value.join(',') : value;
  if (name in dict)
    dict[name].push(res);
  else
    dict[name] = [res];
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = commonjsGlobal.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));
});

var FTR_MEMBER_SUPPORT = "Member Support";
var FTR_SUPPORT = "Support";
var FTR_IMPORTANT_INFO = "Important Information";
var FTR_HELP = "Help & Contact Us";
var FTR_NURSE_CHAT = "Ask a Nurse: Chat Now";
var FTR_NURSE_CHAT_WITH_PHONE = "Ask a Nurse: <a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">Chat Now</a>";
var FTR_NURSE_LINE = "Ask a Nurse: <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK = "Share Feedback";
var FTR_MEMBER_INFO = "Member Information";
var FTR_PROVIDER_DATA_INFO = "Provider Data Information";
var FTR_LEGAL_ENTITIES = "Legal Entities";
var FTR_QUICK_LINKS = "Quick Links";
var FTR_RIGHTS = "All rights reserved.";
var FTR_ABOUT_RALLY = "About Rally";
var FTR_ABOUT_UNITED = "About UnitedHealthcare";
var FTR_TERMS = "Terms of Use";
var FTR_PRIVACY = "Privacy Policy";
var FTR_NOTICES = "Notices & Disclosures";
var FTR_LEGAL_NOTICES = "Legal Notices & Disclosures";
var FTR_UPDATED = "Last Updated: {{date}} at {{time}} CT";
var FTR_UPDATED_MEDICAL = "Medical information last updated: {{date}}";
var FTR_UPDATED_MENTAL = "Mental Health information last updated: {{date}}";
var FTR_INFO_UPDATED = "Information last Updated {{date}} at {{time}} CT";
var FTR_MADE_BY = "Made by";
var FTR_ACCESSIBILITY = "Accessibility";
var FTR_ACCESSIBILITY_STATEMENT = "Accessibility Statement";
var FTR_LANGUAGE_ENG = "Language Assistance | Non-Discrimination Notice";
var FTR_LANGUAGE_SPA = "Asistencia de Idiomas | Aviso de no Discriminación";
var FTR_LANGUAGE_CHI = "語言協助 | 不歧視通知";
var FTR_FOLLOW_US = "Follow Us";
var FTR_FACEBOOK = "Facebook";
var FTR_BACK_TO_TOP = "Back to top";
var FTR_MATERIAL_ID = "Marketing Material ID # {{materialId}}";
var FTR_PROVIDER_DIRECTORY = "Print / Email Provider Directory";
var enusFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT,
	FTR_SUPPORT: FTR_SUPPORT,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO,
	FTR_HELP: FTR_HELP,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE,
	FTR_NURSE_LINE: FTR_NURSE_LINE,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS,
	FTR_RIGHTS: FTR_RIGHTS,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED,
	FTR_TERMS: FTR_TERMS,
	FTR_PRIVACY: FTR_PRIVACY,
	FTR_NOTICES: FTR_NOTICES,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES,
	FTR_UPDATED: FTR_UPDATED,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED,
	FTR_MADE_BY: FTR_MADE_BY,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI,
	FTR_FOLLOW_US: FTR_FOLLOW_US,
	FTR_FACEBOOK: FTR_FACEBOOK,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY
};

var ACCOUNT_PROFILE_LEGACY = "Account Profile";
var ACCOUNT_PROFILE = "Account / Profile";
var ACCOUNT_SETTINGS = "Account Settings";
var CLAIMS_AND_ACCOUNTS = "Claims & Accounts";
var CLOSE_NAVIGATION_MENU = "Close Navigation Menu";
var COVERAGE = "Coverage & Benefits";
var FIND_CARE_COST = "Find Care & Costs";
var FIND_CARE = "Find Care";
var HEALTH_CHECKLIST = "Health Checklist";
var HEALTH_RECORD = "Health Record";
var HEALTH_RESOURCES = "Health Resources";
var HEALTH_WELLNESS = "Health & Wellness";
var HEALTH = "Health & Wellness";
var HELP = "Help";
var HOME = "Home";
var LOGOUT = "Logout";
var MESSAGES = "Messages";
var OPEN_NAVIGATION_MENU = "Open Navigation Menu";
var PHARMACIES = "Pharmacies & Prescriptions";
var PREMIUM_PAYMENTS = "Premium Payments";
var RETURN_HOME = "Return to the homepage";
var REWARDS = "Rewards";
var SKIP_TO_MAIN_CONTENT = "Skip to main content";
var enusHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU,
	COVERAGE: COVERAGE,
	FIND_CARE_COST: FIND_CARE_COST,
	FIND_CARE: FIND_CARE,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST,
	HEALTH_RECORD: HEALTH_RECORD,
	HEALTH_RESOURCES: HEALTH_RESOURCES,
	HEALTH_WELLNESS: HEALTH_WELLNESS,
	HEALTH: HEALTH,
	HELP: HELP,
	HOME: HOME,
	LOGOUT: LOGOUT,
	MESSAGES: MESSAGES,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU,
	PHARMACIES: PHARMACIES,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS,
	RETURN_HOME: RETURN_HOME,
	REWARDS: REWARDS,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT
};

var AMOUNT_BILLED = "Amount Billed";
var ALLOWED_AMOUNT = "Allowed Amount";
var AMOUNT_NOT_COVERED = "Amount Not Covered";
var AMOUNT_OF_TOTAL = "{{amount}} of {{total}}";
var AS_OF_DATE = "As of {{date}}";
var BEHAVIORAL_HEALTH = "Mental Health & Substance Use";
var CANCEL = "Cancel";
var CLAIM_NUM = "Claim #";
var CLAIM_STATUS = "Claim Status";
var CLAIM_TYPE = "Claim Type";
var CLAIMS = "Claims";
var CLICK_HERE = "Click Here";
var COPAY = "Copay";
var COVERAGE_ENDED = "Coverage Ended:";
var COVERAGE_STARTS = "Coverage Starts:";
var DCSA = "Dependent Care Spending Account";
var DENIED = "Denied";
var DENTAL = "Dental";
var DEPENDENT = "Dependent";
var DETAILS = "Details";
var DOB = "DOB";
var DOMESTIC_PARTNER = "Domestic Partner";
var DRUG_LOOKUP = "Drug Lookup";
var EDIT = "Edit";
var EXTERNAL_LINK_MESSAGE = "*Selecting these links will route you to an external site.";
var FIND_DOCTOR = "Find a doctor";
var FIND_EMERGENCY_ROOM = "Find an emergency room";
var FIND_PROVIDER = "Find a Provider";
var FIND_SPECIALIST = "Find a specialist";
var FIND_URGENT_CARE = "Find an urgent care facility";
var FROM = "From";
var GO_BACK = "Go back to the previous page";
var GO_BACK_MODAL = "Go back to previous content";
var HCSA = "Healthcare Spending Account";
var HEALTH_PLAN_DISCOUNT = "Health Plan Discount";
var HRA_PAID_TO_YOU = "HRA Paid To You";
var I_UNDERSTAND = "I understand";
var IN_NETWORK = "In-network";
var IN_PROCESS = "In Process";
var LOADING = "Loading";
var MARK_AS_PAID = "Mark as Paid";
var MEDICAL = "Medical";
var MRA = "Medical Reimbursement Account";
var NAME = "Name";
var NEXT = "Next";
var NEXT_PAGE = "Next Page";
var NOT_MARKED_AS_PAID = "Not Marked As Paid";
var OPENS_IN_NEW_WINDOW = "[Opens in a new window]";
var OTHER = "Other";
var OUT_OF_NETWORK = "Out-of-network";
var PAGE_OF = "Page {{current}} of {{total}}";
var PAGINATION = "Pagination";
var PATIENT_NAME = "Patient Name";
var PATIENT_RESPONSIBILITY = "Patient Responsibility";
var PATIENTS_CLAIM_DOS = "{{patient}}'s Claim Date of Service";
var PAY_NOW = "Pay Now";
var PHARMACY = "Pharmacy";
var PHARMACY_LOCATOR = "Pharmacy Locator";
var PLAN_DISCOUNT = "Plan Discount";
var PLAN_PAID = "Plan Paid";
var PREVIOUS = "Previous";
var PREVIOUS_PAGE = "Previous Page";
var PRINT_SUMMARY = "Print Summary";
var PROCESSED = "Processed";
var PROVIDED_SERVICE = "Provided Service";
var PROVIDER = "Provider";
var RECOMMENDATIONS = "Recommendations";
var RETIREE = "Retiree";
var RX = "Rx";
var SAVE = "Save";
var SAVED = "Saved";
var SPOUSE = "Spouse";
var STATUS = "Status";
var SUBMIT_CLAIM = "Submit a Claim";
var SUBSCRIBER = "Subscriber";
var TIER_ONE = "Tier 1";
var TO = "To";
var TYPE_COVERAGE_ENDED = "{{type}} Coverage Ended:";
var TYPE_COVERAGE_STARTS = "{{type}} Coverage Starts:";
var UNKNOWN_PROVIDER = "Unknown Provider";
var VIEW_ALL_CLAIMS = "View all claims";
var VIEW_DISCOUNTS_AND_SERVICES = "View Discounts & Services";
var VIEW_EXPLANATION_BENEFITS = "View Explanation of Benefits";
var VISION = "Vision";
var WATCH_A_VIDEO_EXPLANATION = "Watch a Video Explanation";
var YOU_MAY_OWE = "You May Owe";
var YOU_PAID = "You Paid";
var enusCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL,
	AS_OF_DATE: AS_OF_DATE,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH,
	CANCEL: CANCEL,
	CLAIM_NUM: CLAIM_NUM,
	CLAIM_STATUS: CLAIM_STATUS,
	CLAIM_TYPE: CLAIM_TYPE,
	CLAIMS: CLAIMS,
	CLICK_HERE: CLICK_HERE,
	COPAY: COPAY,
	COVERAGE_ENDED: COVERAGE_ENDED,
	COVERAGE_STARTS: COVERAGE_STARTS,
	DCSA: DCSA,
	DENIED: DENIED,
	DENTAL: DENTAL,
	DEPENDENT: DEPENDENT,
	DETAILS: DETAILS,
	DOB: DOB,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER,
	DRUG_LOOKUP: DRUG_LOOKUP,
	EDIT: EDIT,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE,
	FIND_DOCTOR: FIND_DOCTOR,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM,
	FIND_PROVIDER: FIND_PROVIDER,
	FIND_SPECIALIST: FIND_SPECIALIST,
	FIND_URGENT_CARE: FIND_URGENT_CARE,
	FROM: FROM,
	GO_BACK: GO_BACK,
	GO_BACK_MODAL: GO_BACK_MODAL,
	HCSA: HCSA,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU,
	I_UNDERSTAND: I_UNDERSTAND,
	IN_NETWORK: IN_NETWORK,
	IN_PROCESS: IN_PROCESS,
	LOADING: LOADING,
	MARK_AS_PAID: MARK_AS_PAID,
	MEDICAL: MEDICAL,
	MRA: MRA,
	NAME: NAME,
	NEXT: NEXT,
	NEXT_PAGE: NEXT_PAGE,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW,
	OTHER: OTHER,
	OUT_OF_NETWORK: OUT_OF_NETWORK,
	PAGE_OF: PAGE_OF,
	PAGINATION: PAGINATION,
	PATIENT_NAME: PATIENT_NAME,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS,
	PAY_NOW: PAY_NOW,
	PHARMACY: PHARMACY,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR,
	PLAN_DISCOUNT: PLAN_DISCOUNT,
	PLAN_PAID: PLAN_PAID,
	PREVIOUS: PREVIOUS,
	PREVIOUS_PAGE: PREVIOUS_PAGE,
	PRINT_SUMMARY: PRINT_SUMMARY,
	PROCESSED: PROCESSED,
	PROVIDED_SERVICE: PROVIDED_SERVICE,
	PROVIDER: PROVIDER,
	RECOMMENDATIONS: RECOMMENDATIONS,
	RETIREE: RETIREE,
	RX: RX,
	SAVE: SAVE,
	SAVED: SAVED,
	SPOUSE: SPOUSE,
	STATUS: STATUS,
	SUBMIT_CLAIM: SUBMIT_CLAIM,
	SUBSCRIBER: SUBSCRIBER,
	TIER_ONE: TIER_ONE,
	TO: TO,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS,
	VISION: VISION,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION,
	YOU_MAY_OWE: YOU_MAY_OWE,
	YOU_PAID: YOU_PAID
};

var FTR_MEMBER_SUPPORT$1 = "Apoyo a los miembros";
var FTR_SUPPORT$1 = "Ayuda";
var FTR_IMPORTANT_INFO$1 = "Información importante";
var FTR_HELP$1 = "Ayuda y contacto";
var FTR_NURSE_CHAT$1 = "Consulte a un enfermero: chatee ahora";
var FTR_NURSE_CHAT_WITH_PHONE$1 = "Preguntar a una enfermera: <a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">Chatee ahora</a>";
var FTR_NURSE_LINE$1 = "Preguntar a una enfermera: <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK$1 = "Compartir opinión";
var FTR_MEMBER_INFO$1 = "Información del miembro";
var FTR_PROVIDER_DATA_INFO$1 = "Información sobre el proveedor";
var FTR_LEGAL_ENTITIES$1 = "Entidades legales";
var FTR_QUICK_LINKS$1 = "Enlaces rápidos";
var FTR_RIGHTS$1 = "Todos los derechos reservados.";
var FTR_ABOUT_RALLY$1 = "Sobre Rally";
var FTR_ABOUT_UNITED$1 = "Acerca de UnitedHealthcare";
var FTR_TERMS$1 = "Términos de uso";
var FTR_PRIVACY$1 = "Políticas de privacidad";
var FTR_NOTICES$1 = "Notificaciones y avisos legales";
var FTR_LEGAL_NOTICES$1 = "Divulgaciones y avisos legales";
var FTR_UPDATED$1 = "Última actualización: {{date}} a las {{time}} CT";
var FTR_UPDATED_MEDICAL$1 = "Última actualización de la información médica el: {{date}}";
var FTR_UPDATED_MENTAL$1 = "Última actualización de la información de salud mental el: {{date}}";
var FTR_INFO_UPDATED$1 = "La información se actualizó por última vez el {{date}} a las {{time}} CT.";
var FTR_MADE_BY$1 = "Hecho por";
var FTR_ACCESSIBILITY$1 = "Accesibilidad";
var FTR_ACCESSIBILITY_STATEMENT$1 = "Declaración de accesibilidad";
var FTR_LANGUAGE_ENG$1 = "Language Assistance | Non-Discrimination Notice";
var FTR_LANGUAGE_SPA$1 = "Asistencia con el idioma | Aviso de no discriminación";
var FTR_LANGUAGE_CHI$1 = "語言協助 | 不歧視通知";
var FTR_FOLLOW_US$1 = "Síguenos";
var FTR_FACEBOOK$1 = "Facebook";
var FTR_BACK_TO_TOP$1 = "Volver al principio";
var FTR_MATERIAL_ID$1 = "Material de marketing Nro. {{materialId}}";
var FTR_PROVIDER_DIRECTORY$1 = "Imprimir/Directorio de correo electrónico de los proveedores";
var esusFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT$1,
	FTR_SUPPORT: FTR_SUPPORT$1,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO$1,
	FTR_HELP: FTR_HELP$1,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT$1,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE$1,
	FTR_NURSE_LINE: FTR_NURSE_LINE$1,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK$1,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO$1,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO$1,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES$1,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS$1,
	FTR_RIGHTS: FTR_RIGHTS$1,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY$1,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED$1,
	FTR_TERMS: FTR_TERMS$1,
	FTR_PRIVACY: FTR_PRIVACY$1,
	FTR_NOTICES: FTR_NOTICES$1,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES$1,
	FTR_UPDATED: FTR_UPDATED$1,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL$1,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL$1,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED$1,
	FTR_MADE_BY: FTR_MADE_BY$1,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY$1,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT$1,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG$1,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA$1,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI$1,
	FTR_FOLLOW_US: FTR_FOLLOW_US$1,
	FTR_FACEBOOK: FTR_FACEBOOK$1,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP$1,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID$1,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY$1
};

var ACCOUNT_PROFILE_LEGACY$1 = "Perfil de cuenta";
var ACCOUNT_PROFILE$1 = "Cuenta/Perfil";
var ACCOUNT_SETTINGS$1 = "Configuraciones de cuenta";
var CLAIMS_AND_ACCOUNTS$1 = "Reclamos y cuentas";
var CLOSE_NAVIGATION_MENU$1 = "Cierra el menú de navegación";
var COVERAGE$1 = "Cobertura y beneficios";
var FIND_CARE_COST$1 = "Buscar atención y costos";
var FIND_CARE$1 = "Encontrar servicio";
var HEALTH_CHECKLIST$1 = "Lista de verificación de salud";
var HEALTH_RECORD$1 = "Historial médico";
var HEALTH_RESOURCES$1 = "Recursos de salud";
var HEALTH_WELLNESS$1 = "Salud y bienestar";
var HEALTH$1 = "Salud y bienestar";
var HELP$1 = "Ayuda";
var HOME$1 = "Inicio";
var LOGOUT$1 = "Cerrar sesión";
var MESSAGES$1 = "Mensajes";
var OPEN_NAVIGATION_MENU$1 = "Abre el menú de navegación";
var PHARMACIES$1 = "Farmacias y recetas médicas";
var PREMIUM_PAYMENTS$1 = "Pagos premium";
var RETURN_HOME$1 = "Volver a la página de inicio";
var REWARDS$1 = "Recompensas";
var SKIP_TO_MAIN_CONTENT$1 = "Ir al contenido principal";
var esusHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY$1,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE$1,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS$1,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS$1,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU$1,
	COVERAGE: COVERAGE$1,
	FIND_CARE_COST: FIND_CARE_COST$1,
	FIND_CARE: FIND_CARE$1,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST$1,
	HEALTH_RECORD: HEALTH_RECORD$1,
	HEALTH_RESOURCES: HEALTH_RESOURCES$1,
	HEALTH_WELLNESS: HEALTH_WELLNESS$1,
	HEALTH: HEALTH$1,
	HELP: HELP$1,
	HOME: HOME$1,
	LOGOUT: LOGOUT$1,
	MESSAGES: MESSAGES$1,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU$1,
	PHARMACIES: PHARMACIES$1,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS$1,
	RETURN_HOME: RETURN_HOME$1,
	REWARDS: REWARDS$1,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT$1
};

var AMOUNT_BILLED$1 = "Cantidad facturada";
var ALLOWED_AMOUNT$1 = "Monto autorizado";
var AMOUNT_NOT_COVERED$1 = "Monto no cubierto";
var AMOUNT_OF_TOTAL$1 = "{{amount}} de {{total}}";
var AS_OF_DATE$1 = "Al día {{date}}.";
var BEHAVIORAL_HEALTH$1 = "Salud mental y abuso de sustancias";
var CANCEL$1 = "Cancelar";
var CLAIM_NUM$1 = "# de solicitud";
var CLAIM_STATUS$1 = "Estado de la solicitud";
var CLAIM_TYPE$1 = "Tipo de solicitud";
var CLAIMS$1 = "Solicitudes";
var CLICK_HERE$1 = "Haga clic aquí";
var COPAY$1 = "Copago";
var COVERAGE_ENDED$1 = "La cobertura terminó:";
var COVERAGE_STARTS$1 = "La cobertura empieza:";
var DCSA$1 = "Cuenta de gastos para atención de dependientes";
var DENIED$1 = "Denegado";
var DENTAL$1 = "Dental";
var DEPENDENT$1 = "Dependiente";
var DETAILS$1 = "Detalles";
var DOB$1 = "Fecha de nacimiento";
var DOMESTIC_PARTNER$1 = "Pareja de hecho";
var DRUG_LOOKUP$1 = "Búsqueda de medicamento";
var EDIT$1 = "Editar";
var EXTERNAL_LINK_MESSAGE$1 = "*La selección de estos enlaces lo llevará a un sitio externo.";
var FIND_DOCTOR$1 = "Buscar un médico";
var FIND_EMERGENCY_ROOM$1 = "Buscar una sala de emergencias";
var FIND_PROVIDER$1 = "Encontar un proveedor";
var FIND_SPECIALIST$1 = "Buscar un especialista";
var FIND_URGENT_CARE$1 = "Encontrar un centro de atención de emergencia";
var FROM$1 = "De";
var GO_BACK$1 = "Volver a la página anterior";
var GO_BACK_MODAL$1 = "Volver al contenido anterior";
var HCSA$1 = "Cuenta de gastos de atención médica";
var HEALTH_PLAN_DISCOUNT$1 = "Descuento del plan de salud";
var HRA_PAID_TO_YOU$1 = "Pago de HRA que recibes";
var I_UNDERSTAND$1 = "Entiendo";
var IN_NETWORK$1 = "Dentro de la red";
var IN_PROCESS$1 = "En proceso";
var LOADING$1 = "Cargando";
var MARK_AS_PAID$1 = "Marcar como pagado";
var MEDICAL$1 = "Médico";
var MRA$1 = "Cuenta de reembolso médico";
var NAME$1 = "Nombre";
var NEXT$1 = "Siguiente";
var NEXT_PAGE$1 = "Página siguiente";
var NOT_MARKED_AS_PAID$1 = "No marcado como pagado";
var OPENS_IN_NEW_WINDOW$1 = "[Opens in a new window]";
var OTHER$1 = "Otro";
var OUT_OF_NETWORK$1 = "Fuera de la red";
var PAGE_OF$1 = "Página {{current}} de {{total}}";
var PAGINATION$1 = "Paginación";
var PATIENT_NAME$1 = "Nombre del paciente";
var PATIENT_RESPONSIBILITY$1 = "Responsabilidad del paciente";
var PATIENTS_CLAIM_DOS$1 = "Fecha de solicitud del servicio de {{patient}}";
var PAY_NOW$1 = "Pagar ahora";
var PHARMACY$1 = "Farmacia";
var PHARMACY_LOCATOR$1 = "Localizador de farmacia";
var PLAN_DISCOUNT$1 = "Descuento del plan";
var PLAN_PAID$1 = "Plan pagado";
var PREVIOUS$1 = "Anterior";
var PREVIOUS_PAGE$1 = "Página anterior";
var PRINT_SUMMARY$1 = "Imprimir resumen";
var PROCESSED$1 = "Procesado";
var PROVIDED_SERVICE$1 = "Servicio prestado";
var PROVIDER$1 = "Proveedor";
var RECOMMENDATIONS$1 = "Recomendaciones";
var RETIREE$1 = "Jubilado";
var RX$1 = "Rx";
var SAVE$1 = "Guardar";
var SAVED$1 = "Guardado";
var SPOUSE$1 = "Cónyuge";
var STATUS$1 = "Estado";
var SUBMIT_CLAIM$1 = "Enviar una solicitud";
var SUBSCRIBER$1 = "Suscriptor";
var TIER_ONE$1 = "Nivel 1";
var TO$1 = "Hasta";
var TYPE_COVERAGE_ENDED$1 = "La cobertura {{type}} finaliza el:";
var TYPE_COVERAGE_STARTS$1 = "La cobertura {{type}} comienza el:";
var UNKNOWN_PROVIDER$1 = "Proveedor desconocido";
var VIEW_ALL_CLAIMS$1 = "Ver todas las solicitudes";
var VIEW_DISCOUNTS_AND_SERVICES$1 = "Ver descuentos y servicios";
var VIEW_EXPLANATION_BENEFITS$1 = "Ver la explicación de los beneficios";
var VISION$1 = "Visión";
var WATCH_A_VIDEO_EXPLANATION$1 = "Mirar un video explicativo";
var YOU_MAY_OWE$1 = "Puede que tengas una deuda";
var YOU_PAID$1 = "Has pagado";
var esusCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED$1,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT$1,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED$1,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL$1,
	AS_OF_DATE: AS_OF_DATE$1,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH$1,
	CANCEL: CANCEL$1,
	CLAIM_NUM: CLAIM_NUM$1,
	CLAIM_STATUS: CLAIM_STATUS$1,
	CLAIM_TYPE: CLAIM_TYPE$1,
	CLAIMS: CLAIMS$1,
	CLICK_HERE: CLICK_HERE$1,
	COPAY: COPAY$1,
	COVERAGE_ENDED: COVERAGE_ENDED$1,
	COVERAGE_STARTS: COVERAGE_STARTS$1,
	DCSA: DCSA$1,
	DENIED: DENIED$1,
	DENTAL: DENTAL$1,
	DEPENDENT: DEPENDENT$1,
	DETAILS: DETAILS$1,
	DOB: DOB$1,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER$1,
	DRUG_LOOKUP: DRUG_LOOKUP$1,
	EDIT: EDIT$1,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE$1,
	FIND_DOCTOR: FIND_DOCTOR$1,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM$1,
	FIND_PROVIDER: FIND_PROVIDER$1,
	FIND_SPECIALIST: FIND_SPECIALIST$1,
	FIND_URGENT_CARE: FIND_URGENT_CARE$1,
	FROM: FROM$1,
	GO_BACK: GO_BACK$1,
	GO_BACK_MODAL: GO_BACK_MODAL$1,
	HCSA: HCSA$1,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT$1,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU$1,
	I_UNDERSTAND: I_UNDERSTAND$1,
	IN_NETWORK: IN_NETWORK$1,
	IN_PROCESS: IN_PROCESS$1,
	LOADING: LOADING$1,
	MARK_AS_PAID: MARK_AS_PAID$1,
	MEDICAL: MEDICAL$1,
	MRA: MRA$1,
	NAME: NAME$1,
	NEXT: NEXT$1,
	NEXT_PAGE: NEXT_PAGE$1,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID$1,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW$1,
	OTHER: OTHER$1,
	OUT_OF_NETWORK: OUT_OF_NETWORK$1,
	PAGE_OF: PAGE_OF$1,
	PAGINATION: PAGINATION$1,
	PATIENT_NAME: PATIENT_NAME$1,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY$1,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS$1,
	PAY_NOW: PAY_NOW$1,
	PHARMACY: PHARMACY$1,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR$1,
	PLAN_DISCOUNT: PLAN_DISCOUNT$1,
	PLAN_PAID: PLAN_PAID$1,
	PREVIOUS: PREVIOUS$1,
	PREVIOUS_PAGE: PREVIOUS_PAGE$1,
	PRINT_SUMMARY: PRINT_SUMMARY$1,
	PROCESSED: PROCESSED$1,
	PROVIDED_SERVICE: PROVIDED_SERVICE$1,
	PROVIDER: PROVIDER$1,
	RECOMMENDATIONS: RECOMMENDATIONS$1,
	RETIREE: RETIREE$1,
	RX: RX$1,
	SAVE: SAVE$1,
	SAVED: SAVED$1,
	SPOUSE: SPOUSE$1,
	STATUS: STATUS$1,
	SUBMIT_CLAIM: SUBMIT_CLAIM$1,
	SUBSCRIBER: SUBSCRIBER$1,
	TIER_ONE: TIER_ONE$1,
	TO: TO$1,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED$1,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS$1,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER$1,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS$1,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES$1,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS$1,
	VISION: VISION$1,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION$1,
	YOU_MAY_OWE: YOU_MAY_OWE$1,
	YOU_PAID: YOU_PAID$1
};

var FTR_MEMBER_SUPPORT$2 = "Sipò Manm";
var FTR_SUPPORT$2 = "Sipò";
var FTR_IMPORTANT_INFO$2 = "Enfòmasyon Enpòtan";
var FTR_HELP$2 = "Èd ak Kontakte nou";
var FTR_NURSE_CHAT$2 = "Mande Yon Enfimyè: Diskite avèk nou kounye a";
var FTR_NURSE_CHAT_WITH_PHONE$2 = "Mande Yon Enfimyè: <a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">Diskite avèk nou kounye a</a>";
var FTR_NURSE_LINE$2 = "Mande Yon Enfimyè: <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK$2 = "Pataje opinyon w";
var FTR_MEMBER_INFO$2 = "Enfòmasyon sou Manm";
var FTR_PROVIDER_DATA_INFO$2 = "Enfòmasyon Done Pwofesyonèl Swen Sante";
var FTR_LEGAL_ENTITIES$2 = "Antite Legal yo";
var FTR_QUICK_LINKS$2 = "Lyen Dirèk";
var FTR_RIGHTS$2 = "Tout dwa rezève.";
var FTR_ABOUT_RALLY$2 = "Konsènan Rally";
var FTR_ABOUT_UNITED$2 = "Konsènan UnitedHealthcare";
var FTR_TERMS$2 = "Tèm Itilizasyon";
var FTR_PRIVACY$2 = "Règleman Enfòmasyon Prive";
var FTR_NOTICES$2 = "Avi legal yo ak Piblikasyon yo";
var FTR_LEGAL_NOTICES$2 = "Avi legalak ak Piblikasyon yo";
var FTR_UPDATED$2 = "Last Updated: {{date}} at {{time}} CT";
var FTR_UPDATED_MEDICAL$2 = "Medical information last updated: {{date}}";
var FTR_UPDATED_MENTAL$2 = "Mental Health information last updated: {{date}}";
var FTR_INFO_UPDATED$2 = "Dènye Mizajou Enfòmasyon {{date}} nan {{time}} CT";
var FTR_MADE_BY$2 = "Moun ki fè li a";
var FTR_ACCESSIBILITY$2 = "Fasilite Aksè";
var FTR_ACCESSIBILITY_STATEMENT$2 = "Deklarasyon sou Aksè Fasil";
var FTR_LANGUAGE_ENG$2 = "Asistans nan lang | Avi Anti-Diskriminasyon";
var FTR_LANGUAGE_SPA$2 = "Asistencia de Idiomas | Aviso de no Discriminación";
var FTR_LANGUAGE_CHI$2 = "語言協助 | 不歧視通知";
var FTR_FOLLOW_US$2 = "Swiv Nou";
var FTR_FACEBOOK$2 = "Facebook";
var FTR_BACK_TO_TOP$2 = "Back to top";
var FTR_MATERIAL_ID$2 = "Marketing Material ID # {{materialId}}";
var FTR_PROVIDER_DIRECTORY$2 = "Print / Email Provider Directory";
var hthtFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT$2,
	FTR_SUPPORT: FTR_SUPPORT$2,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO$2,
	FTR_HELP: FTR_HELP$2,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT$2,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE$2,
	FTR_NURSE_LINE: FTR_NURSE_LINE$2,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK$2,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO$2,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO$2,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES$2,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS$2,
	FTR_RIGHTS: FTR_RIGHTS$2,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY$2,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED$2,
	FTR_TERMS: FTR_TERMS$2,
	FTR_PRIVACY: FTR_PRIVACY$2,
	FTR_NOTICES: FTR_NOTICES$2,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES$2,
	FTR_UPDATED: FTR_UPDATED$2,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL$2,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL$2,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED$2,
	FTR_MADE_BY: FTR_MADE_BY$2,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY$2,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT$2,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG$2,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA$2,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI$2,
	FTR_FOLLOW_US: FTR_FOLLOW_US$2,
	FTR_FACEBOOK: FTR_FACEBOOK$2,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP$2,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID$2,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY$2
};

var ACCOUNT_PROFILE_LEGACY$2 = "Pwofil Kont";
var ACCOUNT_PROFILE$2 = "Kont / Profil";
var ACCOUNT_SETTINGS$2 = "Paramèt Kont";
var CLAIMS_AND_ACCOUNTS$2 = "Reklamasyon ak Kont";
var CLOSE_NAVIGATION_MENU$2 = "Fèmen Meni Navigasyon";
var COVERAGE$2 = "Asirans ak Benefis";
var FIND_CARE_COST$2 = "Jwenn Swen ak Depans";
var FIND_CARE$2 = "Jwenn Swen";
var HEALTH_CHECKLIST$2 = "Lis Kontwòl Sante";
var HEALTH_RECORD$2 = "Health Record";
var HEALTH_RESOURCES$2 = "Resous Medikal yo";
var HEALTH_WELLNESS$2 = "Sante ak Byennèt";
var HEALTH$2 = "Sante ak Byennèt";
var HELP$2 = "Èd";
var HOME$2 = "Paj Akèy";
var LOGOUT$2 = "Dekonekte";
var MESSAGES$2 = "Mesaj";
var OPEN_NAVIGATION_MENU$2 = "Ouvri Meni Navigasyon";
var PHARMACIES$2 = "Famasi ak Preskripsyon";
var PREMIUM_PAYMENTS$2 = "Peman Premyòm yo";
var RETURN_HOME$2 = "Retounen sou paj akèy la";
var REWARDS$2 = "Rekonpans";
var SKIP_TO_MAIN_CONTENT$2 = "Sote kontni prensipal la";
var hthtHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY$2,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE$2,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS$2,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS$2,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU$2,
	COVERAGE: COVERAGE$2,
	FIND_CARE_COST: FIND_CARE_COST$2,
	FIND_CARE: FIND_CARE$2,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST$2,
	HEALTH_RECORD: HEALTH_RECORD$2,
	HEALTH_RESOURCES: HEALTH_RESOURCES$2,
	HEALTH_WELLNESS: HEALTH_WELLNESS$2,
	HEALTH: HEALTH$2,
	HELP: HELP$2,
	HOME: HOME$2,
	LOGOUT: LOGOUT$2,
	MESSAGES: MESSAGES$2,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU$2,
	PHARMACIES: PHARMACIES$2,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS$2,
	RETURN_HOME: RETURN_HOME$2,
	REWARDS: REWARDS$2,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT$2
};

var AMOUNT_BILLED$2 = "Montan yo Faktire";
var ALLOWED_AMOUNT$2 = "Montan Aksepte";
var AMOUNT_NOT_COVERED$2 = "Montan pa Kouvri";
var AMOUNT_OF_TOTAL$2 = "{{amount}} nan {{total}}";
var AS_OF_DATE$2 = "Apati {{date}}";
var BEHAVIORAL_HEALTH$2 = "Sante Mantal ak Itilizasyon Estipefyan";
var CANCEL$2 = "Anile";
var CLAIM_NUM$2 = "# Reklamasyon";
var CLAIM_STATUS$2 = "Kondisyon Reklamasyon an";
var CLAIM_TYPE$2 = "Tip Reklamasyon";
var CLAIMS$2 = "Reklamasyon yo";
var CLICK_HERE$2 = "Klike La a";
var COPAY$2 = "Ko-peman";
var COVERAGE_ENDED$2 = "Pwoteksyon an Fini:";
var COVERAGE_STARTS$2 = "Pwoteksyon an Kòmanse:";
var DCSA$2 = "Kont pou Ranbousman pou Swen Depandan";
var DENIED$2 = "Refize";
var DENTAL$2 = "Dantè";
var DEPENDENT$2 = "Depandan";
var DETAILS$2 = "Detay yo";
var DOB$2 = "Dat Nesans";
var DOMESTIC_PARTNER$2 = "Patnè ou ap viv avèk li a";
var DRUG_LOOKUP$2 = "Chèche Medikaman";
var EDIT$2 = "Korije";
var EXTERNAL_LINK_MESSAGE$2 = "*Seleksyone lyen sa yo y ap mete w sou yon wout sit ekstèn.";
var FIND_DOCTOR$2 = "Jwenn yon Doktè";
var FIND_EMERGENCY_ROOM$2 = "Jwenn yon sal ijans";
var FIND_PROVIDER$2 = "Jwenn yon Founisè";
var FIND_SPECIALIST$2 = "Jwenn yon Espesyalis";
var FIND_URGENT_CARE$2 = "Jwenn yon lopital swen ijan";
var FROM$2 = "Soti nan";
var GO_BACK$2 = "Retounen nan paj avan an";
var GO_BACK_MODAL$2 = "Retounen Ale nan Kontni pase a";
var HCSA$2 = "Kont Depans Swen Sante";
var HEALTH_PLAN_DISCOUNT$2 = "Diskont Plan Sante";
var HRA_PAID_TO_YOU$2 = "HRA Paid To You";
var I_UNDERSTAND$2 = "Mwen konprann";
var IN_NETWORK$2 = "Ki nan rezo a";
var IN_PROCESS$2 = "Ap Trete";
var LOADING$2 = "Chajman";
var MARK_AS_PAID$2 = "Make kòm Peye";
var MEDICAL$2 = "Medikal";
var MRA$2 = "Kont Ranbousman Medikal";
var NAME$2 = "Non";
var NEXT$2 = "Swivan";
var NEXT_PAGE$2 = "Pwochen Paj";
var NOT_MARKED_AS_PAID$2 = "Pa t Make Kòm Peye";
var OPENS_IN_NEW_WINDOW$2 = "[Louvri na yon lòt fenèt.]";
var OTHER$2 = "Lòt";
var OUT_OF_NETWORK$2 = "Ki deyò rezo a";
var PAGE_OF$2 = "Paj {{current}} nan {{total}}";
var PAGINATION$2 = "Kantite paj";
var PATIENT_NAME$2 = "Non Pasyan an";
var PATIENT_RESPONSIBILITY$2 = "Responsablite Pasyan";
var PATIENTS_CLAIM_DOS$2 = "{{patient}}Dat Reklamasyon Sèvis la";
var PAY_NOW$2 = "Peye Kounye a";
var PHARMACY$2 = "Famasi";
var PHARMACY_LOCATOR$2 = "Lokalizatè Famasi";
var PLAN_DISCOUNT$2 = "Diskont Plan";
var PLAN_PAID$2 = "Plan Peye";
var PREVIOUS$2 = "Anvan";
var PREVIOUS_PAGE$2 = "Paj Anvan";
var PRINT_SUMMARY$2 = "Enprime Rezime";
var PROCESSED$2 = "Ki trete deja";
var PROVIDED_SERVICE$2 = "Sèvis Ou Jwen";
var PROVIDER$2 = "Founisè";
var RECOMMENDATIONS$2 = "Rekòmandasyon";
var RETIREE$2 = "Retrete";
var RX$2 = "Rx";
var SAVE$2 = "Sovgade";
var SAVED$2 = "Li te Sovgade";
var SPOUSE$2 = "Patnè w";
var STATUS$2 = "Sitiyasyon";
var SUBMIT_CLAIM$2 = "Soumèt yon Reklamasyon";
var SUBSCRIBER$2 = "Abòne";
var TIER_ONE$2 = "Nivo 1";
var TO$2 = "Pou";
var TYPE_COVERAGE_ENDED$2 = "{{type}} Pwoteksyon an Fini:";
var TYPE_COVERAGE_STARTS$2 = "{{type}} Pwoteksyon an Kòmanse:";
var UNKNOWN_PROVIDER$2 = "Doktè Enkoni";
var VIEW_ALL_CLAIMS$2 = "Gade tout reklamasyon yo";
var VIEW_DISCOUNTS_AND_SERVICES$2 = "Gade Diskont yo ak Sèvis";
var VIEW_EXPLANATION_BENEFITS$2 = "Gade Eksplikasyon Avantaj yo";
var VISION$2 = "Vizyon";
var WATCH_A_VIDEO_EXPLANATION$2 = "Gade yon Videyo Eksplikasyon";
var YOU_MAY_OWE$2 = "Ou Ka Dwe";
var YOU_PAID$2 = "Ou te peye";
var hthtCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED$2,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT$2,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED$2,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL$2,
	AS_OF_DATE: AS_OF_DATE$2,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH$2,
	CANCEL: CANCEL$2,
	CLAIM_NUM: CLAIM_NUM$2,
	CLAIM_STATUS: CLAIM_STATUS$2,
	CLAIM_TYPE: CLAIM_TYPE$2,
	CLAIMS: CLAIMS$2,
	CLICK_HERE: CLICK_HERE$2,
	COPAY: COPAY$2,
	COVERAGE_ENDED: COVERAGE_ENDED$2,
	COVERAGE_STARTS: COVERAGE_STARTS$2,
	DCSA: DCSA$2,
	DENIED: DENIED$2,
	DENTAL: DENTAL$2,
	DEPENDENT: DEPENDENT$2,
	DETAILS: DETAILS$2,
	DOB: DOB$2,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER$2,
	DRUG_LOOKUP: DRUG_LOOKUP$2,
	EDIT: EDIT$2,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE$2,
	FIND_DOCTOR: FIND_DOCTOR$2,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM$2,
	FIND_PROVIDER: FIND_PROVIDER$2,
	FIND_SPECIALIST: FIND_SPECIALIST$2,
	FIND_URGENT_CARE: FIND_URGENT_CARE$2,
	FROM: FROM$2,
	GO_BACK: GO_BACK$2,
	GO_BACK_MODAL: GO_BACK_MODAL$2,
	HCSA: HCSA$2,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT$2,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU$2,
	I_UNDERSTAND: I_UNDERSTAND$2,
	IN_NETWORK: IN_NETWORK$2,
	IN_PROCESS: IN_PROCESS$2,
	LOADING: LOADING$2,
	MARK_AS_PAID: MARK_AS_PAID$2,
	MEDICAL: MEDICAL$2,
	MRA: MRA$2,
	NAME: NAME$2,
	NEXT: NEXT$2,
	NEXT_PAGE: NEXT_PAGE$2,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID$2,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW$2,
	OTHER: OTHER$2,
	OUT_OF_NETWORK: OUT_OF_NETWORK$2,
	PAGE_OF: PAGE_OF$2,
	PAGINATION: PAGINATION$2,
	PATIENT_NAME: PATIENT_NAME$2,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY$2,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS$2,
	PAY_NOW: PAY_NOW$2,
	PHARMACY: PHARMACY$2,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR$2,
	PLAN_DISCOUNT: PLAN_DISCOUNT$2,
	PLAN_PAID: PLAN_PAID$2,
	PREVIOUS: PREVIOUS$2,
	PREVIOUS_PAGE: PREVIOUS_PAGE$2,
	PRINT_SUMMARY: PRINT_SUMMARY$2,
	PROCESSED: PROCESSED$2,
	PROVIDED_SERVICE: PROVIDED_SERVICE$2,
	PROVIDER: PROVIDER$2,
	RECOMMENDATIONS: RECOMMENDATIONS$2,
	RETIREE: RETIREE$2,
	RX: RX$2,
	SAVE: SAVE$2,
	SAVED: SAVED$2,
	SPOUSE: SPOUSE$2,
	STATUS: STATUS$2,
	SUBMIT_CLAIM: SUBMIT_CLAIM$2,
	SUBSCRIBER: SUBSCRIBER$2,
	TIER_ONE: TIER_ONE$2,
	TO: TO$2,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED$2,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS$2,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER$2,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS$2,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES$2,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS$2,
	VISION: VISION$2,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION$2,
	YOU_MAY_OWE: YOU_MAY_OWE$2,
	YOU_PAID: YOU_PAID$2
};

var FTR_MEMBER_SUPPORT$3 = "Suporta ti Miyembro";
var FTR_SUPPORT$3 = "Suporta";
var FTR_IMPORTANT_INFO$3 = "Importante nga Impormasyon";
var FTR_HELP$3 = "Tulong ken Kontakendakami";
var FTR_NURSE_CHAT$3 = "Saludsoden ti Nars: Maki-Chat Tattan";
var FTR_NURSE_CHAT_WITH_PHONE$3 = "Saludsoden ti Nars: <a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">Maki-Chat Tattan</a>";
var FTR_NURSE_LINE$3 = "Saludsoden ti Nars: <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK$3 = "Ibingay ti Kumento";
var FTR_MEMBER_INFO$3 = "Impormasyon ti Miyembro";
var FTR_PROVIDER_DATA_INFO$3 = "Impormasyon ti Datos ti Provider";
var FTR_LEGAL_ENTITIES$3 = "Dagiti Legal Nga Entidad";
var FTR_QUICK_LINKS$3 = "Dagiti Nadaras a Link";
var FTR_RIGHTS$3 = "Amin a kalintegan ket nakareserba.";
var FTR_ABOUT_RALLY$3 = "Maipapan iti Rally";
var FTR_ABOUT_UNITED$3 = "Maipapan iti UnitedHealthcare";
var FTR_TERMS$3 = "Dagiti Pagalagadan ti Panagusar";
var FTR_PRIVACY$3 = "Polisiya iti Kinapribado";
var FTR_NOTICES$3 = "Dagiti Pakaammo ken Palawag";
var FTR_LEGAL_NOTICES$3 = "Dagiti Legal a Pakaammo ken Palawag";
var FTR_UPDATED$3 = "Last Updated: {{date}} at {{time}} CT";
var FTR_UPDATED_MEDICAL$3 = "Medical information last updated: {{date}}";
var FTR_UPDATED_MENTAL$3 = "Mental Health information last updated: {{date}}";
var FTR_INFO_UPDATED$3 = "Naudi a Pannakapabaro ti Impormasyon {{date}} iti {{time}} CT";
var FTR_MADE_BY$3 = "Inaramid ti";
var FTR_ACCESSIBILITY$3 = "Kinalaka a Maala";
var FTR_ACCESSIBILITY_STATEMENT$3 = "Palawag ti Aksesibilidad";
var FTR_LANGUAGE_ENG$3 = "Tulong iti Pagsasao | Pakaammo ti Saan-a-Panangidumduma";
var FTR_LANGUAGE_SPA$3 = "Asistencia de Idiomas | Aviso de no Discriminación";
var FTR_LANGUAGE_CHI$3 = "語言協助 | 不歧視通知";
var FTR_FOLLOW_US$3 = "Suruten Dakami";
var FTR_FACEBOOK$3 = "Facebook";
var FTR_BACK_TO_TOP$3 = "Back to top";
var FTR_MATERIAL_ID$3 = "Marketing Material ID # {{materialId}}";
var FTR_PROVIDER_DIRECTORY$3 = "Print / Email Provider Directory";
var ilphFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT$3,
	FTR_SUPPORT: FTR_SUPPORT$3,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO$3,
	FTR_HELP: FTR_HELP$3,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT$3,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE$3,
	FTR_NURSE_LINE: FTR_NURSE_LINE$3,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK$3,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO$3,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO$3,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES$3,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS$3,
	FTR_RIGHTS: FTR_RIGHTS$3,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY$3,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED$3,
	FTR_TERMS: FTR_TERMS$3,
	FTR_PRIVACY: FTR_PRIVACY$3,
	FTR_NOTICES: FTR_NOTICES$3,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES$3,
	FTR_UPDATED: FTR_UPDATED$3,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL$3,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL$3,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED$3,
	FTR_MADE_BY: FTR_MADE_BY$3,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY$3,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT$3,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG$3,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA$3,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI$3,
	FTR_FOLLOW_US: FTR_FOLLOW_US$3,
	FTR_FACEBOOK: FTR_FACEBOOK$3,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP$3,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID$3,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY$3
};

var ACCOUNT_PROFILE_LEGACY$3 = "Account Profile";
var ACCOUNT_PROFILE$3 = "Account / Profile";
var ACCOUNT_SETTINGS$3 = "Account Settings";
var CLAIMS_AND_ACCOUNTS$3 = "Dagiti Panagtunton ken Account";
var CLOSE_NAVIGATION_MENU$3 = "Iserra ti Navigation Menu";
var COVERAGE$3 = "Dagiti Masakupan ken Benepisyo";
var FIND_CARE_COST$3 = "Agsapul iti Taripato ken kadagiti Gastos";
var FIND_CARE$3 = "Mangsapul iti Taripato";
var HEALTH_CHECKLIST$3 = "Listaan para iti Salun-at";
var HEALTH_RECORD$3 = "Health Record";
var HEALTH_RESOURCES$3 = "Dagiti Pagtaudan ti Salun-at";
var HEALTH_WELLNESS$3 = "Salun-at ken Kinasaranta";
var HEALTH$3 = "Salun-at ken Kinasaranta";
var HELP$3 = "Tulong";
var HOME$3 = "Pagtaengan";
var LOGOUT$3 = "Ag-logout";
var MESSAGES$3 = "Dagiti Mensahe";
var OPEN_NAVIGATION_MENU$3 = "Lukatan ti Navigation Menu";
var PHARMACIES$3 = "Dagiti Parmasya ken Reseta";
var PREMIUM_PAYMENTS$3 = "Dagiti Premium Payment";
var RETURN_HOME$3 = "Agsubli iday homepage";
var REWARDS$3 = "Dagiti Gungguna";
var SKIP_TO_MAIN_CONTENT$3 = "Labsan ket mapan iti kangrunaan a linaon";
var ilphHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY$3,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE$3,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS$3,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS$3,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU$3,
	COVERAGE: COVERAGE$3,
	FIND_CARE_COST: FIND_CARE_COST$3,
	FIND_CARE: FIND_CARE$3,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST$3,
	HEALTH_RECORD: HEALTH_RECORD$3,
	HEALTH_RESOURCES: HEALTH_RESOURCES$3,
	HEALTH_WELLNESS: HEALTH_WELLNESS$3,
	HEALTH: HEALTH$3,
	HELP: HELP$3,
	HOME: HOME$3,
	LOGOUT: LOGOUT$3,
	MESSAGES: MESSAGES$3,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU$3,
	PHARMACIES: PHARMACIES$3,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS$3,
	RETURN_HOME: RETURN_HOME$3,
	REWARDS: REWARDS$3,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT$3
};

var AMOUNT_BILLED$3 = "Gatad a Mabayadan";
var ALLOWED_AMOUNT$3 = "Maipalubos a Gatad";
var AMOUNT_NOT_COVERED$3 = "Gatad a Saan a Masakupan";
var AMOUNT_OF_TOTAL$3 = "{{amount}} ti {{total}}";
var AS_OF_DATE$3 = "Manipud {{date}}";
var BEHAVIORAL_HEALTH$3 = "Salun-at ti Mental Ken Panagusar iti Substance";
var CANCEL$3 = "Kanselaen";
var CLAIM_NUM$3 = "Panagtunton #";
var CLAIM_STATUS$3 = "Kasasaad ti Panagtunton";
var CLAIM_TYPE$3 = "Tipo ti Panagtunton";
var CLAIMS$3 = "Dagiti Panagtunton";
var CLICK_HERE$3 = "Pinduten Ditoy";
var COPAY$3 = "Copay";
var COVERAGE_ENDED$3 = "Nagpatinggaan ti Masakupan:";
var COVERAGE_STARTS$3 = "Pangrugian ti Masakupan:";
var DCSA$3 = "Ti Dependent Care Spending Account";
var DENIED$3 = "Napagkedkedan";
var DENTAL$3 = "Dental";
var DEPENDENT$3 = "Dependent";
var DETAILS$3 = "Dagiti Detalye";
var DOB$3 = "DOB";
var DOMESTIC_PARTNER$3 = "Kadwa iti Balay";
var DRUG_LOOKUP$3 = "Panagsapul iti Agas";
var EDIT$3 = "I-edit";
var EXTERNAL_LINK_MESSAGE$3 = "*Ti panangpili kadagitoy a link ket ipannaka iti ruar a site.";
var FIND_DOCTOR$3 = "Mangsapul iti Doktor";
var FIND_EMERGENCY_ROOM$3 = "Mangsapul iti emergency room";
var FIND_PROVIDER$3 = "Agsapul iti Tagaipaay";
var FIND_SPECIALIST$3 = "Mangsapul iti Espesyalista";
var FIND_URGENT_CARE$3 = "Mangsapul iti pasilidad ti naganat a taripato";
var FROM$3 = "Manipud";
var GO_BACK$3 = "Agsubli iti napalabas a panid";
var GO_BACK_MODAL$3 = "Agsubli iti napalabas a linaonna";
var HCSA$3 = "Ti Healthcare Spending Account";
var HEALTH_PLAN_DISCOUNT$3 = "Diskwento ti Plano ti Salun-at";
var HRA_PAID_TO_YOU$3 = "HRA Paid To You";
var I_UNDERSTAND$3 = "Maawatak";
var IN_NETWORK$3 = "Uneg ti Network";
var IN_PROCESS$3 = "Maprosproseso";
var LOADING$3 = "Aglo-load";
var MARK_AS_PAID$3 = "Markaan a Nabayadanen";
var MEDICAL$3 = "Medikal";
var MRA$3 = "Ti Medikal Reimbursement Account";
var NAME$3 = "Nagan";
var NEXT$3 = "Sumaruno";
var NEXT_PAGE$3 = "Sumaruno a Panid";
var NOT_MARKED_AS_PAID$3 = "Saan a Namarkaan a Nabayadanen";
var OPENS_IN_NEW_WINDOW$3 = "[Aglukat iti baro a window]";
var OTHER$3 = "Dadduma";
var OUT_OF_NETWORK$3 = "Ruar ti Network";
var PAGE_OF$3 = "Panid {{current}} ti {{total}}";
var PAGINATION$3 = "Pagination";
var PATIENT_NAME$3 = "Nagan ti Pasyente";
var PATIENT_RESPONSIBILITY$3 = "Responsibilidad ti Pasyente";
var PATIENTS_CLAIM_DOS$3 = "{{patient}}'s Petsa ti serbisyo ti Panagtunton";
var PAY_NOW$3 = "Agbayad Itan";
var PHARMACY$3 = "Parmasia";
var PHARMACY_LOCATOR$3 = "Panagsapul iti Parmasya";
var PLAN_DISCOUNT$3 = "Diskwento ti Plano";
var PLAN_PAID$3 = "Nabayadan a Plano";
var PREVIOUS$3 = "Napalabas";
var PREVIOUS_PAGE$3 = "Napalabas a Panid";
var PRINT_SUMMARY$3 = "Iprinta ti Summary";
var PROCESSED$3 = "Naproseso";
var PROVIDED_SERVICE$3 = "Naipaay a Serbisyo";
var PROVIDER$3 = "Provider";
var RECOMMENDATIONS$3 = "Dagiti Rekomendasyon";
var RETIREE$3 = "Retirado";
var RX$3 = "Rx";
var SAVE$3 = "I-save";
var SAVED$3 = "Nai-save";
var SPOUSE$3 = "Asawa";
var STATUS$3 = "Kasasaad";
var SUBMIT_CLAIM$3 = "Mangisumite ti Panagtunton";
var SUBSCRIBER$3 = "Subscriber";
var TIER_ONE$3 = "Tier 1";
var TO$3 = "Agingga";
var TYPE_COVERAGE_ENDED$3 = "{{type}} Nagpatinggaan ti Masakupan:";
var TYPE_COVERAGE_STARTS$3 = "{{type}} Pangrugian ti Masakupan:";
var UNKNOWN_PROVIDER$3 = "Saan nga Am-ammo a Provider";
var VIEW_ALL_CLAIMS$3 = "Kitaen amin dagiti panagtunton";
var VIEW_DISCOUNTS_AND_SERVICES$3 = "Kitaen dagiti Diskuwento ken Serbisyo";
var VIEW_EXPLANATION_BENEFITS$3 = "Kitaen ti Pannakailawlawag dagiti Benepisyo";
var VISION$3 = "Panagkita";
var WATCH_A_VIDEO_EXPLANATION$3 = "Buyaen ti Pannakailawlawag a Video";
var YOU_MAY_OWE$3 = "Mabalinka nga Umutang";
var YOU_PAID$3 = "Binayadam";
var ilphCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED$3,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT$3,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED$3,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL$3,
	AS_OF_DATE: AS_OF_DATE$3,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH$3,
	CANCEL: CANCEL$3,
	CLAIM_NUM: CLAIM_NUM$3,
	CLAIM_STATUS: CLAIM_STATUS$3,
	CLAIM_TYPE: CLAIM_TYPE$3,
	CLAIMS: CLAIMS$3,
	CLICK_HERE: CLICK_HERE$3,
	COPAY: COPAY$3,
	COVERAGE_ENDED: COVERAGE_ENDED$3,
	COVERAGE_STARTS: COVERAGE_STARTS$3,
	DCSA: DCSA$3,
	DENIED: DENIED$3,
	DENTAL: DENTAL$3,
	DEPENDENT: DEPENDENT$3,
	DETAILS: DETAILS$3,
	DOB: DOB$3,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER$3,
	DRUG_LOOKUP: DRUG_LOOKUP$3,
	EDIT: EDIT$3,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE$3,
	FIND_DOCTOR: FIND_DOCTOR$3,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM$3,
	FIND_PROVIDER: FIND_PROVIDER$3,
	FIND_SPECIALIST: FIND_SPECIALIST$3,
	FIND_URGENT_CARE: FIND_URGENT_CARE$3,
	FROM: FROM$3,
	GO_BACK: GO_BACK$3,
	GO_BACK_MODAL: GO_BACK_MODAL$3,
	HCSA: HCSA$3,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT$3,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU$3,
	I_UNDERSTAND: I_UNDERSTAND$3,
	IN_NETWORK: IN_NETWORK$3,
	IN_PROCESS: IN_PROCESS$3,
	LOADING: LOADING$3,
	MARK_AS_PAID: MARK_AS_PAID$3,
	MEDICAL: MEDICAL$3,
	MRA: MRA$3,
	NAME: NAME$3,
	NEXT: NEXT$3,
	NEXT_PAGE: NEXT_PAGE$3,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID$3,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW$3,
	OTHER: OTHER$3,
	OUT_OF_NETWORK: OUT_OF_NETWORK$3,
	PAGE_OF: PAGE_OF$3,
	PAGINATION: PAGINATION$3,
	PATIENT_NAME: PATIENT_NAME$3,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY$3,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS$3,
	PAY_NOW: PAY_NOW$3,
	PHARMACY: PHARMACY$3,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR$3,
	PLAN_DISCOUNT: PLAN_DISCOUNT$3,
	PLAN_PAID: PLAN_PAID$3,
	PREVIOUS: PREVIOUS$3,
	PREVIOUS_PAGE: PREVIOUS_PAGE$3,
	PRINT_SUMMARY: PRINT_SUMMARY$3,
	PROCESSED: PROCESSED$3,
	PROVIDED_SERVICE: PROVIDED_SERVICE$3,
	PROVIDER: PROVIDER$3,
	RECOMMENDATIONS: RECOMMENDATIONS$3,
	RETIREE: RETIREE$3,
	RX: RX$3,
	SAVE: SAVE$3,
	SAVED: SAVED$3,
	SPOUSE: SPOUSE$3,
	STATUS: STATUS$3,
	SUBMIT_CLAIM: SUBMIT_CLAIM$3,
	SUBSCRIBER: SUBSCRIBER$3,
	TIER_ONE: TIER_ONE$3,
	TO: TO$3,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED$3,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS$3,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER$3,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS$3,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES$3,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS$3,
	VISION: VISION$3,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION$3,
	YOU_MAY_OWE: YOU_MAY_OWE$3,
	YOU_PAID: YOU_PAID$3
};

var FTR_MEMBER_SUPPORT$4 = "회원 지원";
var FTR_SUPPORT$4 = "지원";
var FTR_IMPORTANT_INFO$4 = "중요한 정보";
var FTR_HELP$4 = "도움말 및 문의하기";
var FTR_NURSE_CHAT$4 = "간호사에게 문의: 채팅 상담";
var FTR_NURSE_CHAT_WITH_PHONE$4 = "간호사에게 문의: <a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">온라인 상담</a>";
var FTR_NURSE_LINE$4 = "간호사에게 문의: <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK$4 = "피드백 공유하기";
var FTR_MEMBER_INFO$4 = "회원 정보";
var FTR_PROVIDER_DATA_INFO$4 = "제공자 데이터 정보";
var FTR_LEGAL_ENTITIES$4 = "법적 주체";
var FTR_QUICK_LINKS$4 = "퀵 링크";
var FTR_RIGHTS$4 = "All rights reserved.";
var FTR_ABOUT_RALLY$4 = "Rally 소개";
var FTR_ABOUT_UNITED$4 = "UnitedHealthcare 소개";
var FTR_TERMS$4 = "이용약관";
var FTR_PRIVACY$4 = "개인정보보호방침";
var FTR_NOTICES$4 = "알림 및 공개정보";
var FTR_LEGAL_NOTICES$4 = "법적 고지 및 공개";
var FTR_UPDATED$4 = "Last Updated: {{date}} at {{time}} CT";
var FTR_UPDATED_MEDICAL$4 = "Medical information last updated: {{date}}";
var FTR_UPDATED_MENTAL$4 = "Mental Health information last updated: {{date}}";
var FTR_INFO_UPDATED$4 = "최근 업데이트 {{date}}, {{time}} CT";
var FTR_MADE_BY$4 = "제작사";
var FTR_ACCESSIBILITY$4 = "접근성";
var FTR_ACCESSIBILITY_STATEMENT$4 = "이용 방법 설명서";
var FTR_LANGUAGE_ENG$4 = "언어 지원 | 비차별 정보 공지";
var FTR_LANGUAGE_SPA$4 = "Asistencia de Idiomas | Aviso de no Discriminación";
var FTR_LANGUAGE_CHI$4 = "語言協助 | 不歧視通知";
var FTR_FOLLOW_US$4 = "소셜 계정 팔로우";
var FTR_FACEBOOK$4 = "Facebook";
var FTR_BACK_TO_TOP$4 = "Back to top";
var FTR_MATERIAL_ID$4 = "Marketing Material ID # {{materialId}}";
var FTR_PROVIDER_DIRECTORY$4 = "Print / Email Provider Directory";
var kousFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT$4,
	FTR_SUPPORT: FTR_SUPPORT$4,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO$4,
	FTR_HELP: FTR_HELP$4,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT$4,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE$4,
	FTR_NURSE_LINE: FTR_NURSE_LINE$4,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK$4,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO$4,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO$4,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES$4,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS$4,
	FTR_RIGHTS: FTR_RIGHTS$4,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY$4,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED$4,
	FTR_TERMS: FTR_TERMS$4,
	FTR_PRIVACY: FTR_PRIVACY$4,
	FTR_NOTICES: FTR_NOTICES$4,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES$4,
	FTR_UPDATED: FTR_UPDATED$4,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL$4,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL$4,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED$4,
	FTR_MADE_BY: FTR_MADE_BY$4,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY$4,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT$4,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG$4,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA$4,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI$4,
	FTR_FOLLOW_US: FTR_FOLLOW_US$4,
	FTR_FACEBOOK: FTR_FACEBOOK$4,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP$4,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID$4,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY$4
};

var ACCOUNT_PROFILE_LEGACY$4 = "계정 프로필";
var ACCOUNT_PROFILE$4 = "계정 / 프로필";
var ACCOUNT_SETTINGS$4 = "계정 설정";
var CLAIMS_AND_ACCOUNTS$4 = "클레임 및 계정";
var CLOSE_NAVIGATION_MENU$4 = "탐색 메뉴 닫기";
var COVERAGE$4 = "보장 범위 및 혜택";
var FIND_CARE_COST$4 = "케어 및 비용 찾기";
var FIND_CARE$4 = "의료 서비스 검색";
var HEALTH_CHECKLIST$4 = "건강 체크리스트";
var HEALTH_RECORD$4 = "Health Record";
var HEALTH_RESOURCES$4 = "의료 자원";
var HEALTH_WELLNESS$4 = "건강 및 웰니스";
var HEALTH$4 = "건강 및 웰니스";
var HELP$4 = "도움말";
var HOME$4 = "홈";
var LOGOUT$4 = "로그아웃";
var MESSAGES$4 = "메시지";
var OPEN_NAVIGATION_MENU$4 = "탐색 메뉴 열기";
var PHARMACIES$4 = "약국 및 처방";
var PREMIUM_PAYMENTS$4 = "보험료 납부";
var RETURN_HOME$4 = "홈페이지로 돌아가기";
var REWARDS$4 = "보상";
var SKIP_TO_MAIN_CONTENT$4 = "주요 콘텐츠로 건너뛰기";
var kousHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY$4,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE$4,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS$4,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS$4,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU$4,
	COVERAGE: COVERAGE$4,
	FIND_CARE_COST: FIND_CARE_COST$4,
	FIND_CARE: FIND_CARE$4,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST$4,
	HEALTH_RECORD: HEALTH_RECORD$4,
	HEALTH_RESOURCES: HEALTH_RESOURCES$4,
	HEALTH_WELLNESS: HEALTH_WELLNESS$4,
	HEALTH: HEALTH$4,
	HELP: HELP$4,
	HOME: HOME$4,
	LOGOUT: LOGOUT$4,
	MESSAGES: MESSAGES$4,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU$4,
	PHARMACIES: PHARMACIES$4,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS$4,
	RETURN_HOME: RETURN_HOME$4,
	REWARDS: REWARDS$4,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT$4
};

var AMOUNT_BILLED$4 = "청구액";
var ALLOWED_AMOUNT$4 = "허용 금액";
var AMOUNT_NOT_COVERED$4 = "보험이 적용되지 않는 금액";
var AMOUNT_OF_TOTAL$4 = "{{amount}} - {{total}}";
var AS_OF_DATE$4 = "기준 시점 {{date}}";
var BEHAVIORAL_HEALTH$4 = "정신 건강 및 마약성 물질 사용";
var CANCEL$4 = "취소";
var CLAIM_NUM$4 = "클레임 번호";
var CLAIM_STATUS$4 = "클레임 상태";
var CLAIM_TYPE$4 = "클레임 유형";
var CLAIMS$4 = "클레임";
var CLICK_HERE$4 = "여기를 클릭하십시오";
var COPAY$4 = "기본 진료비(Copay)";
var COVERAGE_ENDED$4 = "보상 종료일:";
var COVERAGE_STARTS$4 = "보상 시작일:";
var DCSA$4 = "부양 가족 케어 지출 계정";
var DENIED$4 = "거절됨";
var DENTAL$4 = "치과";
var DEPENDENT$4 = "부양가족";
var DETAILS$4 = "자세한 내용";
var DOB$4 = "생년월일";
var DOMESTIC_PARTNER$4 = "동거 파트너";
var DRUG_LOOKUP$4 = "약품 검색";
var EDIT$4 = "수정";
var EXTERNAL_LINK_MESSAGE$4 = "*이 링크를 선택하면 외부 사이트로 연결됩니다.";
var FIND_DOCTOR$4 = "의사 찾기";
var FIND_EMERGENCY_ROOM$4 = "응급실 찾기";
var FIND_PROVIDER$4 = "제공자 찾기";
var FIND_SPECIALIST$4 = "전문의 찾기";
var FIND_URGENT_CARE$4 = "긴급 치료 시설 찾기";
var FROM$4 = "부터";
var GO_BACK$4 = "이전 페이지로 돌아가기";
var GO_BACK_MODAL$4 = "이전 콘텐츠로 돌아가기";
var HCSA$4 = "헬스케어 지출 계정";
var HEALTH_PLAN_DISCOUNT$4 = "건강 플랜 할인";
var HRA_PAID_TO_YOU$4 = "HRA Paid To You";
var I_UNDERSTAND$4 = "본인은 이해합니다.";
var IN_NETWORK$4 = "네트워크 소속";
var IN_PROCESS$4 = "처리 중";
var LOADING$4 = "로딩";
var MARK_AS_PAID$4 = "지불됨으로 표시";
var MEDICAL$4 = "의료";
var MRA$4 = "의료 환급 계정";
var NAME$4 = "이름";
var NEXT$4 = "다음";
var NEXT_PAGE$4 = "다음 페이지";
var NOT_MARKED_AS_PAID$4 = "지불됨으로 표시되지 않음";
var OPENS_IN_NEW_WINDOW$4 = "[새 창 열기]";
var OTHER$4 = "기타";
var OUT_OF_NETWORK$4 = "네트워크 비소속";
var PAGE_OF$4 = "페이지 {{current}} / {{total}}";
var PAGINATION$4 = "페이지 확인";
var PATIENT_NAME$4 = "환자 이름";
var PATIENT_RESPONSIBILITY$4 = "환자 책임";
var PATIENTS_CLAIM_DOS$4 = "{{patient}}의 서비스 클레임 일자";
var PAY_NOW$4 = "지금 지불하기";
var PHARMACY$4 = "약국";
var PHARMACY_LOCATOR$4 = "약국 찾기";
var PLAN_DISCOUNT$4 = "플랜 할인";
var PLAN_PAID$4 = "지불된 플랜";
var PREVIOUS$4 = "이전";
var PREVIOUS_PAGE$4 = "이전 페이지";
var PRINT_SUMMARY$4 = "요약 인쇄";
var PROCESSED$4 = "처리됨";
var PROVIDED_SERVICE$4 = "제공 서비스";
var PROVIDER$4 = "서비스 제공자";
var RECOMMENDATIONS$4 = "권장사항";
var RETIREE$4 = "퇴직자";
var RX$4 = "Rx";
var SAVE$4 = "저장";
var SAVED$4 = "저장됨";
var SPOUSE$4 = "배우자";
var STATUS$4 = "상태";
var SUBMIT_CLAIM$4 = "클레임 제출";
var SUBSCRIBER$4 = "가입자";
var TIER_ONE$4 = "1 단계";
var TO$4 = "까지";
var TYPE_COVERAGE_ENDED$4 = "{{type}} 보상 종료일:";
var TYPE_COVERAGE_STARTS$4 = "{{type}} 보상 시작일:";
var UNKNOWN_PROVIDER$4 = "알려지지 않은 제공자";
var VIEW_ALL_CLAIMS$4 = "모든 클레임 내역 보기";
var VIEW_DISCOUNTS_AND_SERVICES$4 = "할인 및 서비스 보기";
var VIEW_EXPLANATION_BENEFITS$4 = "혜택 설명 보기";
var VISION$4 = "안과";
var WATCH_A_VIDEO_EXPLANATION$4 = "비디오 설명 보기";
var YOU_MAY_OWE$4 = "지불해야 할 금액";
var YOU_PAID$4 = "지불하셨습니다";
var kousCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED$4,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT$4,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED$4,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL$4,
	AS_OF_DATE: AS_OF_DATE$4,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH$4,
	CANCEL: CANCEL$4,
	CLAIM_NUM: CLAIM_NUM$4,
	CLAIM_STATUS: CLAIM_STATUS$4,
	CLAIM_TYPE: CLAIM_TYPE$4,
	CLAIMS: CLAIMS$4,
	CLICK_HERE: CLICK_HERE$4,
	COPAY: COPAY$4,
	COVERAGE_ENDED: COVERAGE_ENDED$4,
	COVERAGE_STARTS: COVERAGE_STARTS$4,
	DCSA: DCSA$4,
	DENIED: DENIED$4,
	DENTAL: DENTAL$4,
	DEPENDENT: DEPENDENT$4,
	DETAILS: DETAILS$4,
	DOB: DOB$4,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER$4,
	DRUG_LOOKUP: DRUG_LOOKUP$4,
	EDIT: EDIT$4,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE$4,
	FIND_DOCTOR: FIND_DOCTOR$4,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM$4,
	FIND_PROVIDER: FIND_PROVIDER$4,
	FIND_SPECIALIST: FIND_SPECIALIST$4,
	FIND_URGENT_CARE: FIND_URGENT_CARE$4,
	FROM: FROM$4,
	GO_BACK: GO_BACK$4,
	GO_BACK_MODAL: GO_BACK_MODAL$4,
	HCSA: HCSA$4,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT$4,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU$4,
	I_UNDERSTAND: I_UNDERSTAND$4,
	IN_NETWORK: IN_NETWORK$4,
	IN_PROCESS: IN_PROCESS$4,
	LOADING: LOADING$4,
	MARK_AS_PAID: MARK_AS_PAID$4,
	MEDICAL: MEDICAL$4,
	MRA: MRA$4,
	NAME: NAME$4,
	NEXT: NEXT$4,
	NEXT_PAGE: NEXT_PAGE$4,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID$4,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW$4,
	OTHER: OTHER$4,
	OUT_OF_NETWORK: OUT_OF_NETWORK$4,
	PAGE_OF: PAGE_OF$4,
	PAGINATION: PAGINATION$4,
	PATIENT_NAME: PATIENT_NAME$4,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY$4,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS$4,
	PAY_NOW: PAY_NOW$4,
	PHARMACY: PHARMACY$4,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR$4,
	PLAN_DISCOUNT: PLAN_DISCOUNT$4,
	PLAN_PAID: PLAN_PAID$4,
	PREVIOUS: PREVIOUS$4,
	PREVIOUS_PAGE: PREVIOUS_PAGE$4,
	PRINT_SUMMARY: PRINT_SUMMARY$4,
	PROCESSED: PROCESSED$4,
	PROVIDED_SERVICE: PROVIDED_SERVICE$4,
	PROVIDER: PROVIDER$4,
	RECOMMENDATIONS: RECOMMENDATIONS$4,
	RETIREE: RETIREE$4,
	RX: RX$4,
	SAVE: SAVE$4,
	SAVED: SAVED$4,
	SPOUSE: SPOUSE$4,
	STATUS: STATUS$4,
	SUBMIT_CLAIM: SUBMIT_CLAIM$4,
	SUBSCRIBER: SUBSCRIBER$4,
	TIER_ONE: TIER_ONE$4,
	TO: TO$4,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED$4,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS$4,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER$4,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS$4,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES$4,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS$4,
	VISION: VISION$4,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION$4,
	YOU_MAY_OWE: YOU_MAY_OWE$4,
	YOU_PAID: YOU_PAID$4
};

var FTR_MEMBER_SUPPORT$5 = "Suporta sa Miyembro";
var FTR_SUPPORT$5 = "Suporta";
var FTR_IMPORTANT_INFO$5 = "Mahalagang Impormasyon";
var FTR_HELP$5 = "Tulong at Makipag-ugnay sa Amin";
var FTR_NURSE_CHAT$5 = "Magtanong sa Nars: Mag-chat Ngayon";
var FTR_NURSE_CHAT_WITH_PHONE$5 = "Magtanong sa Nars: <a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">Mag-chat Ngayon</a>";
var FTR_NURSE_LINE$5 = "Magtanong sa Nars: <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK$5 = "Ibahagi ang Feedback";
var FTR_MEMBER_INFO$5 = "Impormasyon ng Myembro";
var FTR_PROVIDER_DATA_INFO$5 = "Datos ng Impormasyon ng Provider (Tagapagbigay)";
var FTR_LEGAL_ENTITIES$5 = "Mga Legal na Entidad";
var FTR_QUICK_LINKS$5 = "Quick Links";
var FTR_RIGHTS$5 = "All rights reserved.";
var FTR_ABOUT_RALLY$5 = "Tungkol sa Rally";
var FTR_ABOUT_UNITED$5 = "Tungkol sa UnitedHealthcare";
var FTR_TERMS$5 = "Mga Tuntunin ng Paggamit";
var FTR_PRIVACY$5 = "Privacy Policy";
var FTR_NOTICES$5 = "Mga Paunawa at Disclosure";
var FTR_LEGAL_NOTICES$5 = "Maghanap ng Ospital";
var FTR_UPDATED$5 = "Last Updated: {{date}} at {{time}} CT";
var FTR_UPDATED_MEDICAL$5 = "Medical information last updated: {{date}}";
var FTR_UPDATED_MENTAL$5 = "Mental Health information last updated: {{date}}";
var FTR_INFO_UPDATED$5 = "Huling nai-update ang impormasyon noong {{date}} sa {{time}} CT";
var FTR_MADE_BY$5 = "Gawa ng";
var FTR_ACCESSIBILITY$5 = "Accessibility";
var FTR_ACCESSIBILITY_STATEMENT$5 = "Accessibility Statement o Pahayag";
var FTR_LANGUAGE_ENG$5 = "Language Assistance | Non-Discrimination Notice";
var FTR_LANGUAGE_SPA$5 = "Asistencia de Idiomas | Aviso de no Discriminación";
var FTR_LANGUAGE_CHI$5 = "語言協助 | 不歧視通知";
var FTR_FOLLOW_US$5 = "Sundan Kami";
var FTR_FACEBOOK$5 = "Facebook";
var FTR_BACK_TO_TOP$5 = "Back to top";
var FTR_MATERIAL_ID$5 = "Marketing Material ID # {{materialId}}";
var FTR_PROVIDER_DIRECTORY$5 = "Print / Email Provider Directory";
var tlphFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT$5,
	FTR_SUPPORT: FTR_SUPPORT$5,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO$5,
	FTR_HELP: FTR_HELP$5,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT$5,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE$5,
	FTR_NURSE_LINE: FTR_NURSE_LINE$5,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK$5,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO$5,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO$5,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES$5,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS$5,
	FTR_RIGHTS: FTR_RIGHTS$5,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY$5,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED$5,
	FTR_TERMS: FTR_TERMS$5,
	FTR_PRIVACY: FTR_PRIVACY$5,
	FTR_NOTICES: FTR_NOTICES$5,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES$5,
	FTR_UPDATED: FTR_UPDATED$5,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL$5,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL$5,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED$5,
	FTR_MADE_BY: FTR_MADE_BY$5,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY$5,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT$5,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG$5,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA$5,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI$5,
	FTR_FOLLOW_US: FTR_FOLLOW_US$5,
	FTR_FACEBOOK: FTR_FACEBOOK$5,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP$5,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID$5,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY$5
};

var ACCOUNT_PROFILE_LEGACY$5 = "Account Profile";
var ACCOUNT_PROFILE$5 = "Account / Profile";
var ACCOUNT_SETTINGS$5 = "Mga Setting sa Account";
var CLAIMS_AND_ACCOUNTS$5 = "Mga Claim at Account";
var CLOSE_NAVIGATION_MENU$5 = "Isara ang Navigation Menu";
var COVERAGE$5 = "Coverage (Pagsakop) at Mga Benepisyo";
var FIND_CARE_COST$5 = "Maghanap ng Pangangalaga at Halaga ng Babayaran";
var FIND_CARE$5 = "Maghanap ng Pangangalaga";
var HEALTH_CHECKLIST$5 = "Checklist ng Kalusugan";
var HEALTH_RECORD$5 = "Health Record";
var HEALTH_RESOURCES$5 = "Health Resources (Mga Mapagkukunan sa Kalusugan)";
var HEALTH_WELLNESS$5 = "Kalusugan at Wellness";
var HEALTH$5 = "Kalusugan at Wellness";
var HELP$5 = "Tulong";
var HOME$5 = "Home";
var LOGOUT$5 = "Mag-log out";
var MESSAGES$5 = "Mga Mensahe";
var OPEN_NAVIGATION_MENU$5 = "Buksan ang Navigation Menu";
var PHARMACIES$5 = "Mga Parmasya at Reseta";
var PREMIUM_PAYMENTS$5 = "Mga Bayad sa Seguro na Kabayaran";
var RETURN_HOME$5 = "Bumalik sa homepage";
var REWARDS$5 = "Mga Gantimpala";
var SKIP_TO_MAIN_CONTENT$5 = "Laktawan sa papunta sa pangunahing nilalaman";
var tlphHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY$5,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE$5,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS$5,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS$5,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU$5,
	COVERAGE: COVERAGE$5,
	FIND_CARE_COST: FIND_CARE_COST$5,
	FIND_CARE: FIND_CARE$5,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST$5,
	HEALTH_RECORD: HEALTH_RECORD$5,
	HEALTH_RESOURCES: HEALTH_RESOURCES$5,
	HEALTH_WELLNESS: HEALTH_WELLNESS$5,
	HEALTH: HEALTH$5,
	HELP: HELP$5,
	HOME: HOME$5,
	LOGOUT: LOGOUT$5,
	MESSAGES: MESSAGES$5,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU$5,
	PHARMACIES: PHARMACIES$5,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS$5,
	RETURN_HOME: RETURN_HOME$5,
	REWARDS: REWARDS$5,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT$5
};

var AMOUNT_BILLED$5 = "Halaga na Sinisingil";
var ALLOWED_AMOUNT$5 = "Pinapayagang Halaga";
var AMOUNT_NOT_COVERED$5 = "Halagang Hindi Covered o Sakop";
var AMOUNT_OF_TOTAL$5 = "{{amount}} ng {{total}}";
var AS_OF_DATE$5 = "Sa ngayon {{date}}";
var BEHAVIORAL_HEALTH$5 = "Kalusugang Pangkaisipan at Substance Use";
var CANCEL$5 = "Kanselahin";
var CLAIM_NUM$5 = "Claim #";
var CLAIM_STATUS$5 = "Status ng Claim";
var CLAIM_TYPE$5 = "Uri ng Claim";
var CLAIMS$5 = "Mga claim";
var CLICK_HERE$5 = "Mag-click Dito";
var COPAY$5 = "Copay";
var COVERAGE_ENDED$5 = "Katapusan ng Coverage (Pagsakop):";
var COVERAGE_STARTS$5 = "Simula ng Coverage (Pagsakop):";
var DCSA$5 = "Dependent Care Spending Account";
var DENIED$5 = "Tinanggihan";
var DENTAL$5 = "Dental";
var DEPENDENT$5 = "Dependent";
var DETAILS$5 = "Mga Detalye";
var DOB$5 = "Kaarawan";
var DOMESTIC_PARTNER$5 = "Domestic Partner (Live-in Partner)";
var DRUG_LOOKUP$5 = "Paghahanap ng Gamot";
var EDIT$5 = "I-edit";
var EXTERNAL_LINK_MESSAGE$5 = "*Ang pagpili ng mga link na ito ay magdadala sa iyo sa isang external o panlabas na site.";
var FIND_DOCTOR$5 = "Maghanap ng doktor";
var FIND_EMERGENCY_ROOM$5 = "Maghanap ng emergency room";
var FIND_PROVIDER$5 = "Maghanap ng Provider (Tagapagbigay)";
var FIND_SPECIALIST$5 = "Maghanap ng espesyalista";
var FIND_URGENT_CARE$5 = "Maghanap ng urgent care na pasilidad";
var FROM$5 = "Mula sa";
var GO_BACK$5 = "Bumalik sa nakaraang pahina";
var GO_BACK_MODAL$5 = "Bumalik sa nakaraang nilalaman";
var HCSA$5 = "Healthcare Spending Account";
var HEALTH_PLAN_DISCOUNT$5 = "Diskwento sa Plano ng Kalusugan";
var HRA_PAID_TO_YOU$5 = "HRA Paid To You";
var I_UNDERSTAND$5 = "Naintindihan ko";
var IN_NETWORK$5 = "Loob-ng-Network";
var IN_PROCESS$5 = "Pinoproseso";
var LOADING$5 = "Naglo-load";
var MARK_AS_PAID$5 = "Namarkahan bilang Bayad";
var MEDICAL$5 = "Medikal";
var MRA$5 = "Medical Reimbursement Account";
var NAME$5 = "Pangalan";
var NEXT$5 = "Susunod";
var NEXT_PAGE$5 = "Susunod na Pahina";
var NOT_MARKED_AS_PAID$5 = "Hindi Namarkahan bilang Bayad";
var OPENS_IN_NEW_WINDOW$5 = "[Bubuksan sa bagong window]";
var OTHER$5 = "Iba pa";
var OUT_OF_NETWORK$5 = "Labas-ng-Network";
var PAGE_OF$5 = "Pahina {{current}} ng {{total}}";
var PAGINATION$5 = "Pagbilang ng pahina";
var PATIENT_NAME$5 = "Pangalan ng Pasyente";
var PATIENT_RESPONSIBILITY$5 = "Pananagutan ng Pasyente";
var PATIENTS_CLAIM_DOS$5 = "{{patient}}'s Claim Petsa ng Serbisyo";
var PAY_NOW$5 = "Magbayad Ngayon";
var PHARMACY$5 = "Parmasya";
var PHARMACY_LOCATOR$5 = "Tagahanap ng Lokasyon ng Parmasya";
var PLAN_DISCOUNT$5 = "Diskwento sa Plano";
var PLAN_PAID$5 = "Binayarang Plano";
var PREVIOUS$5 = "Nakaraan";
var PREVIOUS_PAGE$5 = "Nakaraang Pahina";
var PRINT_SUMMARY$5 = "I-print ang Summary";
var PROCESSED$5 = "Naproseso";
var PROVIDED_SERVICE$5 = "Ibinigay na Serbisyo";
var PROVIDER$5 = "Provider (Tagapagbigay)";
var RECOMMENDATIONS$5 = "Mga Rekomendasyon";
var RETIREE$5 = "Retirado";
var RX$5 = "Rx";
var SAVE$5 = "I-save";
var SAVED$5 = "Naka-save";
var SPOUSE$5 = "Asawa";
var STATUS$5 = "Status";
var SUBMIT_CLAIM$5 = "Magsumite ng Claim";
var SUBSCRIBER$5 = "Subscriber";
var TIER_ONE$5 = "Tier 1";
var TO$5 = "Hanggang sa";
var TYPE_COVERAGE_ENDED$5 = "{{type}} Katapusan ng Coverage (Pagsakop):";
var TYPE_COVERAGE_STARTS$5 = "{{type}} Simula ng Coverage (Pagsakop):";
var UNKNOWN_PROVIDER$5 = "Hindi Kilalang Provider (Tagapagbigay)";
var VIEW_ALL_CLAIMS$5 = "Tingnan ang lahat ng claim";
var VIEW_DISCOUNTS_AND_SERVICES$5 = "Tingnan ang Mga Diskwento & Mga Serbisyo";
var VIEW_EXPLANATION_BENEFITS$5 = "Tingnan ang Paliwanag ng mga Benepisyo";
var VISION$5 = "Paningin";
var WATCH_A_VIDEO_EXPLANATION$5 = "Panoorin ang Paliwanag na Video";
var YOU_MAY_OWE$5 = "Maaari Mong Inutang";
var YOU_PAID$5 = "Binayaran Mo";
var tlphCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED$5,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT$5,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED$5,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL$5,
	AS_OF_DATE: AS_OF_DATE$5,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH$5,
	CANCEL: CANCEL$5,
	CLAIM_NUM: CLAIM_NUM$5,
	CLAIM_STATUS: CLAIM_STATUS$5,
	CLAIM_TYPE: CLAIM_TYPE$5,
	CLAIMS: CLAIMS$5,
	CLICK_HERE: CLICK_HERE$5,
	COPAY: COPAY$5,
	COVERAGE_ENDED: COVERAGE_ENDED$5,
	COVERAGE_STARTS: COVERAGE_STARTS$5,
	DCSA: DCSA$5,
	DENIED: DENIED$5,
	DENTAL: DENTAL$5,
	DEPENDENT: DEPENDENT$5,
	DETAILS: DETAILS$5,
	DOB: DOB$5,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER$5,
	DRUG_LOOKUP: DRUG_LOOKUP$5,
	EDIT: EDIT$5,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE$5,
	FIND_DOCTOR: FIND_DOCTOR$5,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM$5,
	FIND_PROVIDER: FIND_PROVIDER$5,
	FIND_SPECIALIST: FIND_SPECIALIST$5,
	FIND_URGENT_CARE: FIND_URGENT_CARE$5,
	FROM: FROM$5,
	GO_BACK: GO_BACK$5,
	GO_BACK_MODAL: GO_BACK_MODAL$5,
	HCSA: HCSA$5,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT$5,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU$5,
	I_UNDERSTAND: I_UNDERSTAND$5,
	IN_NETWORK: IN_NETWORK$5,
	IN_PROCESS: IN_PROCESS$5,
	LOADING: LOADING$5,
	MARK_AS_PAID: MARK_AS_PAID$5,
	MEDICAL: MEDICAL$5,
	MRA: MRA$5,
	NAME: NAME$5,
	NEXT: NEXT$5,
	NEXT_PAGE: NEXT_PAGE$5,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID$5,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW$5,
	OTHER: OTHER$5,
	OUT_OF_NETWORK: OUT_OF_NETWORK$5,
	PAGE_OF: PAGE_OF$5,
	PAGINATION: PAGINATION$5,
	PATIENT_NAME: PATIENT_NAME$5,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY$5,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS$5,
	PAY_NOW: PAY_NOW$5,
	PHARMACY: PHARMACY$5,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR$5,
	PLAN_DISCOUNT: PLAN_DISCOUNT$5,
	PLAN_PAID: PLAN_PAID$5,
	PREVIOUS: PREVIOUS$5,
	PREVIOUS_PAGE: PREVIOUS_PAGE$5,
	PRINT_SUMMARY: PRINT_SUMMARY$5,
	PROCESSED: PROCESSED$5,
	PROVIDED_SERVICE: PROVIDED_SERVICE$5,
	PROVIDER: PROVIDER$5,
	RECOMMENDATIONS: RECOMMENDATIONS$5,
	RETIREE: RETIREE$5,
	RX: RX$5,
	SAVE: SAVE$5,
	SAVED: SAVED$5,
	SPOUSE: SPOUSE$5,
	STATUS: STATUS$5,
	SUBMIT_CLAIM: SUBMIT_CLAIM$5,
	SUBSCRIBER: SUBSCRIBER$5,
	TIER_ONE: TIER_ONE$5,
	TO: TO$5,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED$5,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS$5,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER$5,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS$5,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES$5,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS$5,
	VISION: VISION$5,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION$5,
	YOU_MAY_OWE: YOU_MAY_OWE$5,
	YOU_PAID: YOU_PAID$5
};

var FTR_MEMBER_SUPPORT$6 = "Hỗ trợ Thành viên";
var FTR_SUPPORT$6 = "Hỗ Trợ";
var FTR_IMPORTANT_INFO$6 = "Thông Tin Quan Trọng";
var FTR_HELP$6 = "Trợ giúp & Liên hệ với chúng tôi";
var FTR_NURSE_CHAT$6 = "Hỏi Y tá: Trò chuyện ngay bây giờ";
var FTR_NURSE_CHAT_WITH_PHONE$6 = "Hỏi Y tá: <a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">Trò chuyện Ngay bây giờ</a>";
var FTR_NURSE_LINE$6 = "Hỏi Y tá: <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK$6 = "Chia sẻ Phản hồi";
var FTR_MEMBER_INFO$6 = "Thông tin Thành viên";
var FTR_PROVIDER_DATA_INFO$6 = "Thông Tin Dữ Liệu Nhà Cung Cấp";
var FTR_LEGAL_ENTITIES$6 = "Pháp Nhân";
var FTR_QUICK_LINKS$6 = "Liên kết nhanh";
var FTR_RIGHTS$6 = "Bảo lưu mọi quyền.";
var FTR_ABOUT_RALLY$6 = "Về Rally";
var FTR_ABOUT_UNITED$6 = "Về UnitedHealthcare";
var FTR_TERMS$6 = "Điều khoản Sử dụng";
var FTR_PRIVACY$6 = "Chính sách Bảo mật";
var FTR_NOTICES$6 = "Thông Báo & Tiết Lộ Thông Tin";
var FTR_LEGAL_NOTICES$6 = "Thông báo & Công bố Pháp nhân";
var FTR_UPDATED$6 = "Last Updated: {{date}} at {{time}} CT";
var FTR_UPDATED_MEDICAL$6 = "Medical information last updated: {{date}}";
var FTR_UPDATED_MENTAL$6 = "Mental Health information last updated: {{date}}";
var FTR_INFO_UPDATED$6 = "Cập Nhật Thông Tin Gần Đây Nhất vào ngày {{date}} lúc {{time}} múi giờ miền Trung";
var FTR_MADE_BY$6 = "Thực hiện bởi";
var FTR_ACCESSIBILITY$6 = "Khả năng tiếp cận";
var FTR_ACCESSIBILITY_STATEMENT$6 = "Công Bố Về Hỗ Trợ Cho Người Khuyết Tật";
var FTR_LANGUAGE_ENG$6 = "Hỗ Trợ Ngôn Ngữ | Thông Báo Về Không Phân Biệt Đối Xử";
var FTR_LANGUAGE_SPA$6 = "Asistencia de Idiomas | Aviso de no Discriminación";
var FTR_LANGUAGE_CHI$6 = "語言協助 | 不歧視通知";
var FTR_FOLLOW_US$6 = "Theo Dõi Chúng Tôi";
var FTR_FACEBOOK$6 = "Facebook";
var FTR_BACK_TO_TOP$6 = "Back to top";
var FTR_MATERIAL_ID$6 = "Marketing Material ID # {{materialId}}";
var FTR_PROVIDER_DIRECTORY$6 = "Print / Email Provider Directory";
var vivnFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT$6,
	FTR_SUPPORT: FTR_SUPPORT$6,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO$6,
	FTR_HELP: FTR_HELP$6,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT$6,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE$6,
	FTR_NURSE_LINE: FTR_NURSE_LINE$6,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK$6,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO$6,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO$6,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES$6,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS$6,
	FTR_RIGHTS: FTR_RIGHTS$6,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY$6,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED$6,
	FTR_TERMS: FTR_TERMS$6,
	FTR_PRIVACY: FTR_PRIVACY$6,
	FTR_NOTICES: FTR_NOTICES$6,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES$6,
	FTR_UPDATED: FTR_UPDATED$6,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL$6,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL$6,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED$6,
	FTR_MADE_BY: FTR_MADE_BY$6,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY$6,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT$6,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG$6,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA$6,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI$6,
	FTR_FOLLOW_US: FTR_FOLLOW_US$6,
	FTR_FACEBOOK: FTR_FACEBOOK$6,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP$6,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID$6,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY$6
};

var ACCOUNT_PROFILE_LEGACY$6 = "Hồ sơ Tài khoản";
var ACCOUNT_PROFILE$6 = "Tài khoản / Hồ sơ";
var ACCOUNT_SETTINGS$6 = "Cài đặt tài khoản";
var CLAIMS_AND_ACCOUNTS$6 = "Yêu cầu bồi thường & Tài khoản";
var CLOSE_NAVIGATION_MENU$6 = "Đóng Trình đơn Điều hướng";
var COVERAGE$6 = "Phạm vi Bảo hiểm & Quyền lợi";
var FIND_CARE_COST$6 = "Tìm Dịch vụ Chăm sóc & Chi phí";
var FIND_CARE$6 = "Tìm Dịch vụ chăm sóc";
var HEALTH_CHECKLIST$6 = "Danh sách chăm sóc sức khỏe";
var HEALTH_RECORD$6 = "Health Record";
var HEALTH_RESOURCES$6 = "Nguồn tài nguyên Sức khỏe";
var HEALTH_WELLNESS$6 = "Sức khỏe & Đời sống Khỏe mạnh";
var HEALTH$6 = "Sức khỏe & Đời sống Khỏe mạnh";
var HELP$6 = "Trợ giúp";
var HOME$6 = "Trang chủ";
var LOGOUT$6 = "Đăng xuất";
var MESSAGES$6 = "Tin nhắn";
var OPEN_NAVIGATION_MENU$6 = "Mở Trình đơn Điều hướng";
var PHARMACIES$6 = "Nhà thuốc & Đơn thuốc";
var PREMIUM_PAYMENTS$6 = "Thanh toán Phí bảo hiểm";
var RETURN_HOME$6 = "Quay trở lại trang chủ";
var REWARDS$6 = "Ưu đãi";
var SKIP_TO_MAIN_CONTENT$6 = "Bỏ qua để chuyển đến nội dung chính";
var vivnHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY$6,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE$6,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS$6,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS$6,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU$6,
	COVERAGE: COVERAGE$6,
	FIND_CARE_COST: FIND_CARE_COST$6,
	FIND_CARE: FIND_CARE$6,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST$6,
	HEALTH_RECORD: HEALTH_RECORD$6,
	HEALTH_RESOURCES: HEALTH_RESOURCES$6,
	HEALTH_WELLNESS: HEALTH_WELLNESS$6,
	HEALTH: HEALTH$6,
	HELP: HELP$6,
	HOME: HOME$6,
	LOGOUT: LOGOUT$6,
	MESSAGES: MESSAGES$6,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU$6,
	PHARMACIES: PHARMACIES$6,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS$6,
	RETURN_HOME: RETURN_HOME$6,
	REWARDS: REWARDS$6,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT$6
};

var AMOUNT_BILLED$6 = "Số tiền Thanh toán";
var ALLOWED_AMOUNT$6 = "Số tiền Cho phép";
var AMOUNT_NOT_COVERED$6 = "Số tiền không được bảo hiểm";
var AMOUNT_OF_TOTAL$6 = "{{amount}} / {{total}}";
var AS_OF_DATE$6 = "Tại thời điểm {{date}}";
var BEHAVIORAL_HEALTH$6 = "Sức khỏe Tâm thần & Sử dụng Chất gây nghiện";
var CANCEL$6 = "Hủy";
var CLAIM_NUM$6 = "Số Yêu cầu Bồi thường #";
var CLAIM_STATUS$6 = "Tình trạng Yêu cầu Bồi thường";
var CLAIM_TYPE$6 = "Loại Yêu cầu Bồi thường";
var CLAIMS$6 = "Yêu cầu Bồi thường";
var CLICK_HERE$6 = "Nhấp vào đây";
var COPAY$6 = "Đồng thanh toán";
var COVERAGE_ENDED$6 = "Phạm vi Bảo hiểm Kết thúc:";
var COVERAGE_STARTS$6 = "Phạm vi Bảo hiểm Bắt đầu:";
var DCSA$6 = "Tài khoản Chi tiêu Chăm sóc Người phụ thuộc";
var DENIED$6 = "Bị từ chối";
var DENTAL$6 = "Nha khoa";
var DEPENDENT$6 = "Người phụ thuộc";
var DETAILS$6 = "Thông tin Chi tiết";
var DOB$6 = "Ngày sinh";
var DOMESTIC_PARTNER$6 = "Bạn đời Sống chung";
var DRUG_LOOKUP$6 = "Tra cứu thuốc";
var EDIT$6 = "Chỉnh sửa";
var EXTERNAL_LINK_MESSAGE$6 = "*Chọn những liên kết này sẽ dẫn quý vị đến một trang web bên ngoài.";
var FIND_DOCTOR$6 = "Tìm bác sĩ";
var FIND_EMERGENCY_ROOM$6 = "Tìm phòng cấp cứu";
var FIND_PROVIDER$6 = "Tìm Nhà cung cấp";
var FIND_SPECIALIST$6 = "Tìm bác sĩ chuyên khoa";
var FIND_URGENT_CARE$6 = "Tìm cơ sở chăm sóc khẩn cấp";
var FROM$6 = "Từ";
var GO_BACK$6 = "Quay trở lại trang trước";
var GO_BACK_MODAL$6 = "Quay lại nội dung trước đó";
var HCSA$6 = "Tài khoản Chi tiêu Chăm sóc sức khỏe";
var HEALTH_PLAN_DISCOUNT$6 = "Chiết khấu Chương trình Bảo hiểm Sức khỏe";
var HRA_PAID_TO_YOU$6 = "HRA Paid To You";
var I_UNDERSTAND$6 = "Tôi hiểu";
var IN_NETWORK$6 = "Trong mạng lưới";
var IN_PROCESS$6 = "Đang xử lý";
var LOADING$6 = "Đang tải";
var MARK_AS_PAID$6 = "Đánh dấu Đã trả";
var MEDICAL$6 = "Khám sức khỏe";
var MRA$6 = "Tài khoản Bồi hoàn Y tế";
var NAME$6 = "Tên";
var NEXT$6 = "Tiếp theo";
var NEXT_PAGE$6 = "Trang tiếp theo";
var NOT_MARKED_AS_PAID$6 = "Chưa Đánh Dấu Đã Thanh Toán";
var OPENS_IN_NEW_WINDOW$6 = "[Mở trong cửa sổ mới]";
var OTHER$6 = "Khác";
var OUT_OF_NETWORK$6 = "Ngoài mạng lưới";
var PAGE_OF$6 = "Trang {{current}} của {{total}}";
var PAGINATION$6 = "Phân trang";
var PATIENT_NAME$6 = "Tên bệnh nhân";
var PATIENT_RESPONSIBILITY$6 = "Trách nhiệm của Bệnh nhân";
var PATIENTS_CLAIM_DOS$6 = "{{patient}}Ngày hưởng Dịch vụ của Yêu cầu bồi thường của";
var PAY_NOW$6 = "Thanh toán ngay bây giờ";
var PHARMACY$6 = "Nhà thuốc";
var PHARMACY_LOCATOR$6 = "Xác định vị trí Nhà thuốc";
var PLAN_DISCOUNT$6 = "Chiết khấu Chương trình";
var PLAN_PAID$6 = "Chương trình đã Thanh toán";
var PREVIOUS$6 = "Trước";
var PREVIOUS_PAGE$6 = "Trang trước";
var PRINT_SUMMARY$6 = "In bản Tóm tắt";
var PROCESSED$6 = "Đã xử lý";
var PROVIDED_SERVICE$6 = "Dịch vụ được Cung cấp";
var PROVIDER$6 = "Nhà cung cấp";
var RECOMMENDATIONS$6 = "Đề xuất";
var RETIREE$6 = "Người về hưu";
var RX$6 = "Toa thuốc (Rx)";
var SAVE$6 = "Lưu";
var SAVED$6 = "Đã lưu";
var SPOUSE$6 = "Vợ/chồng";
var STATUS$6 = "Tình trạng";
var SUBMIT_CLAIM$6 = "Nộp Yêu cầu Bồi thường";
var SUBSCRIBER$6 = "Người đăng ký tham gia bảo hiểm";
var TIER_ONE$6 = "Bậc 1";
var TO$6 = "Đến";
var TYPE_COVERAGE_ENDED$6 = "{{type}} Phạm vi Bảo hiểm Kết thúc:";
var TYPE_COVERAGE_STARTS$6 = "{{type}} Phạm vi Bảo hiểm Bắt đầu:";
var UNKNOWN_PROVIDER$6 = "Nhà cung cấp vô danh";
var VIEW_ALL_CLAIMS$6 = "Xem tất cả yêu cầu bồi thường";
var VIEW_DISCOUNTS_AND_SERVICES$6 = "Xem Chiết khấu & Dịch vụ";
var VIEW_EXPLANATION_BENEFITS$6 = "Xem Giải thích về quyền lợi";
var VISION$6 = "Thị lực";
var WATCH_A_VIDEO_EXPLANATION$6 = "Xem Video Giải thích";
var YOU_MAY_OWE$6 = "Quý vị có thể phải trả";
var YOU_PAID$6 = "Quý vị đã thanh toán";
var vivnCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED$6,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT$6,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED$6,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL$6,
	AS_OF_DATE: AS_OF_DATE$6,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH$6,
	CANCEL: CANCEL$6,
	CLAIM_NUM: CLAIM_NUM$6,
	CLAIM_STATUS: CLAIM_STATUS$6,
	CLAIM_TYPE: CLAIM_TYPE$6,
	CLAIMS: CLAIMS$6,
	CLICK_HERE: CLICK_HERE$6,
	COPAY: COPAY$6,
	COVERAGE_ENDED: COVERAGE_ENDED$6,
	COVERAGE_STARTS: COVERAGE_STARTS$6,
	DCSA: DCSA$6,
	DENIED: DENIED$6,
	DENTAL: DENTAL$6,
	DEPENDENT: DEPENDENT$6,
	DETAILS: DETAILS$6,
	DOB: DOB$6,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER$6,
	DRUG_LOOKUP: DRUG_LOOKUP$6,
	EDIT: EDIT$6,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE$6,
	FIND_DOCTOR: FIND_DOCTOR$6,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM$6,
	FIND_PROVIDER: FIND_PROVIDER$6,
	FIND_SPECIALIST: FIND_SPECIALIST$6,
	FIND_URGENT_CARE: FIND_URGENT_CARE$6,
	FROM: FROM$6,
	GO_BACK: GO_BACK$6,
	GO_BACK_MODAL: GO_BACK_MODAL$6,
	HCSA: HCSA$6,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT$6,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU$6,
	I_UNDERSTAND: I_UNDERSTAND$6,
	IN_NETWORK: IN_NETWORK$6,
	IN_PROCESS: IN_PROCESS$6,
	LOADING: LOADING$6,
	MARK_AS_PAID: MARK_AS_PAID$6,
	MEDICAL: MEDICAL$6,
	MRA: MRA$6,
	NAME: NAME$6,
	NEXT: NEXT$6,
	NEXT_PAGE: NEXT_PAGE$6,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID$6,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW$6,
	OTHER: OTHER$6,
	OUT_OF_NETWORK: OUT_OF_NETWORK$6,
	PAGE_OF: PAGE_OF$6,
	PAGINATION: PAGINATION$6,
	PATIENT_NAME: PATIENT_NAME$6,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY$6,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS$6,
	PAY_NOW: PAY_NOW$6,
	PHARMACY: PHARMACY$6,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR$6,
	PLAN_DISCOUNT: PLAN_DISCOUNT$6,
	PLAN_PAID: PLAN_PAID$6,
	PREVIOUS: PREVIOUS$6,
	PREVIOUS_PAGE: PREVIOUS_PAGE$6,
	PRINT_SUMMARY: PRINT_SUMMARY$6,
	PROCESSED: PROCESSED$6,
	PROVIDED_SERVICE: PROVIDED_SERVICE$6,
	PROVIDER: PROVIDER$6,
	RECOMMENDATIONS: RECOMMENDATIONS$6,
	RETIREE: RETIREE$6,
	RX: RX$6,
	SAVE: SAVE$6,
	SAVED: SAVED$6,
	SPOUSE: SPOUSE$6,
	STATUS: STATUS$6,
	SUBMIT_CLAIM: SUBMIT_CLAIM$6,
	SUBSCRIBER: SUBSCRIBER$6,
	TIER_ONE: TIER_ONE$6,
	TO: TO$6,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED$6,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS$6,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER$6,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS$6,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES$6,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS$6,
	VISION: VISION$6,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION$6,
	YOU_MAY_OWE: YOU_MAY_OWE$6,
	YOU_PAID: YOU_PAID$6
};

var FTR_MEMBER_SUPPORT$7 = "會員支援服務";
var FTR_SUPPORT$7 = "支持";
var FTR_IMPORTANT_INFO$7 = "重要資訊";
var FTR_HELP$7 = "幫助和聯絡我們";
var FTR_NURSE_CHAT$7 = "詢問護士：立即交談";
var FTR_NURSE_CHAT_WITH_PHONE$7 = "詢問護士：<a href=\"tel:{{phone}}\">{{phone}}</a> | <a href=\"{{url}}\" target=\"_blank\">立即交談</a>";
var FTR_NURSE_LINE$7 = "詢問護士： <a href=\"tel:{{phone}}\">{{phone}}</a>";
var FTR_SHARE_FEEDBACK$7 = "分享回饋意見";
var FTR_MEMBER_INFO$7 = "會員資訊";
var FTR_PROVIDER_DATA_INFO$7 = "服務提供者數據資訊";
var FTR_LEGAL_ENTITIES$7 = "法律實體";
var FTR_QUICK_LINKS$7 = "快速連結";
var FTR_RIGHTS$7 = "版權所有。";
var FTR_ABOUT_RALLY$7 = "關於 Rally";
var FTR_ABOUT_UNITED$7 = "關於 UnitedHealthcare";
var FTR_TERMS$7 = "使用條款";
var FTR_PRIVACY$7 = "隱私政策";
var FTR_NOTICES$7 = "聲明與披露";
var FTR_LEGAL_NOTICES$7 = "法律聲明與披露";
var FTR_UPDATED$7 = "Last Updated: {{date}} at {{time}} CT";
var FTR_UPDATED_MEDICAL$7 = "Medical information last updated: {{date}}";
var FTR_UPDATED_MENTAL$7 = "Mental Health information last updated: {{date}}";
var FTR_INFO_UPDATED$7 = "資訊更新於：{{date}}中部時間{{time}}";
var FTR_MADE_BY$7 = "製作者：";
var FTR_ACCESSIBILITY$7 = "可獲取性";
var FTR_ACCESSIBILITY_STATEMENT$7 = "無障礙聲明";
var FTR_LANGUAGE_ENG$7 = "Language Assistance | Non-Discrimination Notice";
var FTR_LANGUAGE_SPA$7 = "Asistencia de Idiomas | Aviso de no Discriminación";
var FTR_LANGUAGE_CHI$7 = "語言協助 | 不歧視聲明";
var FTR_FOLLOW_US$7 = "關注我們";
var FTR_FACEBOOK$7 = "Facebook";
var FTR_BACK_TO_TOP$7 = "Back to top";
var FTR_MATERIAL_ID$7 = "Marketing Material ID # {{materialId}}";
var FTR_PROVIDER_DIRECTORY$7 = "Print / Email Provider Directory";
var zhtwFooter = {
	FTR_MEMBER_SUPPORT: FTR_MEMBER_SUPPORT$7,
	FTR_SUPPORT: FTR_SUPPORT$7,
	FTR_IMPORTANT_INFO: FTR_IMPORTANT_INFO$7,
	FTR_HELP: FTR_HELP$7,
	FTR_NURSE_CHAT: FTR_NURSE_CHAT$7,
	FTR_NURSE_CHAT_WITH_PHONE: FTR_NURSE_CHAT_WITH_PHONE$7,
	FTR_NURSE_LINE: FTR_NURSE_LINE$7,
	FTR_SHARE_FEEDBACK: FTR_SHARE_FEEDBACK$7,
	FTR_MEMBER_INFO: FTR_MEMBER_INFO$7,
	FTR_PROVIDER_DATA_INFO: FTR_PROVIDER_DATA_INFO$7,
	FTR_LEGAL_ENTITIES: FTR_LEGAL_ENTITIES$7,
	FTR_QUICK_LINKS: FTR_QUICK_LINKS$7,
	FTR_RIGHTS: FTR_RIGHTS$7,
	FTR_ABOUT_RALLY: FTR_ABOUT_RALLY$7,
	FTR_ABOUT_UNITED: FTR_ABOUT_UNITED$7,
	FTR_TERMS: FTR_TERMS$7,
	FTR_PRIVACY: FTR_PRIVACY$7,
	FTR_NOTICES: FTR_NOTICES$7,
	FTR_LEGAL_NOTICES: FTR_LEGAL_NOTICES$7,
	FTR_UPDATED: FTR_UPDATED$7,
	FTR_UPDATED_MEDICAL: FTR_UPDATED_MEDICAL$7,
	FTR_UPDATED_MENTAL: FTR_UPDATED_MENTAL$7,
	FTR_INFO_UPDATED: FTR_INFO_UPDATED$7,
	FTR_MADE_BY: FTR_MADE_BY$7,
	FTR_ACCESSIBILITY: FTR_ACCESSIBILITY$7,
	FTR_ACCESSIBILITY_STATEMENT: FTR_ACCESSIBILITY_STATEMENT$7,
	FTR_LANGUAGE_ENG: FTR_LANGUAGE_ENG$7,
	FTR_LANGUAGE_SPA: FTR_LANGUAGE_SPA$7,
	FTR_LANGUAGE_CHI: FTR_LANGUAGE_CHI$7,
	FTR_FOLLOW_US: FTR_FOLLOW_US$7,
	FTR_FACEBOOK: FTR_FACEBOOK$7,
	FTR_BACK_TO_TOP: FTR_BACK_TO_TOP$7,
	FTR_MATERIAL_ID: FTR_MATERIAL_ID$7,
	FTR_PROVIDER_DIRECTORY: FTR_PROVIDER_DIRECTORY$7
};

var ACCOUNT_PROFILE_LEGACY$7 = "帳戶設定檔";
var ACCOUNT_PROFILE$7 = "帳戶/設定檔";
var ACCOUNT_SETTINGS$7 = "帳戶設定";
var CLAIMS_AND_ACCOUNTS$7 = "理賠與帳戶";
var CLOSE_NAVIGATION_MENU$7 = "關閉導航選單";
var COVERAGE$7 = "承保範圍與福利";
var FIND_CARE_COST$7 = "查找醫療保健提供者與費用";
var FIND_CARE$7 = "查找醫療保健提供者";
var HEALTH_CHECKLIST$7 = "健康檢查表";
var HEALTH_RECORD$7 = "Health Record";
var HEALTH_RESOURCES$7 = "衛生保健資源";
var HEALTH_WELLNESS$7 = "身心健康";
var HEALTH$7 = "身心健康";
var HELP$7 = "協助説明";
var HOME$7 = "首頁";
var LOGOUT$7 = "登出";
var MESSAGES$7 = "訊息";
var OPEN_NAVIGATION_MENU$7 = "打開導航選單";
var PHARMACIES$7 = "藥房與處方藥";
var PREMIUM_PAYMENTS$7 = "保險費款項";
var RETURN_HOME$7 = "返回首頁";
var REWARDS$7 = "獎勵";
var SKIP_TO_MAIN_CONTENT$7 = "跳至主要內容";
var zhtwHeader = {
	ACCOUNT_PROFILE_LEGACY: ACCOUNT_PROFILE_LEGACY$7,
	ACCOUNT_PROFILE: ACCOUNT_PROFILE$7,
	ACCOUNT_SETTINGS: ACCOUNT_SETTINGS$7,
	CLAIMS_AND_ACCOUNTS: CLAIMS_AND_ACCOUNTS$7,
	CLOSE_NAVIGATION_MENU: CLOSE_NAVIGATION_MENU$7,
	COVERAGE: COVERAGE$7,
	FIND_CARE_COST: FIND_CARE_COST$7,
	FIND_CARE: FIND_CARE$7,
	HEALTH_CHECKLIST: HEALTH_CHECKLIST$7,
	HEALTH_RECORD: HEALTH_RECORD$7,
	HEALTH_RESOURCES: HEALTH_RESOURCES$7,
	HEALTH_WELLNESS: HEALTH_WELLNESS$7,
	HEALTH: HEALTH$7,
	HELP: HELP$7,
	HOME: HOME$7,
	LOGOUT: LOGOUT$7,
	MESSAGES: MESSAGES$7,
	OPEN_NAVIGATION_MENU: OPEN_NAVIGATION_MENU$7,
	PHARMACIES: PHARMACIES$7,
	PREMIUM_PAYMENTS: PREMIUM_PAYMENTS$7,
	RETURN_HOME: RETURN_HOME$7,
	REWARDS: REWARDS$7,
	SKIP_TO_MAIN_CONTENT: SKIP_TO_MAIN_CONTENT$7
};

var AMOUNT_BILLED$7 = "計費金額";
var ALLOWED_AMOUNT$7 = "允許金額";
var AMOUNT_NOT_COVERED$7 = "未承保金額";
var AMOUNT_OF_TOTAL$7 = "{{amount}} 的 {{total}}";
var AS_OF_DATE$7 = "截至： {{date}}";
var BEHAVIORAL_HEALTH$7 = "精神健康和藥物濫用";
var CANCEL$7 = "取消";
var CLAIM_NUM$7 = "理賠申請號碼";
var CLAIM_STATUS$7 = "理賠狀態";
var CLAIM_TYPE$7 = "理賠類型";
var CLAIMS$7 = "保險理賠";
var CLICK_HERE$7 = "點擊此處";
var COPAY$7 = "共付額";
var COVERAGE_ENDED$7 = "承保結束日期:";
var COVERAGE_STARTS$7 = "承保開始日期：";
var DCSA$7 = "受撫養人照護支出帳戶";
var DENIED$7 = "拒絕";
var DENTAL$7 = "牙科";
var DEPENDENT$7 = "受撫養人";
var DETAILS$7 = "詳情";
var DOB$7 = "出生日期";
var DOMESTIC_PARTNER$7 = "同居伴侶";
var DRUG_LOOKUP$7 = "藥品查詢";
var EDIT$7 = "編輯";
var EXTERNAL_LINK_MESSAGE$7 = "*選擇這些連結會將您引導至外部網站。";
var FIND_DOCTOR$7 = "查找醫生";
var FIND_EMERGENCY_ROOM$7 = "查找急診室";
var FIND_PROVIDER$7 = "查找服務提供者";
var FIND_SPECIALIST$7 = "查找專科醫生";
var FIND_URGENT_CARE$7 = "查找急症照護機構";
var FROM$7 = "自";
var GO_BACK$7 = "返回上一個頁面";
var GO_BACK_MODAL$7 = "返回上一個內容";
var HCSA$7 = "醫療保健支出帳戶";
var HEALTH_PLAN_DISCOUNT$7 = "健康計劃折扣";
var HRA_PAID_TO_YOU$7 = "HRA Paid To You";
var I_UNDERSTAND$7 = "我瞭解";
var IN_NETWORK$7 = "網絡內";
var IN_PROCESS$7 = "處理中";
var LOADING$7 = "載入中";
var MARK_AS_PAID$7 = "標示為已付";
var MEDICAL$7 = "醫療";
var MRA$7 = "醫療償付帳戶";
var NAME$7 = "名字";
var NEXT$7 = "下一個";
var NEXT_PAGE$7 = "下一頁";
var NOT_MARKED_AS_PAID$7 = "未標示為已付";
var OPENS_IN_NEW_WINDOW$7 = "[在新視窗中打開]";
var OTHER$7 = "其他";
var OUT_OF_NETWORK$7 = "網絡外";
var PAGE_OF$7 = "第 {{current}} 頁，共 {{total}} 頁";
var PAGINATION$7 = "分頁";
var PATIENT_NAME$7 = "患者姓名";
var PATIENT_RESPONSIBILITY$7 = "患者責任";
var PATIENTS_CLAIM_DOS$7 = "{{patient}}的服務理賠日期";
var PAY_NOW$7 = "立即支付";
var PHARMACY$7 = "藥房";
var PHARMACY_LOCATOR$7 = "藥房查找";
var PLAN_DISCOUNT$7 = "計畫折扣";
var PLAN_PAID$7 = "計劃已支付";
var PREVIOUS$7 = "上一個";
var PREVIOUS_PAGE$7 = "上一頁";
var PRINT_SUMMARY$7 = "列印摘要";
var PROCESSED$7 = "已處理";
var PROVIDED_SERVICE$7 = "提供服務";
var PROVIDER$7 = "服務提供者";
var RECOMMENDATIONS$7 = "推薦";
var RETIREE$7 = "退休人士";
var RX$7 = "處方藥";
var SAVE$7 = "儲存";
var SAVED$7 = "已儲存";
var SPOUSE$7 = "配偶";
var STATUS$7 = "狀態";
var SUBMIT_CLAIM$7 = "提交理賠申請";
var SUBSCRIBER$7 = "訂戶";
var TIER_ONE$7 = "層級 1";
var TO$7 = "至";
var TYPE_COVERAGE_ENDED$7 = "{{type}} 承保結束日期:";
var TYPE_COVERAGE_STARTS$7 = "{{type}} 承保開始日期：";
var UNKNOWN_PROVIDER$7 = "未知服務提供者";
var VIEW_ALL_CLAIMS$7 = "檢視所有理賠申請";
var VIEW_DISCOUNTS_AND_SERVICES$7 = "檢視「折扣與服務」";
var VIEW_EXPLANATION_BENEFITS$7 = "檢視福利說明書";
var VISION$7 = "眼科";
var WATCH_A_VIDEO_EXPLANATION$7 = "觀看影片說明";
var YOU_MAY_OWE$7 = "您可能需支付";
var YOU_PAID$7 = "您已支付";
var zhtwCommon = {
	AMOUNT_BILLED: AMOUNT_BILLED$7,
	ALLOWED_AMOUNT: ALLOWED_AMOUNT$7,
	AMOUNT_NOT_COVERED: AMOUNT_NOT_COVERED$7,
	AMOUNT_OF_TOTAL: AMOUNT_OF_TOTAL$7,
	AS_OF_DATE: AS_OF_DATE$7,
	BEHAVIORAL_HEALTH: BEHAVIORAL_HEALTH$7,
	CANCEL: CANCEL$7,
	CLAIM_NUM: CLAIM_NUM$7,
	CLAIM_STATUS: CLAIM_STATUS$7,
	CLAIM_TYPE: CLAIM_TYPE$7,
	CLAIMS: CLAIMS$7,
	CLICK_HERE: CLICK_HERE$7,
	COPAY: COPAY$7,
	COVERAGE_ENDED: COVERAGE_ENDED$7,
	COVERAGE_STARTS: COVERAGE_STARTS$7,
	DCSA: DCSA$7,
	DENIED: DENIED$7,
	DENTAL: DENTAL$7,
	DEPENDENT: DEPENDENT$7,
	DETAILS: DETAILS$7,
	DOB: DOB$7,
	DOMESTIC_PARTNER: DOMESTIC_PARTNER$7,
	DRUG_LOOKUP: DRUG_LOOKUP$7,
	EDIT: EDIT$7,
	EXTERNAL_LINK_MESSAGE: EXTERNAL_LINK_MESSAGE$7,
	FIND_DOCTOR: FIND_DOCTOR$7,
	FIND_EMERGENCY_ROOM: FIND_EMERGENCY_ROOM$7,
	FIND_PROVIDER: FIND_PROVIDER$7,
	FIND_SPECIALIST: FIND_SPECIALIST$7,
	FIND_URGENT_CARE: FIND_URGENT_CARE$7,
	FROM: FROM$7,
	GO_BACK: GO_BACK$7,
	GO_BACK_MODAL: GO_BACK_MODAL$7,
	HCSA: HCSA$7,
	HEALTH_PLAN_DISCOUNT: HEALTH_PLAN_DISCOUNT$7,
	HRA_PAID_TO_YOU: HRA_PAID_TO_YOU$7,
	I_UNDERSTAND: I_UNDERSTAND$7,
	IN_NETWORK: IN_NETWORK$7,
	IN_PROCESS: IN_PROCESS$7,
	LOADING: LOADING$7,
	MARK_AS_PAID: MARK_AS_PAID$7,
	MEDICAL: MEDICAL$7,
	MRA: MRA$7,
	NAME: NAME$7,
	NEXT: NEXT$7,
	NEXT_PAGE: NEXT_PAGE$7,
	NOT_MARKED_AS_PAID: NOT_MARKED_AS_PAID$7,
	OPENS_IN_NEW_WINDOW: OPENS_IN_NEW_WINDOW$7,
	OTHER: OTHER$7,
	OUT_OF_NETWORK: OUT_OF_NETWORK$7,
	PAGE_OF: PAGE_OF$7,
	PAGINATION: PAGINATION$7,
	PATIENT_NAME: PATIENT_NAME$7,
	PATIENT_RESPONSIBILITY: PATIENT_RESPONSIBILITY$7,
	PATIENTS_CLAIM_DOS: PATIENTS_CLAIM_DOS$7,
	PAY_NOW: PAY_NOW$7,
	PHARMACY: PHARMACY$7,
	PHARMACY_LOCATOR: PHARMACY_LOCATOR$7,
	PLAN_DISCOUNT: PLAN_DISCOUNT$7,
	PLAN_PAID: PLAN_PAID$7,
	PREVIOUS: PREVIOUS$7,
	PREVIOUS_PAGE: PREVIOUS_PAGE$7,
	PRINT_SUMMARY: PRINT_SUMMARY$7,
	PROCESSED: PROCESSED$7,
	PROVIDED_SERVICE: PROVIDED_SERVICE$7,
	PROVIDER: PROVIDER$7,
	RECOMMENDATIONS: RECOMMENDATIONS$7,
	RETIREE: RETIREE$7,
	RX: RX$7,
	SAVE: SAVE$7,
	SAVED: SAVED$7,
	SPOUSE: SPOUSE$7,
	STATUS: STATUS$7,
	SUBMIT_CLAIM: SUBMIT_CLAIM$7,
	SUBSCRIBER: SUBSCRIBER$7,
	TIER_ONE: TIER_ONE$7,
	TO: TO$7,
	TYPE_COVERAGE_ENDED: TYPE_COVERAGE_ENDED$7,
	TYPE_COVERAGE_STARTS: TYPE_COVERAGE_STARTS$7,
	UNKNOWN_PROVIDER: UNKNOWN_PROVIDER$7,
	VIEW_ALL_CLAIMS: VIEW_ALL_CLAIMS$7,
	VIEW_DISCOUNTS_AND_SERVICES: VIEW_DISCOUNTS_AND_SERVICES$7,
	VIEW_EXPLANATION_BENEFITS: VIEW_EXPLANATION_BENEFITS$7,
	VISION: VISION$7,
	WATCH_A_VIDEO_EXPLANATION: WATCH_A_VIDEO_EXPLANATION$7,
	YOU_MAY_OWE: YOU_MAY_OWE$7,
	YOU_PAID: YOU_PAID$7
};

var _memo;

var normalizeLocale = function normalizeLocale(locale) {
  switch (locale.toLocaleLowerCase()) {
    case 'es-us':
      return Locale.esUS;

    case 'ht-ht':
      return Locale.htHT;

    case 'il-ph':
      return Locale.ilPH;

    case 'ko-us':
      return Locale.koUS;

    case 'tl-ph':
      return Locale.tlPH;

    case 'vi-vn':
      return Locale.viVN;

    case 'zh-tw':
      return Locale.zhTW;

    default:
      return Locale.enUS;
  }
};

var combined = _objectSpread({}, enusFooter, enusHeader, enusCommon);
var memo = (_memo = {}, _defineProperty(_memo, 'en-US', combined), _defineProperty(_memo, 'es-US', _objectSpread({}, esusFooter, esusHeader, esusCommon)), _defineProperty(_memo, 'ht-HT', _objectSpread({}, hthtFooter, hthtHeader, hthtCommon)), _defineProperty(_memo, 'il-PH', _objectSpread({}, ilphFooter, ilphHeader, ilphCommon)), _defineProperty(_memo, 'ko-US', _objectSpread({}, kousFooter, kousHeader, kousCommon)), _defineProperty(_memo, 'tl-PH', _objectSpread({}, tlphFooter, tlphHeader, tlphCommon)), _defineProperty(_memo, 'vi-VN', _objectSpread({}, vivnFooter, vivnHeader, vivnCommon)), _defineProperty(_memo, 'zh-TW', _objectSpread({}, zhtwFooter, zhtwHeader, zhtwCommon)), _memo);
var loadTranslations = function loadTranslations(locale) {
  var normalizedLocale = normalizeLocale(locale);
  return memo[normalizedLocale] || {};
};
function getLocale() {
  var urlParams = new urlSearchParams_node(window.location.search);
  return urlParams.get('locale') ? urlParams.get('locale') : '';
}

var Translate = function Translate(_ref) {
  var i18nKey = _ref.i18nKey,
      values = _ref.values;
  return React__default.createElement(NamespacesConsumer, null, function (t) {
    var translated = t(i18nKey, values);
    return React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: translated
      }
    });
  });
};

var Locale;

(function (Locale) {
  Locale["enUS"] = "en-US";
  Locale["esUS"] = "es-US";
  Locale["htHT"] = "ht-HT";
  Locale["ilPH"] = "il-PH";
  Locale["koUS"] = "ko-US";
  Locale["tlPH"] = "tl-PH";
  Locale["viVN"] = "vi-VN";
  Locale["zhTW"] = "zh-TW";
})(Locale || (Locale = {}));

var _React$createContext$3 = React__default.createContext({
  locale: getLocale()
}),
    LocaleConsumer = _React$createContext$3.Consumer,
    LocaleProvider = _React$createContext$3.Provider;

var UnsafeWithConfiguredLink = function UnsafeWithConfiguredLink(props) {
  return React__default.createElement(ProfileConsumer, null, function (_ref) {
    var profile = _ref.profile;
    return React__default.createElement(ProductConsumer, null, function (_ref2) {
      var products = _ref2.products;
      return React__default.createElement(LocaleConsumer, null, function (_ref3) {
        var locale = _ref3.locale;
        return React__default.createElement(UrlConsumer, null, function (_ref4) {
          var baseUrls = _ref4.baseUrls;
          var href;
          var children = props.children,
              dependentProducts = props.dependentProducts,
              getLink = props.getLink;

          if (!getLink) {
            href = '#';
          } else {
            href = getUrl({
              getLink: getLink,
              dependentProducts: dependentProducts
            }, {
              lineOfBusiness: profile ? profile.currentUser.lineOfBusiness : LineOfBusiness.EI,
              baseUrls: baseUrls,
              locale: locale,
              products: products
            });
          }

          return children({
            href: href
          });
        });
      });
    });
  });
};
var WithConfiguredLink = function WithConfiguredLink(_ref5) {
  var children = _ref5.children,
      props = _objectWithoutProperties(_ref5, ["children"]);

  return React__default.createElement(UnsafeWithConfiguredLink, props, function (_ref6) {
    var href = _ref6.href;

    if (href === null) {
      return null;
    }

    return children({
      href: href
    });
  });
};

var ConfiguredAnchor = function ConfiguredAnchor(_ref7) {
  var getLink = _ref7.getLink,
      dependentProducts = _ref7.dependentProducts,
      props = _objectWithoutProperties(_ref7, ["getLink", "dependentProducts"]);

  return React__default.createElement(WithConfiguredLink, {
    getLink: getLink,
    dependentProducts: dependentProducts
  }, function (_ref8) {
    var href = _ref8.href;
    return React__default.createElement("li", null, React__default.createElement(TargetAwareAnchor, _extends({}, props, {
      href: href
    })));
  });
};

var homeLink = function homeLink(_ref) {
  var resources = _ref.resources;
  return resources.HEADER.DASHBOARD;
};

var CurrentLogo = function CurrentLogo(_ref2) {
  var logos = _ref2.logos;
  return createElement(TargetAwareAnchor, {
    className: "logo-container-link"
  }, createElement(BaseLogo, {
    logos: logos
  }));
};

var PhaseTwoLogo = function PhaseTwoLogo(_ref3) {
  var logos = _ref3.logos;
  return createElement(WithConfiguredLink, {
    getLink: homeLink
  }, function (_ref4) {
    var href = _ref4.href;
    return createElement(TargetAwareAnchor, {
      className: "logo-container-link",
      track: "home",
      href: href
    }, createElement(BaseLogo, {
      logos: logos
    }));
  });
};

var BaseLogo = function BaseLogo(_ref5) {
  var logos = _ref5.logos;

  var _logos = _toArray(logos),
      primaryLogo = _logos[0],
      secondaryLogos = _logos.slice(1);

  return createElement(Fragment, null, createElement(PrimaryLogo, primaryLogo), secondaryLogos.map(function (logoProps, i) {
    return createElement(Image, _extends({
      key: i,
      className: "secondary-logo"
    }, logoProps));
  }));
};

var LogoList = function LogoList(_ref6) {
  var logos = _ref6.logos;
  return createElement(FeatureFlagGate, {
    flag: "isHeaderFooterPhaseTwoOn",
    flaggedFeature: createElement(PhaseTwoLogo, {
      logos: logos
    }),
    defaultFeature: createElement(CurrentLogo, {
      logos: logos
    })
  });
};

var ConnectedLogoList = function ConnectedLogoList() {
  return React__default.createElement(ProfileConsumer, null, function (_ref) {
    var profile = _ref.profile;

    if (!profile) {
      return React__default.createElement(LogoList, {
        logos: [defaultLogo]
      });
    }

    var logos = getLogos(profile);
    return React__default.createElement(LogoList, {
      logos: logos
    });
  });
};

var ActiveAnchor = function ActiveAnchor(_ref) {
  var href = _ref.href,
      track = _ref.track,
      props = _objectWithoutProperties(_ref, ["href", "track"]);

  return React__default.createElement(TargetAwareAnchor, _extends({}, props, {
    track: track,
    href: href
  }));
};

var NavLink = function NavLink(_ref) {
  var getLink = _ref.getLink,
      dependentProducts = _ref.dependentProducts,
      track = _ref.track,
      isActive = _ref.isActive,
      props = _objectWithoutProperties(_ref, ["getLink", "dependentProducts", "track", "isActive"]);

  return React__default.createElement(WithConfiguredLink, {
    getLink: getLink,
    dependentProducts: dependentProducts
  }, function (_ref2) {
    var href = _ref2.href;
    var activeNavLinkClass = classnames({
      active: isActive
    });
    return React__default.createElement(ActiveAnchor, _extends({
      className: activeNavLinkClass
    }, props, {
      track: track,
      href: href
    }));
  });
};

var LobPicker = function LobPicker(props) {
  return React__default.createElement(ProfileConsumer, null, function (_ref) {
    var profile = _ref.profile;
    var _props$options = props.options,
        defaultOption = _props$options.defaultOption,
        byLob = _props$options.byLob,
        render = props.render,
        rest = props.rest,
        children = props.children;

    if (!profile) {
      var _finalProps = _extends({}, defaultOption, rest, {
        children: children
      });

      return render(_finalProps);
    }

    var lineOfBusiness = profile.currentUser.lineOfBusiness;
    var selected = byLob[lineOfBusiness] || defaultOption;

    var finalProps = _extends({}, selected, rest, {
      children: children
    });

    return render(finalProps);
  });
};

var claimsTranslationOptions = {
  defaultOption: {
    i18nKey: 'CLAIMS'
  },
  byLob: _defineProperty({}, LineOfBusiness.EI, {
    i18nKey: 'CLAIMS_AND_ACCOUNTS'
  })
};

var getClaimsLink = function getClaimsLink(_ref) {
  var resources = _ref.resources;
  return resources.HEADER.SECURE_CLAIMS_ACCOUNT;
};

var eiGetClaimsLink = function eiGetClaimsLink() {
  return function (_ref2) {
    var arcadeUrl = _ref2.arcadeUrl;
    return "".concat(arcadeUrl, "/claims-and-accounts/summary");
  };
};

var getLinkOptions = {
  defaultOption: {
    getLink: getClaimsLink
  },
  byLob: _defineProperty({}, LineOfBusiness.EI, {
    getLink: eiGetClaimsLink
  })
};
var anchorProps = {
  track: 'claims'
};

var Claims = function Claims(_ref3) {
  var isActive = _ref3.isActive;
  return React__default.createElement(LobPicker, {
    options: getLinkOptions,
    rest: _objectSpread({
      isActive: isActive
    }, anchorProps),
    render: NavLink
  }, React__default.createElement(LobPicker, {
    options: claimsTranslationOptions,
    render: Translate
  }));
};

var isTermedCS = function isTermedCS(currentUser) {
  var medicalCoverage = currentUser && currentUser.planCoverages.find(function (coverage) {
    return coverage.coverageType === CoverageType.Medical;
  });
  var isTermedCS = currentUser && currentUser.lineOfBusiness === LineOfBusiness.CS && medicalCoverage && medicalCoverage.planPeriod.status === CoverageStatus.Termed;
  return !!isTermedCS;
};
var getAllCoverageTypesForStatus = function getAllCoverageTypesForStatus() {
  var coverages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var coverageStatuses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [CoverageStatus.Active];
  var allCoverageTypesOfGivenStatus = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = coverages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var c = _step.value;
      var hasCoverage = coverageStatuses.indexOf(c.planPeriod.status) > -1;

      if (hasCoverage) {
        allCoverageTypesOfGivenStatus.push(c.coverageType);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = c.additionalCoverageTypes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var subCoverageType = _step2.value;
            allCoverageTypesOfGivenStatus.push(subCoverageType);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return allCoverageTypesOfGivenStatus;
};
var hasCoverageMatching = function hasCoverageMatching() {
  var coverages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      coverageTypes = _ref.coverageTypes,
      coverageStatuses = _ref.coverageStatuses,
      coverageTypeCodes = _ref.coverageTypeCodes;

  return coverages.some(function (c) {
    return hasMatch(coverageTypes, c.coverageType) && hasMatch(coverageStatuses, c.planPeriod.status) && hasMatch(coverageTypeCodes, c.coverageTypeCode);
  });
};

function hasMatch(whitelist, actual) {
  return !whitelist || !!(actual && whitelist.indexOf(actual) >= 0);
}

var EligibilityGate = function EligibilityGate(_ref) {
  var children = _ref.children,
      eligibleLobs = _ref.eligibleLobs,
      _ref$predicate = _ref.predicate,
      predicate = _ref$predicate === void 0 ? function () {
    return true;
  } : _ref$predicate,
      _ref$showOnError = _ref.showOnError,
      showOnError = _ref$showOnError === void 0 ? false : _ref$showOnError;
  return React__default.createElement(ProductConsumer, null, function (_ref2) {
    var products = _ref2.products;
    return React__default.createElement(ProfileConsumer, null, function (_ref3) {
      var profile = _ref3.profile;

      if (!profile && !showOnError) {
        return null;
      }

      if (profile && eligibleLobs && eligibleLobs.indexOf(profile.currentUser.lineOfBusiness) === -1) {
        return null;
      }

      if (profile && !predicate({
        profile: profile,
        products: products
      })) {
        return null;
      }

      return children;
    });
  });
};

var formsAndResourcesGetter = function formsAndResourcesGetter(_ref) {
  var resources = _ref.resources;
  return resources.HEADER.FORMS_AND_RESOURCES;
};

var benefitsCoverageGetter = function benefitsCoverageGetter(_ref2) {
  var resources = _ref2.resources;
  return resources.HEADER.SECURE_BENEFITS_COVERAGE;
};

var getCoverageLink = function getCoverageLink(currentUser) {
  if (currentUser && currentUser.lineOfBusiness === LineOfBusiness.MR) {
    if (hasCoverageMatching(currentUser.planCoverages, {
      coverageStatuses: [CoverageStatus.Active, CoverageStatus.Future]
    })) {
      return benefitsCoverageGetter;
    } else {
      return formsAndResourcesGetter;
    }
  }

  return benefitsCoverageGetter;
};

var hasCoverageAndBenefits = function hasCoverageAndBenefits(_ref3) {
  var currentUser = _ref3.profile.currentUser;
  return !isTermedCS(currentUser);
};

var CoverageAndBenefits = function CoverageAndBenefits() {
  return React__default.createElement(ProfileConsumer, null, function (_ref4) {
    var profile = _ref4.profile;
    return React__default.createElement(EligibilityGate, {
      predicate: hasCoverageAndBenefits
    }, React__default.createElement(NavLink, {
      getLink: getCoverageLink(profile && profile.currentUser),
      track: "coverage"
    }, React__default.createElement(Translate, {
      i18nKey: "COVERAGE"
    })));
  });
};

var _sectionsByLineOfBusi;

var arcadeRoute = function arcadeRoute(url) {
  return function (_ref) {
    var arcadeUrl = _ref.arcadeUrl;
    return function () {
      return "".concat(arcadeUrl, "/").concat(url);
    };
  };
};

var ssoRedirect = function ssoRedirect(url, _ref2) {
  var arcadeUrl = _ref2.arcadeUrl;
  var deepLink = encodeURIComponent(url);
  return function () {
    return "".concat(arcadeUrl, "/internal-redirect?deepLink=").concat(deepLink);
  };
}; // This enum is currently order based, do not reorder
// Needs to be changed to string values, but that is a breaking change

var ButtonAction;

(function (ButtonAction) {
  ButtonAction[ButtonAction["openIPerceptionsSurvey"] = 0] = "openIPerceptionsSurvey";
  ButtonAction[ButtonAction["localeChanged"] = 1] = "localeChanged";
  ButtonAction[ButtonAction["toggleNav"] = 2] = "toggleNav";
  ButtonAction[ButtonAction["openProviderDirectory"] = 3] = "openProviderDirectory";
})(ButtonAction || (ButtonAction = {}));

var healthRecord = {
  text: 'HEALTH_RECORD',
  type: LinkItemType.Link,
  dependentProducts: [ProductKey.IndividualHealthRecord],
  getLink: function getLink(props) {
    return ssoRedirect(props.baseUrls.healthRecordUrl, props);
  },
  desktopOnly: true,
  showOnError: false
};
var healthChecklist = {
  text: 'HEALTH_CHECKLIST',
  type: LinkItemType.Link,
  dependentProducts: [ProductKey.RallyConnect],
  getLink: function getLink(props) {
    return ssoRedirect(props.resources.SHARED.HEALTH_CHECKLIST(props), props);
  },
  desktopOnly: true,
  showOnError: false
};
var saved = {
  text: 'SAVED',
  type: LinkItemType.Link,
  dependentProducts: [ProductKey.RallyConnect],
  getLink: function getLink(props) {
    return ssoRedirect(props.resources.SHARED.SAVED(props), props);
  },
  desktopOnly: true,
  showOnError: false
};
var rewards = {
  text: 'REWARDS',
  type: LinkItemType.Link,
  getLink: function getLink(props) {
    return ssoRedirect(props.baseUrls.rewardsUrl, props);
  },
  target: LinkTarget.Blank,
  desktopOnly: true,
  dependentProducts: [ProductKey.RallyEngage],
  showOnError: false
};
var accountSettings = {
  text: 'ACCOUNT_SETTINGS',
  type: LinkItemType.Link,
  getLink: function getLink(_ref3) {
    var resources = _ref3.resources;
    return resources.SHARED.ACCOUNT_SETTINGS;
  },
  desktopOnly: true
};
var messages = {
  text: 'MESSAGES',
  type: LinkItemType.Link,
  getLink: function getLink(_ref4) {
    var resources = _ref4.resources;
    return resources.SHARED.MESSAGES;
  },
  dependentProducts: [ProductKey.SecureMessage],
  target: LinkTarget.Self,
  desktopOnly: true,
  showOnError: false
};
var logout = {
  text: 'LOGOUT',
  type: LinkItemType.Link,
  getLink: arcadeRoute('logout'),
  desktopOnly: true
};
var recommendations = {
  text: 'RECOMMENDATIONS',
  type: LinkItemType.Link,
  getLink: function getLink(_ref5) {
    var resources = _ref5.resources;
    return resources.HEADER.RECOMMENDATION;
  }
};
var phaseTwoSections = [{
  header: 'FTR_IMPORTANT_INFO',
  content: [[{
    text: 'FTR_NOTICES',
    type: LinkItemType.Link,
    getLink: function getLink(_ref6) {
      var resources = _ref6.resources;
      return resources.FOOTER.LEGAL_NOTICES;
    }
  }, {
    text: 'FTR_PROVIDER_DATA_INFO',
    type: LinkItemType.Link,
    getLink: function getLink(_ref7) {
      var resources = _ref7.resources;
      return resources.FOOTER.PROVIDER_DATA_INFO;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LEGAL_ENTITIES',
    type: LinkItemType.Link,
    getLink: function getLink(_ref8) {
      var resources = _ref8.resources;
      return resources.FOOTER.LEGAL_ENTITIES;
    },
    target: LinkTarget.Blank
  }]]
}, {
  header: 'FTR_SUPPORT',
  content: [[{
    text: 'FTR_HELP',
    type: LinkItemType.Link,
    getLink: arcadeRoute('help')
  }, {
    text: 'FTR_SHARE_FEEDBACK',
    type: LinkItemType.Button,
    action: ButtonAction.openIPerceptionsSurvey
  }, {
    text: 'FTR_PROVIDER_DIRECTORY',
    type: LinkItemType.Button,
    action: ButtonAction.openProviderDirectory
  }]]
}, {
  header: 'FTR_ACCESSIBILITY',
  content: [[{
    text: 'FTR_ACCESSIBILITY_STATEMENT',
    type: LinkItemType.Link,
    getLink: function getLink(_ref9) {
      var resources = _ref9.resources;
      return resources.FOOTER.ACCESSIBILITY;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LANGUAGE_ENG',
    type: LinkItemType.Link,
    getLink: function getLink(_ref10) {
      var resources = _ref10.resources;
      return resources.FOOTER.LEGAL.NON_DISCRIMINATION_ENG;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LANGUAGE_SPA',
    type: LinkItemType.Link,
    getLink: function getLink(_ref11) {
      var resources = _ref11.resources;
      return resources.FOOTER.LEGAL.NON_DISCRIMINATION_SPA;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LANGUAGE_CHI',
    type: LinkItemType.Link,
    getLink: function getLink(_ref12) {
      var resources = _ref12.resources;
      return resources.FOOTER.LEGAL.NON_DISCRIMINATION_CHI;
    },
    target: LinkTarget.Blank
  }]]
}];
var sections = [{
  header: 'FTR_MEMBER_SUPPORT',
  content: [[{
    text: 'FTR_HELP',
    type: LinkItemType.Link,
    getLink: arcadeRoute('help')
  }, {
    text: 'FTR_NURSE_LINE',
    type: LinkItemType.Text
  }, {
    text: 'FTR_SHARE_FEEDBACK',
    type: LinkItemType.Button,
    action: ButtonAction.openIPerceptionsSurvey
  }, {
    text: 'FTR_ACCESSIBILITY',
    type: LinkItemType.Link,
    getLink: function getLink(_ref13) {
      var resources = _ref13.resources;
      return resources.FOOTER.ACCESSIBILITY;
    },
    target: LinkTarget.Blank
  }]]
}, {
  header: 'FTR_MEMBER_INFO',
  content: [[{
    text: 'FTR_PROVIDER_DATA_INFO',
    type: LinkItemType.Link,
    getLink: function getLink(_ref14) {
      var resources = _ref14.resources;
      return resources.FOOTER.PROVIDER_DATA_INFO;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LEGAL_ENTITIES',
    type: LinkItemType.Link,
    getLink: function getLink(_ref15) {
      var resources = _ref15.resources;
      return resources.FOOTER.LEGAL_ENTITIES;
    },
    target: LinkTarget.Blank
  }]]
}, {
  header: 'FTR_QUICK_LINKS',
  content: [[accountSettings, healthRecord, healthChecklist, messages], [saved, rewards, logout]]
}];
var mrSections = [{
  header: 'FTR_MEMBER_SUPPORT',
  content: [[{
    text: 'FTR_HELP',
    type: LinkItemType.Link,
    getLink: function getLink(_ref16) {
      var resources = _ref16.resources;
      return resources.SHARED.HELP;
    }
  }, {
    text: 'FTR_LEGAL_NOTICES',
    type: LinkItemType.Link,
    getLink: function getLink(_ref17) {
      var resources = _ref17.resources;
      return resources.FOOTER.LEGAL_NOTICES;
    }
  }, {
    text: 'FTR_ACCESSIBILITY',
    type: LinkItemType.Link,
    getLink: function getLink(_ref18) {
      var resources = _ref18.resources;
      return resources.FOOTER.ACCESSIBILITY;
    },
    target: LinkTarget.Blank
  }]]
}, {
  header: 'FTR_QUICK_LINKS',
  content: [[{
    text: 'ACCOUNT_SETTINGS',
    type: LinkItemType.Link,
    getLink: function getLink(_ref19) {
      var resources = _ref19.resources;
      return resources.SHARED.ACCOUNT_SETTINGS;
    },
    desktopOnly: true
  }, messages, saved, logout]]
}];
var csSections = [{
  header: 'FTR_IMPORTANT_INFO',
  content: [[{
    text: 'FTR_NOTICES',
    type: LinkItemType.Link,
    getLink: function getLink(_ref20) {
      var resources = _ref20.resources;
      return resources.FOOTER.LEGAL_NOTICES;
    }
  }, {
    text: 'FTR_LEGAL_ENTITIES',
    type: LinkItemType.Link,
    getLink: function getLink(_ref21) {
      var resources = _ref21.resources;
      return resources.FOOTER.LEGAL_ENTITIES;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_PROVIDER_DATA_INFO',
    type: LinkItemType.Link,
    getLink: function getLink(_ref22) {
      var resources = _ref22.resources;
      return resources.FOOTER.PROVIDER_DATA_INFO;
    },
    target: LinkTarget.Blank
  }]]
}, {
  header: 'FTR_SUPPORT',
  content: [[{
    text: 'FTR_HELP',
    type: LinkItemType.Link,
    getLink: arcadeRoute('help')
  }, {
    text: 'FTR_SHARE_FEEDBACK',
    type: LinkItemType.Button,
    action: ButtonAction.openIPerceptionsSurvey
  }]]
}, {
  header: 'FTR_ACCESSIBILITY',
  content: [[{
    text: 'FTR_ACCESSIBILITY_STATEMENT',
    type: LinkItemType.Link,
    getLink: function getLink(_ref23) {
      var resources = _ref23.resources;
      return resources.FOOTER.ACCESSIBILITY;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LANGUAGE_ENG',
    type: LinkItemType.Link,
    getLink: function getLink(_ref24) {
      var resources = _ref24.resources;
      return resources.FOOTER.LEGAL.NON_DISCRIMINATION_ENG;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LANGUAGE_SPA',
    type: LinkItemType.Link,
    getLink: function getLink(_ref25) {
      var resources = _ref25.resources;
      return resources.FOOTER.LEGAL.NON_DISCRIMINATION_SPA;
    },
    target: LinkTarget.Blank
  }, {
    text: 'FTR_LANGUAGE_CHI',
    type: LinkItemType.Link,
    getLink: function getLink(_ref26) {
      var resources = _ref26.resources;
      return resources.FOOTER.LEGAL.NON_DISCRIMINATION_CHI;
    },
    target: LinkTarget.Blank
  }]]
}, {
  header: 'FTR_FOLLOW_US',
  content: [[{
    text: 'FTR_FACEBOOK',
    type: LinkItemType.Link,
    getLink: function getLink(_ref27) {
      var resources = _ref27.resources;
      return resources.FOOTER.FACEBOOK;
    },
    target: LinkTarget.Blank
  }]]
}];
var sectionsByLineOfBusiness = (_sectionsByLineOfBusi = {}, _defineProperty(_sectionsByLineOfBusi, LineOfBusiness.CS, csSections), _defineProperty(_sectionsByLineOfBusi, LineOfBusiness.EI, sections), _defineProperty(_sectionsByLineOfBusi, LineOfBusiness.MR, mrSections), _sectionsByLineOfBusi);

var findCareTranslations = {
  defaultOption: {
    i18nKey: 'FIND_CARE_COST'
  },
  byLob: _defineProperty({}, LineOfBusiness.CS, {
    i18nKey: 'FIND_CARE'
  })
};
var fpcCoverageTypeCodes = [CoverageTypeCode.MA, CoverageTypeCode.MAPD, CoverageTypeCode.PDP];
var findCostEligibleStates = [State.IA, State.KS, State.LA, State.MI, State.MS, State.NE, State.NY, State.OH, State.PA, State.TN];

var hasFindCare = function hasFindCare(_ref) {
  var currentUser = _ref.profile.currentUser;

  if (currentUser.lineOfBusiness === LineOfBusiness.MR) {
    return currentUser.memberFeatures.fpcEligible && currentUser.planCoverages.some(function (cov) {
      return cov.planPeriod.status !== CoverageStatus.Termed && !!cov.coverageTypeCode && fpcCoverageTypeCodes.indexOf(cov.coverageTypeCode) >= 0;
    });
  } else {
    return currentUser.memberFeatures.fpcEligible && hasCoverageMatching(currentUser.planCoverages, {
      coverageTypes: [CoverageType.Medical, CoverageType.Rx],
      coverageStatuses: [CoverageStatus.Active, CoverageStatus.Future]
    });
  }
};

var isCsCostTransparent = function isCsCostTransparent(currentUser) {
  return currentUser.planCoverages.some(function (plan) {
    return findCostEligibleStates.some(function (state) {
      return state === plan.additionalCoverageInfo.situsState;
    });
  });
};

var hasTypeCodeMA = function hasTypeCodeMA(currentUser) {
  var planCoverages = currentUser.planCoverages;
  return hasCoverageMatching(planCoverages, {
    coverageTypeCodes: [CoverageTypeCode.MA]
  });
};

var mrGetLinkExternal = function mrGetLinkExternal() {
  return function (_ref2) {
    var myUhcBaseUrl = _ref2.myUhcBaseUrl;
    return "".concat(myUhcBaseUrl, "/medicare/find-care");
  };
};

var mrGetLink = function mrGetLink() {
  return function (_ref3) {
    var arcadeUrl = _ref3.arcadeUrl;
    return "".concat(arcadeUrl, "/find-care");
  };
};

var getLink = function getLink() {
  return function (props) {
    return ssoRedirect(props.resources.HEADER.EXT_FIND_CARE(props), props)();
  };
};

var getLinkOptions$1 = {
  defaultOption: {
    getLink: getLink
  },
  byLob: _defineProperty({}, LineOfBusiness.MR, {
    getLink: mrGetLink
  })
};
var anchorProps$1 = {
  track: 'find-care'
};

var CsLink = function CsLink(_ref4) {
  var isActive = _ref4.isActive;
  return React__default.createElement(ProfileConsumer, null, function (_ref5) {
    var profile = _ref5.profile;

    if (!profile) {
      return null;
    }

    var csTranslationKey = isCsCostTransparent(profile.currentUser) ? 'FIND_CARE_COST' : 'FIND_CARE';
    return React__default.createElement(NavLink, {
      getLink: getLink,
      track: anchorProps$1.track,
      isActive: isActive
    }, React__default.createElement(Translate, {
      i18nKey: csTranslationKey
    }));
  });
};

var MrLink = function MrLink(_ref6) {
  var isActive = _ref6.isActive;
  return React__default.createElement(ProfileConsumer, null, function (_ref7) {
    var profile = _ref7.profile;

    if (!profile) {
      return null;
    }

    var link = hasTypeCodeMA(profile.currentUser) ? mrGetLink : mrGetLinkExternal;
    var mrTranslationKey = hasTypeCodeMA(profile.currentUser) ? 'FIND_CARE' : 'FIND_CARE_COST';
    return React__default.createElement(NavLink, {
      getLink: link,
      track: anchorProps$1.track,
      isActive: isActive
    }, React__default.createElement(Translate, {
      i18nKey: mrTranslationKey
    }));
  });
};

var EiText = function EiText() {
  return React__default.createElement(ProfileConsumer, null, function (_ref8) {
    var profile = _ref8.profile;

    if (!profile) {
      return null;
    }

    return React__default.createElement(Translate, {
      i18nKey: eiTranslationKey(profile.currentUser.membershipCategory)
    });
  });
};

var eiTranslationKey = function eiTranslationKey(membershipCategory) {
  return membershipCategory === MembershipCategory.EMPIRE || membershipCategory === MembershipCategory.UHC_WEST ? 'FIND_CARE' : 'FIND_CARE_COST';
};

var FindCareByCoverageType = function FindCareByCoverageType(_ref9) {
  var isActive = _ref9.isActive;
  return React__default.createElement(EligibilityGate, {
    predicate: hasFindCare
  }, React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.EI]
  }, React__default.createElement(NavLink, {
    getLink: getLink,
    track: anchorProps$1.track,
    isActive: isActive
  }, React__default.createElement(EiText, null))), React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.CS]
  }, React__default.createElement(CsLink, {
    isActive: isActive
  })), React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.MR]
  }, React__default.createElement(MrLink, {
    isActive: isActive
  })));
};

var FindCareDefault = function FindCareDefault(_ref10) {
  var isActive = _ref10.isActive;
  return React__default.createElement(EligibilityGate, {
    predicate: hasFindCare
  }, React__default.createElement(LobPicker, {
    options: getLinkOptions$1,
    rest: _objectSpread({
      isActive: isActive
    }, anchorProps$1),
    render: NavLink
  }, React__default.createElement(LobPicker, {
    options: findCareTranslations,
    render: Translate
  })));
};

var FindCare = function FindCare(_ref11) {
  var isActive = _ref11.isActive;
  return React__default.createElement(FeatureFlagGate, {
    flag: "isHeaderFooterPhaseTwoOn",
    flaggedFeature: React__default.createElement(FindCareByCoverageType, {
      isActive: isActive
    }),
    defaultFeature: React__default.createElement(FindCareDefault, {
      isActive: isActive
    })
  });
};

var getLink$1 = function getLink() {
  return function (_ref) {
    var arcadeUrl = _ref.arcadeUrl;
    return "".concat(arcadeUrl, "/health-resources");
  };
};

var HealthResources = function HealthResources(_ref2) {
  var isActive = _ref2.isActive;
  return React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.EI]
  }, React__default.createElement(NavLink, {
    getLink: getLink$1,
    track: "health-resources",
    isActive: isActive
  }, React__default.createElement(Translate, {
    i18nKey: "HEALTH_RESOURCES"
  })));
};

var isEligibleForWellness = function isEligibleForWellness(_ref) {
  var currentUser = _ref.profile.currentUser;
  return currentUser.lineOfBusiness === LineOfBusiness.CS && !isTermedCS(currentUser) || hasCoverageMatching(currentUser.planCoverages, {
    coverageStatuses: [CoverageStatus.Active, CoverageStatus.Future]
  });
};

var translationOptions = {
  defaultOption: {
    i18nKey: 'HEALTH'
  },
  byLob: _defineProperty({}, LineOfBusiness.MR, {
    i18nKey: 'HEALTH_WELLNESS'
  })
};

var getLink$2 = function getLink(_ref2) {
  var resources = _ref2.resources;
  return resources.HEADER.HEALTH;
};

var HealthWellness = function HealthWellness() {
  return React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.CS, LineOfBusiness.MR],
    predicate: isEligibleForWellness
  }, React__default.createElement(NavLink, {
    getLink: getLink$2,
    track: "health-wellness"
  }, React__default.createElement(LobPicker, {
    options: translationOptions,
    render: Translate
  })));
};

var getLink$3 = function getLink(_ref) {
  var resources = _ref.resources;
  return resources.HEADER.DASHBOARD;
};

var Home = function Home(_ref2) {
  var isActive = _ref2.isActive;
  return React__default.createElement(NavLink, {
    getLink: getLink$3,
    track: "home",
    isActive: isActive
  }, React__default.createElement(Translate, {
    i18nKey: "HOME"
  }));
};

var FeatureConfigContext = React__default.createContext({});
var FeatureConfigProvider = FeatureConfigContext.Provider,
    FeatureConfigConsumer = FeatureConfigContext.Consumer;

var getLink$4 = function getLink(_ref) {
  var resources = _ref.resources;
  return resources.HEADER.SECURE_PHARMACIES_PRESCRIPTIONS;
};

var getRallyRxLink = function getRallyRxLink() {
  return function (props) {
    return ssoRedirect(props.resources.HEADER.RALLY_RX(props), props)();
  };
};

var shouldShowPharmacy = function shouldShowPharmacy(_ref2) {
  var currentUser = _ref2.profile.currentUser,
      products = _ref2.products;
  var allActiveCoverageTypes = getAllCoverageTypesForStatus(currentUser.planCoverages, [CoverageStatus.Active]);
  return allActiveCoverageTypes.some(function (coverageType) {
    return coverageType === CoverageType.Rx;
  }) && !!products.rx && !isTermedCS(currentUser);
};

var isRallyRxEligible = function isRallyRxEligible(isRallyRxOn) {
  var rallyRxPolicies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var primaryPolicyNumber = arguments.length > 2 ? arguments[2] : undefined;
  return isRallyRxOn || primaryPolicyNumber !== undefined && rallyRxPolicies.split(',').indexOf(primaryPolicyNumber) !== -1;
};

var CsPharmacies = function CsPharmacies() {
  return React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.CS]
  }, React__default.createElement(NavLink, {
    getLink: getLink$4,
    track: "pharmacies"
  }, React__default.createElement(Translate, {
    i18nKey: "PHARMACIES"
  })));
};

var EiPharmacies = function EiPharmacies(_ref3) {
  var isActive = _ref3.isActive;
  return React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.EI]
  }, React__default.createElement(FeatureFlagConsumer, null, function (_ref4) {
    var isRallyRxOn = _ref4.isRallyRxOn;
    return React__default.createElement(FeatureConfigConsumer, null, function (_ref5) {
      var rallyRxPolicies = _ref5.rallyRxPolicies;
      return React__default.createElement(ProfileConsumer, null, function (_ref6) {
        var profile = _ref6.profile;
        var primaryPolicyNumber = profile && profile.currentUser.primaryPolicyNumber || undefined;
        var eiPharmacyLink = isRallyRxEligible(isRallyRxOn, rallyRxPolicies, primaryPolicyNumber) ? getRallyRxLink : getLink$4;
        return React__default.createElement(NavLink, {
          getLink: eiPharmacyLink,
          track: "pharmacies",
          isActive: isActive
        }, React__default.createElement(Translate, {
          i18nKey: "PHARMACIES"
        }));
      });
    });
  }));
};

var Pharmacies = function Pharmacies(_ref7) {
  var isActive = _ref7.isActive;
  return (// CsPharmacies currently routes to an external URL, so the tab could not be active
    React__default.createElement(EligibilityGate, {
      predicate: shouldShowPharmacy
    }, React__default.createElement(EiPharmacies, {
      isActive: isActive
    }), React__default.createElement(CsPharmacies, null))
  );
};

var _byLob;
var options = {
  defaultOption: {
    getLink: function getLink(_ref) {
      var resources = _ref.resources;
      return resources.HEADER.PREMIUM_PAYMENTS;
    }
  },
  byLob: (_byLob = {}, _defineProperty(_byLob, LineOfBusiness.MR, {
    getLink: function getLink(_ref2) {
      var resources = _ref2.resources;
      return resources.HEADER.PREMIUM_PAYMENTS;
    }
  }), _defineProperty(_byLob, LineOfBusiness.CS, {
    getLink: function getLink() {
      return function (_ref3) {
        var arcadeUrl = _ref3.arcadeUrl;
        return "".concat(arcadeUrl, "/premium-payments");
      };
    }
  }), _byLob)
};

var showPremiumPayments = function showPremiumPayments(_ref4) {
  var currentUser = _ref4.profile.currentUser;
  var premiumPaymentEligible = currentUser.memberFeatures.premiumPaymentEligible;
  var meetsCoverageRequirements = currentUser.lineOfBusiness !== LineOfBusiness.MR || currentUser.planCoverages.some(function (c) {
    return c.planPeriod.status === CoverageStatus.Active || c.planPeriod.status === CoverageStatus.Future;
  });
  var isEIExchangeMember = currentUser.membershipCategory === MembershipCategory.EXCHANGE || currentUser.membershipCategory === MembershipCategory.PUBLIC_EXCHANGE;
  return premiumPaymentEligible && (currentUser.lineOfBusiness === LineOfBusiness.EI ? isEIExchangeMember : meetsCoverageRequirements);
};

var PremiumPayments = function PremiumPayments() {
  return React__default.createElement(EligibilityGate, {
    predicate: showPremiumPayments
  }, React__default.createElement(LobPicker, {
    options: options,
    render: PremiumPaymentsNavLink
  }));
};

var PremiumPaymentsNavLink = function PremiumPaymentsNavLink(props) {
  return React__default.createElement(NavLink, _extends({}, props, {
    track: "premium-payments"
  }), React__default.createElement(Translate, {
    i18nKey: "PREMIUM_PAYMENTS"
  }));
};

var Feature = function Feature(_ref) {
  var feature = _ref.feature,
      children = _ref.children;
  return React__default.createElement(FeatureConsumer, null, function (value) {
    return React__default.createElement(FeatureProvider, {
      value: {
        features: _toConsumableArray(value.features).concat([feature])
      }
    }, children);
  });
};

var StickyContext = React__default.createContext({
  addSticky: function addSticky() {
    return undefined;
  },
  removeSticky: function removeSticky() {
    return undefined;
  },
  totalHeight: 0,
  stickyMap: new Map()
});
var StickyProvider = StickyContext.Provider,
    StickyConsumer = StickyContext.Consumer;

var InnerSticky =
/*#__PURE__*/
function (_Component) {
  _inherits(InnerSticky, _Component);

  function InnerSticky() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, InnerSticky);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InnerSticky)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      stickyFixed: false,
      initialOffset: undefined
    }, _this.stickyRef = React__default.createRef(), _this.addOrRemoveStickyFixed = function () {
      var current = _this.stickyRef.current;

      if (!current) {
        return;
      }

      var stickyProps = _this.getStickyProps();

      var extraYOffset = stickyProps && stickyProps.height || 0;
      var yPos = _this.state.initialOffset || current.offsetTop;

      if (yPos < window.pageYOffset + extraYOffset) {
        _this.setState({
          initialOffset: yPos,
          stickyFixed: true
        });
      } else {
        _this.setState({
          initialOffset: undefined,
          stickyFixed: false
        });
      }
    }, _this.onScroll = function () {
      _this.addOrRemoveStickyFixed();
    }, _this.getStickyProps = function () {
      var current = _this.stickyRef.current;

      if (!current) {
        return undefined;
      }

      return _this.props.stickyContext.stickyMap.get(current);
    }, _temp));
  }

  _createClass(InnerSticky, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var current = this.stickyRef.current;

      if (!current) {
        return;
      }

      window.addEventListener('scroll', this.onScroll);
      this.props.stickyContext.addSticky(current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll);
      var current = this.stickyRef.current;

      if (current) {
        this.props.stickyContext.removeSticky(current);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var stickyFixed = this.state.stickyFixed;
      var stickyProps = this.getStickyProps();
      var className = classnames({
        'sticky-fixed': stickyFixed
      });
      var style = stickyFixed ? {
        top: stickyProps && stickyProps.height || 0,
        position: 'fixed',
        width: '100%',
        zIndex: 2
      } : {};
      return React__default.createElement("div", {
        ref: this.stickyRef,
        className: className,
        style: style
      }, children);
    }
  }]);

  return InnerSticky;
}(Component);
var Sticky = function Sticky(props) {
  return React__default.createElement(StickyConsumer, null, function (value) {
    return React__default.createElement(InnerSticky, _extends({}, props, {
      stickyContext: value
    }));
  });
};

var StickyManager =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(StickyManager, _PureComponent);

  function StickyManager() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, StickyManager);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(StickyManager)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      stickies: []
    }, _this.onResize = function () {
      _this.forceUpdate();
    }, _this.addSticky = function (sticky) {
      var currentStickies = _this.state.stickies;

      if (currentStickies.indexOf(sticky) >= 0) {
        return;
      }

      _this.setState(function (_ref) {
        var stickies = _ref.stickies;
        var beforeStickies = stickies;
        var afterStickies = [];
        var insertIndex = stickies.findIndex(function (currentSticky) {
          return !!(sticky.compareDocumentPosition(currentSticky) & Node.DOCUMENT_POSITION_FOLLOWING);
        });

        if (insertIndex !== -1) {
          beforeStickies = stickies.slice(0, insertIndex);
          afterStickies = stickies.slice(insertIndex);
        }

        var newStickies = _toConsumableArray(beforeStickies).concat([sticky], _toConsumableArray(afterStickies));

        return {
          stickies: newStickies
        };
      });
    }, _this.removeSticky = function (sticky) {
      var newStickies = _this.state.stickies.filter(function (s) {
        return s === sticky;
      });

      _this.setState({
        stickies: newStickies
      });
    }, _temp));
  }

  _createClass(StickyManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('resize', this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var stickyPairs = this.state.stickies.reduce(function (_ref2, value) {
        var totalHeight = _ref2.totalHeight,
            stickyMap = _ref2.stickyMap;
        return {
          totalHeight: totalHeight + value.clientHeight,
          stickyMap: stickyMap.set(value, {
            height: totalHeight
          })
        };
      }, {
        totalHeight: 0,
        stickyMap: new Map()
      });
      return React__default.createElement(StickyProvider, {
        value: _objectSpread({
          addSticky: this.addSticky,
          removeSticky: this.removeSticky
        }, stickyPairs)
      }, children);
    }
  }]);

  return StickyManager;
}(PureComponent);

var StickyHeaderNav = function StickyHeaderNav() {
  return React__default.createElement(ProfileConsumer, null, function (_ref) {
    var profile = _ref.profile;

    if (!profile) {
      return null;
    }

    return React__default.createElement("div", {
      style: {
        height: '50px'
      }
    }, React__default.createElement(Sticky, null, React__default.createElement("div", {
      id: "sticky-nav",
      className: "nav-ready"
    }, React__default.createElement("nav", {
      id: "main-nav"
    }, React__default.createElement("div", {
      className: "container"
    }, React__default.createElement("div", {
      className: "fluid-nav"
    }, React__default.createElement(UrlConsumer, null, function (_ref2) {
      var baseUrls = _ref2.baseUrls;
      return React__default.createElement(NavLinks, {
        baseUrls: baseUrls
      });
    })))))));
  });
};
var HeaderNav = function HeaderNav() {
  return React__default.createElement(ProfileConsumer, null, function (_ref3) {
    var profile = _ref3.profile;

    if (!profile) {
      return null;
    }

    return React__default.createElement("nav", {
      id: "main-nav"
    }, React__default.createElement(UrlConsumer, null, function (_ref4) {
      var baseUrls = _ref4.baseUrls;
      return React__default.createElement(NavLinks, {
        baseUrls: baseUrls
      });
    }));
  });
};
var getActiveNavTab = function getActiveNavTab(baseUrls, windowLocation) {
  var connectUrlAnchor = parseUrl(baseUrls.connectUrl);
  var isConnectUrl = windowLocation.hostname === connectUrlAnchor.hostname;
  var arcadeUrlAnchor = parseUrl(baseUrls.arcadeUrl);
  var isArcadeUrl = windowLocation.hostname === arcadeUrlAnchor.hostname;

  if (isConnectUrl) {
    return {
      isFindCareActive: true
    };
  } else if (isArcadeUrl) {
    if (windowLocation.pathname.indexOf('dashboard') !== -1) {
      return {
        isHomeActive: true
      };
    } else if (windowLocation.pathname.indexOf('find-care') !== -1) {
      return {
        isFindCareActive: true
      };
    } else if (windowLocation.pathname.indexOf('claims-and-accounts') !== -1) {
      return {
        isClaimsActive: true
      };
    } else if (windowLocation.pathname.indexOf('premium-payments') !== -1) {
      return {
        isPremiumPaymentsActive: true
      };
    } else if (windowLocation.pathname.indexOf('pharmacy') !== -1) {
      return {
        isPharmacyActive: true
      };
    } else if (windowLocation.pathname.indexOf('health-resources') !== -1) {
      return {
        isHealthResourcesActive: true
      };
    }
  }

  return {};
};
var initialNavLinksState = {
  isHomeActive: false,
  isFindCareActive: false,
  isClaimsActive: false,
  isPremiumPaymentsActive: false,
  isPharmacyActive: false,
  isHealthResourcesActive: false
};

var NavLinks =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavLinks, _React$Component);

  function NavLinks() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, NavLinks);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NavLinks)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = _objectSpread({}, initialNavLinksState), _this.setActiveNavTab = function () {
      var currentActiveTabState = _extends({}, initialNavLinksState, getActiveNavTab(_this.props.baseUrls, window.location));

      _this.setState(currentActiveTabState);
    }, _temp));
  }

  _createClass(NavLinks, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setActiveNavTab();
      document.addEventListener('arcadeStateChange', this.setActiveNavTab);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('arcadeStateChange', this.setActiveNavTab);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isHomeActive = _this$state.isHomeActive,
          isFindCareActive = _this$state.isFindCareActive,
          isClaimsActive = _this$state.isClaimsActive,
          isPremiumPaymentsActive = _this$state.isPremiumPaymentsActive,
          isPharmacyActive = _this$state.isPharmacyActive,
          isHealthResourcesActive = _this$state.isHealthResourcesActive;
      return React__default.createElement(Feature, {
        feature: "mainNav"
      }, React__default.createElement("div", null, React__default.createElement(Home, {
        isActive: isHomeActive
      }), React__default.createElement(FindCare, {
        isActive: isFindCareActive
      }), React__default.createElement(Claims, {
        isActive: isClaimsActive
      }), React__default.createElement(CoverageAndBenefits, null), React__default.createElement(PremiumPayments, {
        isActive: isPremiumPaymentsActive
      }), React__default.createElement(Pharmacies, {
        isActive: isPharmacyActive
      }), React__default.createElement(HealthWellness, null), React__default.createElement(HealthResources, {
        isActive: isHealthResourcesActive
      })));
    }
  }]);

  return NavLinks;
}(React__default.Component);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".arcade-chrome-root *,\n.arcade-chrome-root *:before,\n.arcade-chrome-root *:after {\n  box-sizing: border-box;\n}\n.arcade-chrome-root html,\n.arcade-chrome-root body,\n.arcade-chrome-root div,\n.arcade-chrome-root span,\n.arcade-chrome-root applet,\n.arcade-chrome-root object,\n.arcade-chrome-root iframe,\n.arcade-chrome-root h1,\n.arcade-chrome-root h2,\n.arcade-chrome-root h3,\n.arcade-chrome-root h4,\n.arcade-chrome-root h5,\n.arcade-chrome-root h6,\n.arcade-chrome-root p,\n.arcade-chrome-root blockquote,\n.arcade-chrome-root pre,\n.arcade-chrome-root a,\n.arcade-chrome-root abbr,\n.arcade-chrome-root acronym,\n.arcade-chrome-root address,\n.arcade-chrome-root big,\n.arcade-chrome-root cite,\n.arcade-chrome-root code,\n.arcade-chrome-root del,\n.arcade-chrome-root dfn,\n.arcade-chrome-root em,\n.arcade-chrome-root img,\n.arcade-chrome-root ins,\n.arcade-chrome-root kbd,\n.arcade-chrome-root q,\n.arcade-chrome-root s,\n.arcade-chrome-root samp,\n.arcade-chrome-root small,\n.arcade-chrome-root strike,\n.arcade-chrome-root strong,\n.arcade-chrome-root sub,\n.arcade-chrome-root sup,\n.arcade-chrome-root tt,\n.arcade-chrome-root var,\n.arcade-chrome-root b,\n.arcade-chrome-root u,\n.arcade-chrome-root i,\n.arcade-chrome-root center,\n.arcade-chrome-root dl,\n.arcade-chrome-root dt,\n.arcade-chrome-root dd,\n.arcade-chrome-root ol,\n.arcade-chrome-root ul,\n.arcade-chrome-root li,\n.arcade-chrome-root fieldset,\n.arcade-chrome-root form,\n.arcade-chrome-root label,\n.arcade-chrome-root legend,\n.arcade-chrome-root table,\n.arcade-chrome-root caption,\n.arcade-chrome-root tbody,\n.arcade-chrome-root tfoot,\n.arcade-chrome-root thead,\n.arcade-chrome-root tr,\n.arcade-chrome-root th,\n.arcade-chrome-root td,\n.arcade-chrome-root article,\n.arcade-chrome-root aside,\n.arcade-chrome-root canvas,\n.arcade-chrome-root details,\n.arcade-chrome-root embed,\n.arcade-chrome-root figure,\n.arcade-chrome-root figcaption,\n.arcade-chrome-root footer,\n.arcade-chrome-root header,\n.arcade-chrome-root hgroup,\n.arcade-chrome-root menu,\n.arcade-chrome-root nav,\n.arcade-chrome-root output,\n.arcade-chrome-root ruby,\n.arcade-chrome-root section,\n.arcade-chrome-root summary,\n.arcade-chrome-root time,\n.arcade-chrome-root mark,\n.arcade-chrome-root audio,\n.arcade-chrome-root video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n.arcade-chrome-root article,\n.arcade-chrome-root aside,\n.arcade-chrome-root details,\n.arcade-chrome-root figcaption,\n.arcade-chrome-root figure,\n.arcade-chrome-root footer,\n.arcade-chrome-root header,\n.arcade-chrome-root hgroup,\n.arcade-chrome-root menu,\n.arcade-chrome-root nav,\n.arcade-chrome-root section {\n  display: block;\n}\n.arcade-chrome-root body {\n  line-height: 1;\n}\n.arcade-chrome-root ol,\n.arcade-chrome-root ul {\n  list-style: none;\n}\n.arcade-chrome-root blockquote,\n.arcade-chrome-root q {\n  quotes: none;\n}\n.arcade-chrome-root blockquote:before,\n.arcade-chrome-root blockquote:after,\n.arcade-chrome-root q:before,\n.arcade-chrome-root q:after {\n  content: \"\";\n  content: none;\n}\n.arcade-chrome-root table {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n.arcade-chrome-root html {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\n.arcade-chrome-root body {\n  margin: 0;\n}\n.arcade-chrome-root article,\n.arcade-chrome-root aside,\n.arcade-chrome-root footer,\n.arcade-chrome-root header,\n.arcade-chrome-root nav,\n.arcade-chrome-root section {\n  display: block;\n}\n.arcade-chrome-root h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n.arcade-chrome-root figcaption,\n.arcade-chrome-root figure,\n.arcade-chrome-root main {\n  display: block;\n}\n.arcade-chrome-root figure {\n  margin: 1em 40px;\n}\n.arcade-chrome-root hr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n.arcade-chrome-root pre {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n.arcade-chrome-root a {\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\n.arcade-chrome-root a:active,\n.arcade-chrome-root a:hover {\n  outline-width: 0;\n}\n.arcade-chrome-root abbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\n.arcade-chrome-root b,\n.arcade-chrome-root strong {\n  font-weight: inherit;\n}\n.arcade-chrome-root b,\n.arcade-chrome-root strong {\n  font-weight: bolder;\n}\n.arcade-chrome-root code,\n.arcade-chrome-root kbd,\n.arcade-chrome-root samp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\n.arcade-chrome-root dfn {\n  font-style: italic;\n}\n.arcade-chrome-root mark {\n  background-color: #ff0;\n  color: #000;\n}\n.arcade-chrome-root small {\n  font-size: 80%;\n}\n.arcade-chrome-root sub,\n.arcade-chrome-root sup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n.arcade-chrome-root sub {\n  bottom: -0.25em;\n}\n.arcade-chrome-root sup {\n  top: -0.5em;\n}\n.arcade-chrome-root audio,\n.arcade-chrome-root video {\n  display: inline-block;\n}\n.arcade-chrome-root audio:not([controls]) {\n  display: none;\n  height: 0;\n}\n.arcade-chrome-root img {\n  border-style: none;\n}\n.arcade-chrome-root svg:not(:root) {\n  overflow: hidden;\n}\n.arcade-chrome-root button,\n.arcade-chrome-root input,\n.arcade-chrome-root optgroup,\n.arcade-chrome-root select,\n.arcade-chrome-root textarea {\n  font-family: sans-serif;\n  font-size: 100%;\n  line-height: 1.15;\n  margin: 0;\n}\n.arcade-chrome-root button,\n.arcade-chrome-root input {\n  overflow: visible;\n}\n.arcade-chrome-root button,\n.arcade-chrome-root select {\n  text-transform: none;\n}\n.arcade-chrome-root button,\n.arcade-chrome-root html [type=\"button\"],\n.arcade-chrome-root [type=\"reset\"],\n.arcade-chrome-root [type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n.arcade-chrome-root [type=\"button\"]::-moz-focus-inner,\n.arcade-chrome-root [type=\"reset\"]::-moz-focus-inner,\n.arcade-chrome-root [type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\nbutton:-moz-focusring,\n.arcade-chrome-root [type=\"button\"]:-moz-focusring,\n.arcade-chrome-root [type=\"reset\"]:-moz-focusring,\n.arcade-chrome-root [type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n.arcade-chrome-root fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\n.arcade-chrome-root legend {\n  box-sizing: border-box;\n  color: inherit;\n  display: table;\n  max-width: 100%;\n  padding: 0;\n  white-space: normal;\n}\n.arcade-chrome-root progress {\n  display: inline-block;\n  vertical-align: baseline;\n}\n.arcade-chrome-root textarea {\n  overflow: auto;\n}\n.arcade-chrome-root [type=\"checkbox\"],\n.arcade-chrome-root [type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n.arcade-chrome-root [type=\"number\"]::-webkit-inner-spin-button,\n.arcade-chrome-root [type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n.arcade-chrome-root [type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n.arcade-chrome-root [type=\"search\"]::-webkit-search-cancel-button,\n.arcade-chrome-root [type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n.arcade-chrome-root ::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\n.arcade-chrome-root details,\n.arcade-chrome-root menu {\n  display: block;\n}\n.arcade-chrome-root summary {\n  display: list-item;\n}\n.arcade-chrome-root canvas {\n  display: inline-block;\n}\n.arcade-chrome-root template {\n  display: none;\n}\n.arcade-chrome-root [hidden] {\n  display: none;\n}\n.arcade-chrome-root button,\n.arcade-chrome-root [type=\"button\"],\n.arcade-chrome-root [type=\"reset\"],\n.arcade-chrome-root [type=\"submit\"] {\n  cursor: pointer;\n}\n.arcade-chrome-root [disabled] {\n  cursor: default;\n}\n.arcade-chrome-root {\n  background-color: #f6f6f6;\n  color: #2d2d39;\n  font-family: 'uhc-sans', \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.arcade-chrome-root *:focus {\n  outline: 5px solid #a2cb4c !important;\n}\n.arcade-chrome-root a,\n.arcade-chrome-root a:visited {\n  color: #196ecf;\n  text-decoration: none;\n  -webkit-transition: color 0.4s, border-bottom-color 0.4s, background-color 0.4s;\n  transition: color 0.4s, border-bottom-color 0.4s, background-color 0.4s;\n}\n.arcade-chrome-root a:hover,\n.arcade-chrome-root a:visited:hover {\n  border-color: #115fa0;\n  color: #115fa0;\n}\n.arcade-chrome-root fieldset {\n  border: 0;\n  margin: 0;\n  outline: 0;\n  padding: 0;\n}\n.arcade-chrome-root input[type=\"radio\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  display: inline-block;\n  font-size: 1.5em;\n  height: 1em;\n  margin-right: 0.2em;\n  overflow: hidden;\n  vertical-align: middle;\n  visibility: hidden;\n  width: 1em;\n}\n.arcade-chrome-root input[type=\"radio\"]:checked {\n  background: #196ecf;\n}\n.arcade-chrome-root input[type=\"radio\"]:checked + label:before {\n  background: #196ecf;\n}\n.arcade-chrome-root input[type=\"radio\"] + label {\n  color: #196ecf;\n  position: relative;\n  vertical-align: middle;\n}\n.arcade-chrome-root input[type=\"radio\"] + label:before {\n  background: #fff;\n  border: 3px solid #196ecf;\n  border-radius: 0.5em;\n  content: '';\n  display: inline-block;\n  font-size: 24px;\n  height: 24px;\n  left: -webkit-calc(-1.2em - 4px);\n  left: calc(-1.2em - 4px);\n  margin-right: -webkit-calc(-1.2em + 4px);\n  margin-right: calc(-1.2em + 4px);\n  position: relative;\n  vertical-align: middle;\n  width: 24px;\n}\n.arcade-chrome-root input[type=\"radio\"]:not(:checked) + label:before {\n  cursor: pointer;\n}\n.arcade-chrome-root section {\n  background-color: #fff;\n  overflow-x: hidden;\n}\n.arcade-chrome-root .hide {\n  display: none !important;\n}\n.arcade-chrome-root .fade-in {\n  -webkit-animation: fade-in 1s;\n  animation: fade-in 1s;\n  -webkit-animation-delay: 0.5s;\n  animation-delay: 0.5s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n.arcade-chrome-root .rally-logo {\n  -webkit-backface-visibility: hidden;\n}\n.arcade-chrome-root .hide-outlines *,\n.arcade-chrome-root .hide-outlines *:focus {\n  outline: 0 !important;\n}\n@media (max-width: 983px) {\n  .arcade-chrome-root .arcade-header-class {\n    background-color: #fff;\n    left: 0vw;\n    position: absolute;\n    -webkit-transition: left 0.4s, padding-top 0.4s;\n    transition: left 0.4s, padding-top 0.4s;\n    width: 100vw;\n  }\n  .arcade-chrome-root .arcade-header-class .nav-open {\n    left: -84vw;\n    overflow: hidden;\n  }\n  .arcade-chrome-root input[type=\"radio\"] {\n    font-size: 2em;\n  }\n  .arcade-chrome-root section.padded {\n    padding: 2em 0;\n  }\n}\n.arcade-chrome-root .container {\n  width: auto;\n  max-width: 1224px;\n  float: none;\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n  padding-left: 0;\n  padding-right: 0;\n  position: relative;\n}\n.arcade-chrome-root .container::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .clearfix::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .left {\n  float: left;\n}\n.arcade-chrome-root .right {\n  float: right;\n}\n.arcade-chrome-root .sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n.arcade-chrome-root .col-1-5 {\n  margin-bottom: 2%;\n}\n.arcade-chrome-root .col-1-5:nth-last-child(5),\n.arcade-chrome-root .col-1-5:nth-last-child(4),\n.arcade-chrome-root .col-1-5:nth-last-child(3),\n.arcade-chrome-root .col-1-5:nth-last-child(2),\n.arcade-chrome-root .col-1-5:last-child {\n  margin-bottom: 0;\n}\n.arcade-chrome-root .col-1-5:not(.col-borders) {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 17.6%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-5:not(.col-borders)::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-5:not(.col-borders):last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-5.col-borders {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 17.6%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-5.col-borders::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-5.col-borders:last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-5.col-borders:not(:first-child):before {\n  left: -6%;\n}\n.arcade-chrome-root .col-1-4 {\n  margin-bottom: 2%;\n}\n.arcade-chrome-root .col-1-4:nth-last-child(4),\n.arcade-chrome-root .col-1-4:nth-last-child(3),\n.arcade-chrome-root .col-1-4:nth-last-child(2),\n.arcade-chrome-root .col-1-4:last-child {\n  margin-bottom: 0;\n}\n.arcade-chrome-root .col-1-4:not(.col-borders) {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 22.75%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-4:not(.col-borders)::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-4:not(.col-borders):last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-4.col-borders {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 22.75%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-4.col-borders::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-4.col-borders:last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-4.col-borders:not(:first-child):before {\n  left: -6%;\n}\n.arcade-chrome-root .col-1-3 {\n  margin-bottom: 3%;\n}\n.arcade-chrome-root .col-1-3:nth-last-child(3),\n.arcade-chrome-root .col-1-3:nth-last-child(2),\n.arcade-chrome-root .col-1-3:last-child {\n  margin-bottom: 0;\n}\n.arcade-chrome-root .col-1-3:not(.col-borders) {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 31.33333333333333%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-3:not(.col-borders)::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-3:not(.col-borders):last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-3.col-borders {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 31.33333333333333%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-3.col-borders::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-3.col-borders:last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-3.col-borders:not(:first-child):before {\n  left: -12%;\n}\n.arcade-chrome-root .col-2-3:not(.col-borders) {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 65.66666666666666%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-2-3:not(.col-borders)::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-2-3:not(.col-borders):last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-2-3.col-borders {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 65.66666666666666%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-2-3.col-borders::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-2-3.col-borders:last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-2-3.col-borders:not(:first-child):before {\n  left: -12%;\n}\n.arcade-chrome-root .col-1-2 {\n  margin-bottom: 30px;\n}\n.arcade-chrome-root .col-1-2:nth-last-child(2),\n.arcade-chrome-root .col-1-2:last-child {\n  margin-bottom: 0;\n}\n.arcade-chrome-root .col-1-2:not(.col-borders) {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 48.5%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-2:not(.col-borders)::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-2:not(.col-borders):last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-2.col-borders {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 48.5%;\n  margin-left: 0%;\n  margin-right: 3%;\n}\n.arcade-chrome-root .col-1-2.col-borders::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .col-1-2.col-borders:last-child {\n  margin-right: 0%;\n}\n.arcade-chrome-root .col-1-2.col-borders:not(:first-child):before {\n  left: -12%;\n}\n.arcade-chrome-root .span-1-2 {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 50%;\n  margin-left: 0%;\n  margin-right: 0%;\n}\n.arcade-chrome-root .span-1-2::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .span-1-3 {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 50%;\n  margin-left: 0%;\n  margin-right: 0%;\n}\n.arcade-chrome-root .span-1-3::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n.arcade-chrome-root .span-1-4 {\n  float: left;\n  clear: none;\n  text-align: inherit;\n  width: 50%;\n  margin-left: 0%;\n  margin-right: 0%;\n}\n.arcade-chrome-root .span-1-4::after {\n  content: '';\n  display: table;\n  clear: both;\n}\n@media (min-width: 984px) {\n  .arcade-chrome-root .hide-desktop {\n    display: none !important;\n  }\n}\n@media (max-width: 767px) {\n  .arcade-chrome-root .hide-mobile {\n    display: none !important;\n  }\n  .arcade-chrome-root .hide-phone {\n    display: none !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 983px) {\n  .arcade-chrome-root .hide-mobile {\n    display: none !important;\n  }\n  .arcade-chrome-root .hide-tablet {\n    display: none !important;\n  }\n}\n@media (max-width: 1223px) {\n  .arcade-chrome-root .container {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .arcade-chrome-root .container .container {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (max-width: 983px) {\n  .arcade-chrome-root .container {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.arcade-chrome-root .arcade-header-class .arcade-heading button.inverse-btn {\n  background-color: #fff;\n  border: 1px solid #196ecf;\n  border-radius: 0;\n  box-sizing: border-box;\n  color: #196ecf;\n  display: inline-block;\n  font-family: inherit;\n  font-size: 0.9em;\n  font-weight: 600;\n  margin: 5px 0;\n  padding: 1em 2em;\n  text-align: center;\n  text-transform: uppercase;\n}\n.arcade-chrome-root .arcade-header-class #skip-to-main {\n  left: 5px;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  filter: alpha(opacity=0);\n  opacity: 0;\n  padding-left: 25px;\n  padding-right: 25px;\n  pointer-events: none;\n  position: absolute;\n  top: 12px;\n}\n.arcade-chrome-root .arcade-header-class #skip-to-main:focus {\n  -ms-filter: none;\n  filter: none;\n  opacity: 1;\n  z-index: 2;\n}\n.arcade-chrome-root .dropdown {\n  display: inline-block;\n  line-height: 1;\n  position: relative;\n  text-align: left;\n  width: 100%;\n}\n.arcade-chrome-root .dropdown.inverted .dropdown-toggle {\n  background-color: #196ecf;\n  border-color: #196ecf;\n  color: #fff;\n}\n.arcade-chrome-root .dropdown.inverted .dropdown-toggle:hover {\n  background-color: #115fa0;\n  border-color: #115fa0;\n}\n.arcade-chrome-root .dropdown.dropdown-options {\n  left: auto;\n  right: 0;\n}\n.arcade-chrome-root .dropdown .dropdown-toggle {\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-align-items: center;\n  align-items: center;\n  background-color: #fff;\n  border: 1px solid #196ecf;\n  border-radius: 0;\n  box-sizing: border-box;\n  color: #196ecf;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  font-weight: 600;\n  height: 100%;\n  -webkit-justify-content: space-between;\n  -ms-justify-content: space-between;\n  justify-content: space-between;\n  padding: 0.6em 1.5em;\n  position: relative;\n  text-align: left;\n  text-transform: uppercase;\n  -webkit-transition: color 0.4s, border-color 0.4s, background-color 0.4s;\n  transition: color 0.4s, border-color 0.4s, background-color 0.4s;\n  width: 100%;\n}\n.arcade-chrome-root .dropdown .dropdown-toggle:hover {\n  background-color: #f2f2f2;\n}\n.arcade-chrome-root .dropdown .dropdown-toggle.dropdown-open .dropdown-arrow {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.arcade-chrome-root .dropdown .dropdown-arrow {\n  line-height: 0;\n  width: 1em;\n  margin-left: 5px;\n  -webkit-transform: rotate(0);\n  -ms-transform: rotate(0);\n  transform: rotate(0);\n  -webkit-transition: transform 0.4s;\n  transition: transform 0.4s;\n}\n.arcade-chrome-root .dropdown .dropdown-arrow > svg {\n  fill: currentColor;\n  height: 1em;\n}\n.arcade-chrome-root .dropdown .dropdown-options {\n  border: 1px solid #196ecf;\n  left: 0;\n  margin-top: -1px;\n  min-width: 100%;\n  position: absolute;\n  z-index: 1;\n}\n.arcade-chrome-root .dropdown .dropdown-option {\n  background: #fff;\n  cursor: pointer;\n  display: block;\n  font-weight: 600;\n  padding: -webkit-calc(.6em + 1px);\n  padding: calc(.6em + 1px) 1.5em;\n  text-transform: uppercase;\n  -webkit-transition: background-color 0.4s;\n  transition: background-color 0.4s;\n  white-space: nowrap;\n}\n.arcade-chrome-root .dropdown .dropdown-option:hover {\n  background: #f2f2f2;\n}\n.arcade-chrome-root .dropdown .dropdown-option.selected {\n  background: #003da1;\n  color: #fff;\n  pointer-events: none;\n}\n.arcade-chrome-root .arcade-header-class {\n  display: block;\n  position: relative;\n  -webkit-transition: padding-top 0.4s;\n  transition: padding-top 0.4s;\n  z-index: 2;\n}\n.arcade-chrome-root .arcade-header-class .arcade-heading {\n  background: #fff;\n  display: block;\n  z-index: 1;\n}\n.arcade-chrome-root .arcade-header-class .utility-nav-container {\n  height: 65px;\n  position: relative;\n  z-index: 1;\n}\n.arcade-chrome-root .arcade-header-class .white-label {\n  float: left;\n  font-size: 0;\n}\n.arcade-chrome-root .arcade-header-class .logo-container-link {\n  position: absolute;\n  -webkit-transform-style: preserve-3d;\n  transform-style: preserve-3d;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n  display: inline-block;\n  overflow-x: visible;\n  white-space: nowrap;\n}\n.arcade-chrome-root .arcade-header-class .logo-container-link img {\n  font-size: 15px;\n  height: 45px;\n}\n.arcade-chrome-root .arcade-header-class .secondary-logo {\n  border-left: 1px solid #ccc;\n  margin-left: 20px;\n  padding: 8px 0 8px 20px;\n}\n.arcade-chrome-root .arcade-header-class .secondary-logo:nth-of-type(3):not(:last-of-type),\n.arcade-chrome-root .arcade-header-class .secondary-logo:nth-of-type(4) {\n  max-width: 28%;\n}\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .arcade-chrome-root .arcade-header-class .primary-logo {\n    max-width: 401px;\n  }\n  .arcade-chrome-root .arcade-header-class .secondary-logo:nth-of-type(3):not(:last-of-type),\n  .arcade-chrome-root .arcade-header-class .secondary-logo:nth-of-type(4) {\n    padding-bottom: 12px;\n    padding-top: 12px;\n    max-width: 100%;\n  }\n}\n.arcade-chrome-root .arcade-header-class .utility-nav {\n  float: right;\n  height: 65px;\n  line-height: 65px;\n}\n.arcade-chrome-root .arcade-header-class .utility-nav > span a,\n.arcade-chrome-root .arcade-header-class .utility-nav > select,\n.arcade-chrome-root .arcade-header-class .utility-nav .dropdown {\n  font-size: 0.75em;\n  line-height: 1em;\n  vertical-align: middle;\n}\n.arcade-chrome-root .arcade-header-class .utility-nav > span a {\n  background: transparent;\n  border: 0;\n  color: #196ecf;\n  display: inline-block;\n  font-weight: 600;\n  margin-left: 11px;\n  padding: 8px 0;\n  text-transform: uppercase;\n  -webkit-transition: color 0.4s;\n  transition: color 0.4s;\n}\n.arcade-chrome-root .arcade-header-class .utility-nav > span a:hover {\n  color: #115fa0;\n}\n.arcade-chrome-root .arcade-header-class .utility-nav > span a:hover .notification-count {\n  background-color: #115fa0;\n}\n.arcade-chrome-root .arcade-header-class .utility-nav .account-btn,\n.arcade-chrome-root .arcade-header-class .utility-nav .locale-btn {\n  margin-left: 11px;\n  width: auto;\n}\n.arcade-chrome-root .arcade-header-class #sticky-nav {\n  -webkit-transition: height 0.4s;\n  transition: height 0.4s;\n}\n.arcade-chrome-root .arcade-header-class #sticky-nav:not(.nav-ready) {\n  position: relative;\n}\n.arcade-chrome-root .arcade-header-class .nav-ready #main-nav,\n.arcade-chrome-root .arcade-header-class .nav-ready #sub-nav {\n  -ms-filter: none;\n  filter: none;\n  opacity: 1;\n}\n.arcade-chrome-root .arcade-header-class #main-nav,\n.arcade-chrome-root .arcade-header-class #sub-nav {\n  background-color: #003da1;\n  height: 50px;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n  filter: alpha(opacity=0);\n  opacity: 0;\n  -webkit-transition: opacity 0.4s linear;\n  transition: opacity 0.4s linear;\n}\n.arcade-chrome-root .arcade-header-class #main-nav .fluid-nav,\n.arcade-chrome-root .arcade-header-class #sub-nav .fluid-nav,\n.arcade-chrome-root .arcade-header-class #main-nav .fluid-nav div,\n.arcade-chrome-root .arcade-header-class #sub-nav .fluid-nav div {\n  display: table;\n  table-layout: fixed;\n  width: 100%;\n}\n.arcade-chrome-root .arcade-header-class #main-nav a,\n.arcade-chrome-root .arcade-header-class #sub-nav a {\n  background-color: #003da1;\n  color: #fff;\n  display: table-cell;\n  font-size: 0.85em;\n  font-weight: 600;\n  height: 50px;\n  line-height: 1.3;\n  padding: 0 10px;\n  text-align: center;\n  text-transform: uppercase;\n  -webkit-transition: background-color 0.4s;\n  transition: background-color 0.4s;\n  vertical-align: middle;\n}\n.arcade-chrome-root .arcade-header-class #main-nav a.active,\n.arcade-chrome-root .arcade-header-class #sub-nav a.active {\n  background-color: #196ecf;\n  pointer-events: none;\n}\n.arcade-chrome-root .arcade-header-class #main-nav a:hover,\n.arcade-chrome-root .arcade-header-class #sub-nav a:hover {\n  background-color: #0d56b8;\n}\n.arcade-chrome-root .arcade-header-class #sub-nav {\n  background-color: clr-sub-nav;\n  height: sub-nav-height;\n  overflow: hidden;\n}\n.arcade-chrome-root .arcade-header-class #sub-nav a {\n  background-color: clr-sub-nav;\n  font-size: 0.8em;\n  height: sub-nav-height;\n}\n.arcade-chrome-root .arcade-header-class #sub-nav a.active {\n  background-color: clr-sub-nav-active;\n}\n.arcade-chrome-root .arcade-header-class #sub-nav a:hover {\n  background-color: clr-sub-nav-hover;\n}\n.arcade-chrome-root .arcade-header-class .help-link * {\n  vertical-align: middle;\n}\n.arcade-chrome-root .arcade-header-class .help-link img {\n  height: 1.1em;\n  margin-right: 3px;\n  vertical-align: middle;\n}\n.arcade-chrome-root .hamburger {\n  cursor: pointer;\n  height: 20px;\n  position: relative;\n  -webkit-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: 0.5s ease-in-out;\n  transition: 0.5s ease-in-out;\n  width: 30px;\n}\n.arcade-chrome-root .hamburger:active,\n.arcade-chrome-root .hamburger:focus,\n.arcade-chrome-root .hamburger {\n  background: transparent;\n  border: 0;\n  outline: 0;\n}\n.arcade-chrome-root .hamburger span {\n  background: #2d2d39;\n  display: block;\n  height: 2px;\n  left: 0;\n  -ms-filter: none;\n  filter: none;\n  opacity: 1;\n  position: absolute;\n  -webkit-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  transform: rotate(0deg);\n  -webkit-transition: 0.25s ease-in-out;\n  transition: 0.25s ease-in-out;\n  width: 100%;\n}\n.arcade-chrome-root .hamburger span:nth-child(1) {\n  top: 0;\n}\n.arcade-chrome-root .hamburger span:nth-child(2),\n.arcade-chrome-root .hamburger span:nth-child(3) {\n  top: 9px;\n}\n.arcade-chrome-root .hamburger span:nth-child(4) {\n  top: 18px;\n}\n.arcade-chrome-root .hamburger.open span:nth-child(1) {\n  left: 50%;\n  top: 9px;\n  width: 0;\n}\n.arcade-chrome-root .hamburger.open span:nth-child(2) {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.arcade-chrome-root .hamburger.open span:nth-child(3) {\n  -webkit-transform: rotate(-45deg);\n  -ms-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n}\n.arcade-chrome-root .hamburger.open span:nth-child(4) {\n  left: 50%;\n  top: 9px;\n  width: 0;\n}\n@media (max-width: 983px) {\n  .arcade-chrome-root .arcade-header-class {\n    font-size: 12px;\n    position: static;\n    -webkit-transition: none;\n    transition: none;\n  }\n  .arcade-chrome-root .arcade-header-class .arcade-mobile-heading {\n    background: #fff;\n    border-bottom: 1px solid #ccc;\n    height: 50px;\n    left: 0vw;\n    padding-left: 20px;\n    padding-right: 20px;\n    position: fixed;\n    top: 0;\n    -webkit-transition: left 0.4s, top 0.4s;\n    transition: left 0.4s, top 0.4s;\n    width: 100%;\n    z-index: 4;\n  }\n  .arcade-chrome-root .arcade-header-class .arcade-mobile-heading .hamburger {\n    position: absolute;\n    -webkit-transform-style: preserve-3d;\n    transform-style: preserve-3d;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    right: 20px;\n  }\n  .arcade-chrome-root .arcade-header-class .arcade-mobile-heading .white-label {\n    padding-left: 15px;\n  }\n  .arcade-chrome-root .arcade-header-class .nav-open .arcade-mobile-heading {\n    left: -84vw;\n  }\n  .arcade-chrome-root .arcade-header-class .nav-open .mobile-nav {\n    -webkit-overflow-scrolling: touch;\n    -ms-filter: none;\n    filter: none;\n    opacity: 1;\n    overflow-y: scroll;\n    visibility: visible;\n  }\n  .arcade-chrome-root .arcade-header-class .notification-open .arcade-header-class {\n    padding-top: 0;\n  }\n  .arcade-chrome-root .arcade-header-class .notification-open .arcade-header-class arcade-heading {\n    top: mobile-notification-height;\n  }\n  .arcade-chrome-root .arcade-header-class .notification-open .mobile-nav {\n    height: -webkit-calc(100vh - mobile-notification-height);\n    height: calc(100vh - mobile-notification-height);\n    top: mobile-notification-height;\n  }\n  .arcade-chrome-root .arcade-header-class .logo-container-link {\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n  .arcade-chrome-root .arcade-header-class .logo-container-link .primary-logo {\n    height: 100%;\n    max-width: 55%;\n    padding: 10px 10px 10px 20px;\n  }\n  .arcade-chrome-root .arcade-header-class .logo-container-link .secondary-logo {\n    height: -webkit-calc(100% - 24px);\n    height: calc(100% - 24px);\n    margin: 12px 0;\n    max-width: 45%;\n    padding: 3px 60px 3px 10px;\n  }\n  .arcade-chrome-root .arcade-header-class .logo-container-link .secondary-logo:nth-of-type(3):not(:last-of-type),\n  .arcade-chrome-root .arcade-header-class .logo-container-link .secondary-logo:nth-of-type(4) {\n    max-width: 35%;\n    padding-right: 10px;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav {\n    background: #fff;\n    border-left: 1px solid #ccc;\n    height: 100vh;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n    opacity: 0;\n    overflow-y: auto;\n    position: fixed;\n    right: 0;\n    top: 0;\n    -webkit-transition: opacity 0.4s, top 0.4s, visibility 0.4s;\n    transition: opacity 0.4s, top 0.4s, visibility 0.4s;\n    visibility: hidden;\n    width: 84vw;\n    z-index: 3;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav.negative-z-index {\n    z-index: -1;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #main-nav a,\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav a,\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav a,\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav li > span,\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav li > button,\n  .arcade-chrome-root .arcade-header-class .mobile-nav .radio-link {\n    display: block;\n    font-size: 1em;\n    font-weight: 600;\n    height: auto;\n    line-height: 1;\n    margin: 0;\n    text-align: left;\n    text-transform: uppercase;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav li > span a {\n    display: inline;\n    padding: 0 5px;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav li > span a:first-child:before {\n    content: '';\n    display: block;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #main-nav,\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav {\n    display: block;\n    float: none;\n    height: auto;\n    line-height: 1;\n    -ms-filter: none;\n    filter: none;\n    opacity: 1;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #main-nav a,\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav a {\n    padding: 1.6em 0 1.6em 1.8em;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #main-nav h1,\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav h1 {\n    color: #757588;\n    font-size: 1em;\n    font-weight: 600;\n    margin: 0;\n    padding: 1em 0 1em 1.8em;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav {\n    border-top: 1px solid #ccc;\n    background: #f2f2f2;\n    padding: 1em 0 10em;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav fieldset {\n    border-top: 1px solid #ccc;\n    padding: 1em 0;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #main-nav a {\n    background: #003da1;\n    border-top: 1px solid #196ecf;\n    color: #fff;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #main-nav a:first-child {\n    border-top: 0;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #main-nav a.active {\n    background-color: #196ecf;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav a {\n    border-top: 1px solid #ccc;\n    display: block;\n    position: relative;\n    left: 0;\n    top: 0;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav a > span {\n    display: inline-block;\n    vertical-align: top;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav a > span:first-child {\n    max-width: 75%;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav .utility-nav .help-link {\n    border-top-color: #001e51;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav a,\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav li > span,\n  .arcade-chrome-root .arcade-header-class .mobile-nav #footer-nav li > button {\n    padding: 1em 0 1em 1.8em;\n  }\n  .arcade-chrome-root .arcade-header-class .mobile-nav .radio-link {\n    padding: 0.3em 0 0.3em 1.8em;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav {\n    display: block;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav .mobile-sub-nav-btn {\n    background-color: #196ecf;\n    border: 1px solid #196ecf;\n    color: #fff;\n    font-weight: 500;\n    height: 50px;\n    text-transform: uppercase;\n    width: 100%;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav .mobile-sub-nav-btn .sub-nav-btn-label {\n    vertical-align: middle;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav .mobile-sub-nav-btn svg.svg-icon-triangle-down {\n    display: inline-block;\n    font-size: 0.75em;\n    line-height: 0;\n    margin-left: 5px;\n    -webkit-transition: transform 0.4s;\n    transition: transform 0.4s;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav .mobile-sub-nav-links {\n    height: 0;\n    overflow: hidden;\n    text-transform: uppercase;\n    -webkit-transition: height 0.4s;\n    transition: height 0.4s;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav .mobile-sub-nav-links a {\n    font-size: 1.2em;\n    padding: 20px;\n    display: block;\n    clear: both;\n    float: none;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav .mobile-sub-nav-links a:first-child {\n    margin-left: auto;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav .mobile-sub-nav-links a:last-child {\n    margin-right: auto;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav.expanded .mobile-sub-nav-btn {\n    background-color: #fff;\n    border-left: 0;\n    border-right: 0;\n    color: #196ecf;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav.expanded svg.svg-icon-triangle-down {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav.expanded .mobile-sub-nav-links {\n    height: 100vh;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav.expanded .mobile-sub-nav-links a.active {\n    background: #196ecf;\n    color: #fff;\n    margin: -1px 0 0 0;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav.expanded .mobile-sub-nav-links a.active:not(.active-clickable) {\n    pointer-events: none;\n  }\n  .arcade-chrome-root .arcade-header-class #mobile-sub-nav.expanded .mobile-sub-nav-links a:not(.active) {\n    border-bottom: 1px solid #ccc;\n    margin: 0 20px;\n    padding: 20px 0;\n    width: -webkit-calc(100% - 40px);\n    width: calc(100% - 40px);\n  }\n}\n@media screen and (max-width: 983px) and (-ms-high-contrast: active), (max-width: 983px) and (-ms-high-contrast: none) {\n  .logo-container-link .secondary-logo:nth-of-type(3):not(:last-of-type),\n  .logo-container-link .secondary-logo:nth-of-type(4) {\n    padding-bottom: 5px;\n    padding-top: 5px;\n    max-width: 100%;\n  }\n}\n.arcade-chrome-root .arcade-footer-class button.back-to-top {\n  background: #196ecf;\n  padding: 10px;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.arcade-chrome-root .arcade-footer-class button.back-to-top .svg-arrow-down {\n  display: block;\n  font-size: 1em;\n}\n.arcade-chrome-root .arcade-footer-class button.back-to-top .svg-arrow-down > svg {\n  fill: #fff;\n  height: 0.8em;\n  width: 1em;\n}\n.arcade-chrome-root .arcade-footer-class {\n  background-color: #f6f6f6;\n  border-top: 5px solid #e9e9e9;\n  color: #2d2d39;\n  line-height: 1.3;\n  padding: 15px 0 30px;\n  position: relative;\n}\n.arcade-chrome-root .arcade-footer-class .footer-links a,\n.arcade-chrome-root .arcade-footer-class button {\n  border-width: 0;\n  padding: 0px;\n  background: inherit;\n  line-height: inherit;\n  color: #2d2d39;\n  font: inherit;\n  font-weight: inherit;\n}\n.arcade-chrome-root .arcade-footer-class .footer-links a:visited,\n.arcade-chrome-root .arcade-footer-class button:visited,\n.arcade-chrome-root .arcade-footer-class .footer-links a hover,\n.arcade-chrome-root .arcade-footer-class button hover,\n.arcade-chrome-root .arcade-footer-class .footer-links a visited.hover,\n.arcade-chrome-root .arcade-footer-class button visited.hover {\n  color: #2d2d39;\n}\n.arcade-chrome-root .arcade-footer-class .footer-links a:hover,\n.arcade-chrome-root .arcade-footer-class button:hover {\n  text-decoration: underline;\n}\n.arcade-chrome-root .arcade-footer-class .footer-section h2 {\n  font-size: 1.35em;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n.arcade-chrome-root .arcade-footer-class .footer-section ul.split-column {\n  box-sizing: border-box;\n  float: left;\n  padding-right: 40px;\n}\n.arcade-chrome-root .arcade-footer-class .footer-section li {\n  display: block;\n  margin: 0 0 10px;\n}\n.arcade-chrome-root .arcade-footer-class .footer-bottom {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  line-height: 1;\n  margin-top: 30px;\n  position: relative;\n}\n.arcade-chrome-root .arcade-footer-class .footer-logo-container {\n  bottom: 0;\n  position: absolute;\n  right: 0;\n}\n.arcade-chrome-root .arcade-footer-class .legal-links {\n  display: block;\n  font-size: 0;\n  margin-top: 0;\n}\n.arcade-chrome-root .arcade-footer-class .legal-links > li {\n  margin-top: 10px;\n  display: block;\n}\n.arcade-chrome-root .arcade-footer-class .pipe-delimited {\n  margin-right: 32px;\n}\n.arcade-chrome-root .arcade-footer-class .pipe-delimited .legal-links {\n  margin-top: 10px;\n}\n.arcade-chrome-root .arcade-footer-class .pipe-delimited .legal-links > li {\n  margin-top: 0;\n  border-left: 1px solid #757588;\n  display: inline-block;\n  padding: 0 7px;\n}\n.arcade-chrome-root .arcade-footer-class .pipe-delimited .legal-links > li:first-child {\n  border-left: 0;\n  padding-left: 0;\n}\n.arcade-chrome-root .arcade-footer-class .footer-bottom,\n.arcade-chrome-root .arcade-footer-class .legal-links > li,\n.arcade-chrome-root .arcade-footer-class .footer-logo-container {\n  font-size: 12px;\n}\n.arcade-chrome-root .arcade-footer-class .footer-logo-container {\n  width: 147px;\n}\n.arcade-chrome-root .arcade-footer-class .footer-logo {\n  display: block;\n  padding-bottom: 15px;\n  width: 100%;\n  margin-bottom: -30px;\n  margin-top: 10px;\n}\n.arcade-chrome-root .arcade-footer-class .footer-updated {\n  margin-top: 10px;\n}\n.arcade-chrome-root .arcade-footer-class .legal-container {\n  margin-left: 0;\n  margin-right: 3%;\n  width: auto;\n}\n.arcade-chrome-root .arcade-footer-class .material-id {\n  margin-top: 10px;\n}\n@media (max-width: 983px) {\n  .arcade-chrome-root #footer-nav .arcade-footer-class {\n    border-top: 1px solid #ccc;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class a,\n  .arcade-chrome-root #footer-nav .arcade-footer-class a > span,\n  .arcade-chrome-root #footer-nav .arcade-footer-class li > span,\n  .arcade-chrome-root #footer-nav .arcade-footer-class li > button {\n    color: #757588;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class h1 {\n    display: none;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-4,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-3,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-2 {\n    display: block;\n    clear: both;\n    float: none;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-4:first-child,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-3:first-child,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-2:first-child {\n    margin-left: auto;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-4:last-child,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-3:last-child,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .col-1-2:last-child {\n    margin-right: auto;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .pipe-delimited > .legal-links:last-child {\n    border-bottom: 0 none #ccc;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .legal-links {\n    border-top: 1px solid #ccc;\n    padding: 20px 0;\n    width: 100%;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .legal-links:last-child {\n    border-bottom: 1px solid #ccc;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class div.left,\n  .arcade-chrome-root #footer-nav .arcade-footer-class div.right {\n    float: none;\n    width: 100%;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .pipe-delimited > .legal-links,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .legal-links > li {\n    margin-top: 0;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .legal-links > li,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .pipe-delimited > .legal-links > li,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .pipe-delimited > .legal-links > li:first-child,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-logo-container {\n    border-left: 0;\n    display: block;\n    padding: 0.5em 0 0.5em 2em;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .legal-links > li *,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .pipe-delimited > .legal-links > li *,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .pipe-delimited > .legal-links > li:first-child *,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-logo-container * {\n    padding: 0;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-updated {\n    margin-top: -20px;\n    padding: 0.5em 0 2em 2em;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-logo-container {\n    margin-top: 30px;\n    position: relative;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-logo {\n    margin-bottom: 0;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-section {\n    border-bottom: 1px solid #ccc;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-section ul.split-column {\n    float: none;\n    padding: 0;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-section li {\n    margin: 0;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-section:last-child {\n    border-bottom: 0px;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-bottom {\n    display: block;\n    margin-top: 0;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-links {\n    margin-bottom: 15px;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-links a,\n  .arcade-chrome-root #footer-nav .arcade-footer-class .footer-links span {\n    color: #757588;\n  }\n  .arcade-chrome-root #footer-nav .arcade-footer-class .material-id {\n    margin-top: -20px;\n    padding: 0.5em 0 2em 2em;\n  }\n}\n";
styleInject(css);

var getLink$5 = function getLink(_ref) {
  var resources = _ref.resources;
  return resources.SHARED.HELP;
};

var Help = function Help() {
  return React__default.createElement("span", null, React__default.createElement(WithConfiguredLink, {
    getLink: getLink$5
  }, function (_ref2) {
    var href = _ref2.href;
    return React__default.createElement(TargetAwareAnchor, {
      href: href,
      className: "help-link",
      track: "help"
    }, React__default.createElement(Image, {
      src: keySrc(ImageKey.IconHelp),
      "aria-hidden": "true"
    }), React__default.createElement(Translate, {
      i18nKey: "HELP"
    }));
  }));
};

var LI = makeTrackedClickable('li');

var KeyCodes;

(function (KeyCodes) {
  KeyCodes[KeyCodes["DownArrow"] = 40] = "DownArrow";
  KeyCodes[KeyCodes["UpArrow"] = 38] = "UpArrow";
  KeyCodes[KeyCodes["Return"] = 13] = "Return";
  KeyCodes[KeyCodes["Space"] = 32] = "Space";
  KeyCodes[KeyCodes["Esc"] = 27] = "Esc";
})(KeyCodes || (KeyCodes = {}));

var uniqueId = 0;
var Dropdown =
/*#__PURE__*/
function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this, props));
    _this.state = {
      show: false,
      tabbingFromDropdownElement: false
    };
    _this.dropdownRef = React__default.createRef();
    _this.toggleRef = React__default.createRef();

    _this.handleDocumentClick = function (event) {
      var dropdown = _this.dropdownRef.current;

      if (!dropdown) {
        return;
      }

      var show = _this.state.show;
      var target = event.target;

      if (show && target instanceof Element) {
        var isShadowRoot = !!target.shadowRoot;

        if (isShadowRoot) {
          if (event.composedPath) {
            target = event.composedPath()[0];
          } else {
            // If your browser doesn't support composedPath, good luck.
            return;
          }
        }

        if (target instanceof Element && !dropdown.contains(target)) {
          _this.closeDropdown();
        }
      }
    };

    _this.handleKeyDown = function (e) {
      var toggle = _this.toggleRef.current;

      switch (e.keyCode) {
        case KeyCodes.DownArrow:
          _this.focusNextOption();

          e.preventDefault();
          break;

        case KeyCodes.UpArrow:
          _this.focusPreviousOption();

          e.preventDefault();
          break;

        case KeyCodes.Return:
        case KeyCodes.Space:
          if (!_this.props.isNav && e.target instanceof HTMLElement && e.target !== toggle) {
            e.target.click();
            toggle && toggle.focus();
            e.preventDefault();
          }

          break;

        case KeyCodes.Esc:
          _this.closeDropdown();

          toggle && toggle.focus();
          break;
      }
    };

    _this.closeDropdown = function () {
      _this.setState({
        show: false
      });
    };

    _this.openDropdown = function (callback) {
      _this.setState({
        show: true
      }, callback);
    };

    _this.tryFocus = function (node) {
      if (node && node instanceof HTMLElement) {
        node.focus();
        return true;
      }

      return false;
    };

    _this.focusNextOption = function () {
      var dropdown = _this.dropdownRef.current;

      if (!dropdown) {
        return;
      }

      var focusedOption = dropdown.querySelector('.dropdown-option:focus');

      if (!focusedOption) {
        _this.openDropdown(function () {
          var option = dropdown.querySelector('.dropdown-option');

          _this.tryFocus(option);
        });
      } else {
        var sibling = focusedOption.nextSibling;

        _this.tryFocus(sibling);
      }
    };

    _this.focusPreviousOption = function () {
      var dropdown = _this.dropdownRef.current;

      if (!dropdown) {
        return;
      }

      var focusedOption = dropdown.querySelector('.dropdown-option:focus');

      if (!focusedOption) {
        _this.closeDropdown();
      } else {
        var sibling = focusedOption.previousSibling;

        if (!_this.tryFocus(sibling)) {
          var toggle = _this.toggleRef.current;
          toggle && toggle.focus();
        }
      }
    };

    _this.toggleShow = function () {
      _this.setState(function (_ref) {
        var show = _ref.show;
        return {
          show: !show
        };
      });
    };

    _this.selectOption = function (option) {
      return function (e) {
        var onSelect = _this.props.onSelect;

        if (onSelect) {
          onSelect(option, e);
        }

        _this.closeDropdown();
      };
    };

    _this.getSelectedOption = function () {
      var _this$props = _this.props,
          options = _this$props.options,
          selectedValue = _this$props.selectedValue;
      return options.find(function (option) {
        return option.value === selectedValue;
      });
    };

    _this.getTrackString = function () {
      var selected = _this.getSelectedOption();

      return selected ? "toggle-".concat(selected.label) : undefined;
    };

    _this.tabOutOnBlurAction = function () {
      _this.setState({
        tabbingFromDropdownElement: _this.state.show
      });

      _this.tabOutTimeoutId = window.setTimeout(function () {
        if (_this.state.show) {
          _this.setState({
            tabbingFromDropdownElement: false
          });

          _this.closeDropdown();
        }
      }, 0);
    };

    _this.tabOutOnFocusAction = function () {
      window.clearTimeout(_this.tabOutTimeoutId);

      if (!_this.state.show && _this.state.tabbingFromDropdownElement) {
        _this.openDropdown();
      }

      _this.setState({
        tabbingFromDropdownElement: false
      });
    };

    _this.uniqueId = uniqueId++;
    _this.tabOutTimeoutId = 0;
    return _this;
  }

  _createClass(Dropdown, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_nextProps, nextState) {
      return this.state.tabbingFromDropdownElement === nextState.tabbingFromDropdownElement;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var show = this.state.show;
      var _this$props2 = this.props,
          className = _this$props2.className,
          label = _this$props2.label,
          isNav = _this$props2.isNav,
          options = _this$props2.options;
      var selected = this.getSelectedOption();
      var toggleClassName = classnames({
        'dropdown-toggle': true,
        'dropdown-open': show
      });
      var toggleId = "".concat(toggleClassName.split(' ').join(''), "-").concat(this.uniqueId);
      var optionClassName = 'dropdown-options';
      var optionId = "".concat(optionClassName.split(' ').join(''), "-").concat(this.uniqueId);
      var rootClassName = classnames('dropdown', className);
      return React__default.createElement("div", {
        className: rootClassName,
        ref: this.dropdownRef,
        onKeyDown: this.handleKeyDown,
        onBlur: this.tabOutOnBlurAction,
        onFocus: this.tabOutOnFocusAction
      }, React__default.createElement(Button, {
        id: toggleId,
        className: toggleClassName,
        innerRef: this.toggleRef,
        "aria-haspopup": true,
        "aria-expanded": show,
        "aria-controls": optionId,
        onClick: this.toggleShow,
        track: this.getTrackString()
      }, React__default.createElement("span", null, React__default.createElement("span", {
        className: "sr-only"
      }, "Selected option: "), label || selected && React__default.createElement(Translate, {
        i18nKey: selected.label
      })), React__default.createElement("div", {
        className: "svg-icon-triangle-down dropdown-arrow",
        "aria-hidden": true
      }, React__default.createElement("svg", {
        focusable: "false",
        viewBox: "0 0 256 256"
      }, React__default.createElement("polygon", {
        points: "128,65.5 256,65.5 192,128 128,190.5 64,128 0,65.5"
      })))), React__default.createElement("ul", {
        id: optionId,
        className: "dropdown-options",
        role: "group",
        hidden: !show,
        "aria-expanded": show,
        "aria-labelledby": toggleId
      }, options.map(function (option, i) {
        var className = classnames({
          'dropdown-option': true,
          selected: selected && option.value === selected.value
        });
        var sharedProps = {
          key: i,
          tabIndex: 0,
          onClick: _this2.selectOption(option),
          track: "option-".concat(option.label),
          children: React__default.createElement(Translate, {
            i18nKey: option.label
          }),
          className: className
        };
        return isNav ? React__default.createElement(TargetAwareAnchor, _extends({
          href: option.value.href,
          target: option.value.target
        }, sharedProps)) : React__default.createElement(LI, _extends({
          role: "button",
          value: option.value
        }, sharedProps));
      })));
    }
  }]);

  return Dropdown;
}(Component);

var _React$createContext$4 = React__default.createContext({
  handleEvent: function handleEvent() {
    return undefined;
  }
}),
    EventProvider = _React$createContext$4.Provider,
    EventConsumer = _React$createContext$4.Consumer;

var localeOptions = [{
  label: 'English',
  value: Locale.enUS
}, {
  label: 'Español',
  value: Locale.esUS
}];
var additionalLocales = [{
  label: 'Creole',
  value: Locale.htHT
}, {
  label: 'Ilocano',
  value: Locale.ilPH
}, {
  label: '한국어',
  value: Locale.koUS
}, {
  label: 'Tagalog',
  value: Locale.tlPH
}, {
  label: 'Tiếng Việt',
  value: Locale.viVN
}, {
  label: '中文',
  value: Locale.zhTW
}];
var handleLocaleSelect = function handleLocaleSelect(handleEvent) {
  return function (option) {
    handleEvent(ButtonAction.localeChanged, {
      locale: option.value
    });
  };
};

var LocaleSelect = function LocaleSelect() {
  return React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.EI, LineOfBusiness.CS],
    predicate: function predicate(_ref) {
      var currentUser = _ref.profile.currentUser;
      return currentUser.membershipCategory !== MembershipCategory.EMPIRE;
    },
    showOnError: true
  }, React__default.createElement(Feature, {
    feature: "localeSelector"
  }, React__default.createElement(LocaleConsumer, null, function (_ref2) {
    var locale = _ref2.locale;
    return React__default.createElement(EventConsumer, null, function (_ref3) {
      var handleEvent = _ref3.handleEvent;
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(EligibilityGate, {
        eligibleLobs: [LineOfBusiness.EI],
        showOnError: true
      }, React__default.createElement(Dropdown, {
        options: localeOptions,
        selectedValue: locale,
        className: "locale-btn",
        onSelect: handleLocaleSelect(handleEvent)
      })), React__default.createElement(EligibilityGate, {
        eligibleLobs: [LineOfBusiness.CS]
      }, React__default.createElement(Dropdown, {
        options: localeOptions.concat(additionalLocales),
        selectedValue: locale,
        className: "locale-btn",
        onSelect: handleLocaleSelect(handleEvent)
      })));
    });
  })));
};

var OutlineMode;

(function (OutlineMode) {
  OutlineMode["Hide"] = "hide";
  OutlineMode["Show"] = "show";
})(OutlineMode || (OutlineMode = {}));

var AccessibleOutlines =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AccessibleOutlines, _React$Component);

  function AccessibleOutlines() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, AccessibleOutlines);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccessibleOutlines)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      outlineMode: OutlineMode.Hide
    }, _this.ref = React__default.createRef(), _this.hideOutlineChange = function () {
      _this.setState({
        outlineMode: OutlineMode.Hide
      });
    }, _this.showOutlineChange = function (event) {
      if (event.keyCode === 9) {
        _this.setState({
          outlineMode: OutlineMode.Show
        });
      }
    }, _temp));
  }

  _createClass(AccessibleOutlines, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var current = this.ref.current;

      if (!current) {
        return;
      }

      current.addEventListener('mousedown', this.hideOutlineChange);
      current.addEventListener('keydown', this.showOutlineChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var current = this.ref.current;

      if (!current) {
        return;
      }

      current.removeEventListener('mousedown', this.hideOutlineChange);
      current.removeEventListener('keydown', this.showOutlineChange);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var outlineMode = this.state.outlineMode;
      var className = classnames({
        'hide-outlines': outlineMode === OutlineMode.Hide
      });
      return React__default.createElement("span", {
        className: className,
        ref: this.ref,
        tabIndex: 0
      }, children);
    }
  }]);

  return AccessibleOutlines;
}(React__default.Component);

var shouldShowSaved = function shouldShowSaved(_ref) {
  var profile = _ref.profile;
  var _profile$currentUser = profile.currentUser,
      planCoverages = _profile$currentUser.planCoverages,
      lineOfBusiness = _profile$currentUser.lineOfBusiness;

  if (lineOfBusiness !== LineOfBusiness.MR) {
    return true;
  }

  var isMaOrMapd = hasCoverageMatching(planCoverages, {
    coverageStatuses: [CoverageStatus.Active, CoverageStatus.Future],
    coverageTypeCodes: [CoverageTypeCode.MA, CoverageTypeCode.MAPD]
  });
  return isMaOrMapd;
};

var shouldShowRecommendations = function shouldShowRecommendations(_ref2) {
  var profile = _ref2.profile;
  var _profile$currentUser2 = profile.currentUser,
      planCoverages = _profile$currentUser2.planCoverages,
      lineOfBusiness = _profile$currentUser2.lineOfBusiness;
  var isFuture = planCoverages.every(function (c) {
    return c.planPeriod.status === CoverageStatus.Future;
  });
  return lineOfBusiness === LineOfBusiness.CS || lineOfBusiness === LineOfBusiness.MR && !isFuture;
};

var linkItems = [{
  item: healthRecord,
  linesOfBusiness: [LineOfBusiness.EI]
}, {
  item: healthChecklist,
  linesOfBusiness: [LineOfBusiness.EI]
}, {
  item: saved,
  predicate: shouldShowSaved
}, {
  item: rewards,
  linesOfBusiness: [LineOfBusiness.EI]
}, {
  item: recommendations,
  predicate: shouldShowRecommendations
}, {
  item: accountSettings
}, {
  item: messages,
  linesOfBusiness: [LineOfBusiness.EI, LineOfBusiness.MR]
}, {
  item: logout
}];
var shouldIncludeItem = function shouldIncludeItem(profile, item) {
  var linesOfBusiness = item.linesOfBusiness,
      predicate = item.predicate;
  var isSupportedLob = !linesOfBusiness || profile && linesOfBusiness.indexOf(profile.currentUser.lineOfBusiness) !== -1;
  var satisfiesPredicate = !predicate || profile && predicate({
    profile: profile
  });
  var includeOption = isSupportedLob && satisfiesPredicate;
  return includeOption;
};

var LinkItemDropdown = function LinkItemDropdown(_ref3) {
  var _ref3$options = _ref3.options,
      options = _ref3$options === void 0 ? [] : _ref3$options,
      linkItems = _ref3.linkItems,
      props = _objectWithoutProperties(_ref3, ["options", "linkItems"]);

  var _linkItems = _toArray(linkItems),
      head = _linkItems[0],
      rest = _linkItems.slice(1);

  var item = head.item;
  return React__default.createElement(ProfileConsumer, null, function (_ref4) {
    var profile = _ref4.profile;
    return React__default.createElement(UnsafeWithConfiguredLink, {
      key: item.text,
      getLink: item.getLink,
      dependentProducts: item.dependentProducts
    }, function (_ref5) {
      var href = _ref5.href;
      var option = {
        label: item.text,
        value: _objectSpread({}, item, {
          href: href
        })
      };
      var includeOption = profile && href && shouldIncludeItem(profile, head) || head.item === accountSettings || head.item === logout; // show even with no profile response

      var newOptions = includeOption ? _toConsumableArray(options).concat([option]) : options;

      if (rest.length === 0) {
        return React__default.createElement(Dropdown, _extends({
          isNav: true
        }, props, {
          options: newOptions,
          className: "account-btn inverted",
          label: React__default.createElement(AccountDropdownLabel, null)
        }));
      } else {
        return React__default.createElement(LinkItemDropdown, _extends({
          options: newOptions,
          linkItems: rest
        }, props));
      }
    });
  });
};

var AccountDropdownLabel = function AccountDropdownLabel() {
  return React__default.createElement(Translate, {
    i18nKey: "ACCOUNT_PROFILE"
  });
};

var AccountDropdown = function AccountDropdown() {
  return React__default.createElement(Feature, {
    feature: "accountDropdown"
  }, React__default.createElement(LinkItemDropdown, {
    linkItems: linkItems
  }));
};

var lastUpdateTime = "2019-05-29T21:13:46.899Z";

var getCurrentYear = function getCurrentYear() {
  var currentDate = new Date();
  return currentDate.getFullYear();
};
var d = new Date(Date.parse(lastUpdateTime));
var t = d.getUTCHours();
var amPm = t > 11 ? 'PM' : 'AM';
var lastUpdated = {
  date: "".concat(d.getMonth() + 1, "/").concat(d.getDate(), "/").concat(d.getFullYear()),
  time: "".concat(t, ":").concat(d.getMinutes(), " ").concat(amPm)
};

var getLegalLayout = function getLegalLayout(_ref) {
  var resources = _ref.resources;
  return resources.FOOTER.LEGAL.PRELOGIN_LEGAL_LAYOUT;
};

var getPrivacyLayout = function getPrivacyLayout(_ref2) {
  var resources = _ref2.resources;
  return resources.FOOTER.LEGAL.PRELOGIN_PRIVACY_LAYOUT;
};

var getCompanyInfo = function getCompanyInfo(_ref3) {
  var resources = _ref3.resources;
  return resources.FOOTER.LEGAL.PRELOGIN_COMPANY_INFO;
};

var CSLegal = function CSLegal() {
  return React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement("li", null, "\xA9 ", getCurrentYear(), " United HealthCare & Rally Health, Inc.", React__default.createElement("span", null, React__default.createElement(Translate, {
    i18nKey: "FTR_RIGHTS"
  })))), React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement(ConfiguredAnchor, {
    track: "terms",
    getLink: getLegalLayout
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_TERMS"
  })), React__default.createElement(ConfiguredAnchor, {
    track: "privacy",
    getLink: getPrivacyLayout
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_PRIVACY"
  })), React__default.createElement(ConfiguredAnchor, {
    getLink: getCompanyInfo,
    track: "about-united"
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_ABOUT_UNITED"
  })), React__default.createElement("li", null, React__default.createElement(TargetAwareAnchor, {
    href: "https://www.rallyhealth.com",
    target: LinkTarget.Blank,
    track: "about-rally"
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_ABOUT_RALLY"
  })))));
};

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
var getTimezoneOffsetInMilliseconds = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
};

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

var is_date = isDate;

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var parseTokenDateTimeDelimeter = /[T ]/;
var parseTokenPlainTime = /:/;

// year tokens
var parseTokenYY = /^(\d{2})$/;
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
];

var parseTokenYYYY = /^(\d{4})/;
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
];

// date tokens
var parseTokenMM = /^-(\d{2})$/;
var parseTokenDDD = /^-?(\d{3})$/;
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/;
var parseTokenWww = /^-?W(\d{2})$/;
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/;

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/;
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/;
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/;

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/;
var parseTokenTimezoneZ = /^(Z)$/;
var parseTokenTimezoneHH = /^([+-])(\d{2})$/;
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/;

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse$1 (argument, dirtyOptions) {
  if (is_date(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits;
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS;
  } else {
    additionalDigits = Number(additionalDigits);
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE$1;
    } else {
      var fullTime = timestamp + time;
      var fullTimeDate = new Date(fullTime);

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate);

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime);
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate);
      if (offsetDiff > 0) {
        offset += offsetDiff;
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {};
  var array = dateString.split(parseTokenDateTimeDelimeter);
  var timeString;

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits];
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);
    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);
    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = parseTokenHH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE$1 +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token;
  var absoluteOffset;

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60;
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString);
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10);
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

var parse_1 = parse$1;

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse_1(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_year = startOfYear;

var LastUpdatedContext = React__default.createContext({
  dateTime: start_of_year(new Date())
});
var LastUpdatedProvider = LastUpdatedContext.Provider,
    LastUpdatedConsumer = LastUpdatedContext.Consumer;

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse_1(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_day = startOfDay;

var MILLISECONDS_IN_MINUTE$2 = 60000;
var MILLISECONDS_IN_DAY = 86400000;

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = start_of_day(dirtyDateLeft);
  var startOfDayRight = start_of_day(dirtyDateRight);

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$2;
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE$2;

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

var difference_in_calendar_days = differenceInCalendarDays;

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var diff = difference_in_calendar_days(date, start_of_year(date));
  var dayOfYear = diff + 1;
  return dayOfYear
}

var get_day_of_year = getDayOfYear;

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0;

  var date = parse_1(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date
}

var start_of_week = startOfWeek;

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return start_of_week(dirtyDate, {weekStartsOn: 1})
}

var start_of_iso_week = startOfISOWeek;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse_1(dirtyDate);
  var year = date.getFullYear();

  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = start_of_iso_week(fourthOfJanuaryOfNextYear);

  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = start_of_iso_week(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

var get_iso_year = getISOYear;

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = get_iso_year(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = start_of_iso_week(fourthOfJanuary);
  return date
}

var start_of_iso_year = startOfISOYear;

var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse_1(dirtyDate);
  var diff = start_of_iso_week(date).getTime() - start_of_iso_year(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

var get_iso_week = getISOWeek;

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (is_date(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

var is_valid = isValid;

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };

  function localize (token, count, options) {
    options = options || {};

    var result;
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token];
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one;
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count);
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

var build_distance_in_words_locale = buildDistanceInWordsLocale;

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
];

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = [];
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key);
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse();
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  );

  return formattingTokensRegExp
}

var build_formatting_tokens_reg_exp = buildFormattingTokensRegExp;

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var meridiemUppercase = ['AM', 'PM'];
  var meridiemLowercase = ['am', 'pm'];
  var meridiemFull = ['a.m.', 'p.m.'];

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  };

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W'];
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    };
  });

  return {
    formatters: formatters,
    formattingTokensRegExp: build_formatting_tokens_reg_exp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

var build_format_locale = buildFormatLocale;

/**
 * @category Locales
 * @summary English locale.
 */
var en = {
  distanceInWords: build_distance_in_words_locale(),
  format: build_format_locale()
};

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var options = dirtyOptions || {};

  var locale = options.locale;
  var localeFormatters = en.format.formatters;
  var formattingTokensRegExp = en.format.formattingTokensRegExp;
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters;

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp;
    }
  }

  var date = parse_1(dirtyDate);

  if (!is_valid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp);

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return get_day_of_year(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(get_day_of_year(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return get_iso_week(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(get_iso_week(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(get_iso_year(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return get_iso_year(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours();
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
};

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp);
  var length = array.length;

  var i;
  var formatter;
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]];
    if (formatter) {
      array[i] = formatter;
    } else {
      array[i] = removeFormattingTokens(array[i]);
    }
  }

  return function (date) {
    var output = '';
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters);
      } else {
        output += array[i];
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return output
}

var format_1 = format;

var lastUpdatedInfo = function lastUpdatedInfo(date, time) {
  return React__default.createElement("div", {
    className: "footer-updated"
  }, React__default.createElement(Translate, {
    i18nKey: 'FTR_UPDATED',
    values: {
      date: date,
      time: time
    }
  }));
};

var LastUpdated = function LastUpdated() {
  return React__default.createElement(FeatureFlagConsumer, null, function (_ref) {
    var isHeaderFooterPhaseTwoOn = _ref.isHeaderFooterPhaseTwoOn;

    if (isHeaderFooterPhaseTwoOn) {
      return React__default.createElement(LastUpdatedConsumer, null, function (_ref2) {
        var dateTime = _ref2.dateTime;
        return lastUpdatedInfo(format_1(dateTime, 'MM.DD.YYYY'), format_1(dateTime, 'hh:mm A'));
      });
    }

    return lastUpdatedInfo(lastUpdated.date, lastUpdated.time);
  });
};

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse_1(dirtyDate);
  var minutes = Number(dirtyMinutes);
  date.setMinutes(minutes);
  return date
}

var set_minutes = setMinutes;

var lastUpdatedInfo$1 = function lastUpdatedInfo(date) {
  return React__default.createElement("div", {
    className: "footer-updated"
  }, React__default.createElement(Translate, {
    i18nKey: 'FTR_UPDATED_MEDICAL',
    values: {
      date: date
    }
  }));
};

var LastUpdated$1 = function LastUpdated() {
  return React__default.createElement(FeatureFlagConsumer, null, function (_ref) {
    var isHeaderFooterPhaseTwoOn = _ref.isHeaderFooterPhaseTwoOn;
    return React__default.createElement(FeatureConfigConsumer, null, function (_ref2) {
      var isFPC = _ref2.isFPC,
          lastUpdatedMedicalDate = _ref2.lastUpdatedMedicalDate;

      if (isFPC && isHeaderFooterPhaseTwoOn) {
        var medicalDateTime = lastUpdatedMedicalDate !== undefined ? parse_1(lastUpdatedMedicalDate) : set_minutes(start_of_year(new Date()), 1);
        return lastUpdatedInfo$1(format_1(medicalDateTime, 'MM.DD.YYYY'));
      }
    });
  });
};

var lastUpdatedInfo$2 = function lastUpdatedInfo(date) {
  return React__default.createElement("div", {
    className: "footer-updated"
  }, React__default.createElement(Translate, {
    i18nKey: 'FTR_UPDATED_MENTAL',
    values: {
      date: date
    }
  }));
};

var LastUpdated$2 = function LastUpdated() {
  return React__default.createElement(FeatureFlagConsumer, null, function (_ref) {
    var isHeaderFooterPhaseTwoOn = _ref.isHeaderFooterPhaseTwoOn;
    return React__default.createElement(FeatureConfigConsumer, null, function (_ref2) {
      var isFPC = _ref2.isFPC,
          lastUpdatedMentalDate = _ref2.lastUpdatedMentalDate;

      if (isFPC && isHeaderFooterPhaseTwoOn) {
        var medicalDateTime = lastUpdatedMentalDate !== undefined ? parse_1(lastUpdatedMentalDate) : set_minutes(start_of_year(new Date()), 1);
        return lastUpdatedInfo$2(format_1(medicalDateTime, 'MM.DD.YYYY'));
      }
    });
  });
};

var getMaterialId = function getMaterialId(currentUser) {
  var materialId = '';

  if (currentUser && currentUser.lineOfBusiness === LineOfBusiness.CS) {
    var _materialId = 'Y0066_181113_095500_C';

    if (currentUser.primaryPolicyNumber && currentUser.primaryPolicyNumber === PrimaryPolicyNumber.masco) {
      _materialId += ' | UHCSCO_181113_095500';
    }

    return _materialId;
  } else if (currentUser && currentUser.lineOfBusiness === LineOfBusiness.MR) {
    materialId = '006_121318_MR_HS';
    return materialId;
  } else {
    return materialId;
  }
};

var MaterialIdRaw = function MaterialIdRaw() {
  return React__default.createElement(ProfileConsumer, null, function (_ref) {
    var profile = _ref.profile;
    var materialId = getMaterialId(profile && profile.currentUser);
    return materialId !== '' ? React__default.createElement("div", {
      className: "material-id"
    }, React__default.createElement(Translate, {
      i18nKey: "FTR_MATERIAL_ID",
      values: {
        materialId: materialId
      }
    })) : null;
  });
};

var MaterialId = function MaterialId() {
  return React__default.createElement(FeatureFlagConsumer, null, function (_ref2) {
    var isHeaderFooterPhaseTwoOn = _ref2.isHeaderFooterPhaseTwoOn;

    if (isHeaderFooterPhaseTwoOn) {
      return React__default.createElement(MaterialIdRaw, null);
    }
  });
};

var getLegalLayout$1 = function getLegalLayout(_ref) {
  var resources = _ref.resources;
  return resources.FOOTER.LEGAL.PRELOGIN_LEGAL_LAYOUT;
};

var getPrivacyLayout$1 = function getPrivacyLayout(_ref2) {
  var resources = _ref2.resources;
  return resources.FOOTER.LEGAL.PRELOGIN_PRIVACY_LAYOUT;
};

var getCompanyInfo$1 = function getCompanyInfo(_ref3) {
  var resources = _ref3.resources;
  return resources.FOOTER.LEGAL.PRELOGIN_COMPANY_INFO;
};

var getNondiscriminationEn = function getNondiscriminationEn(_ref4) {
  var resources = _ref4.resources;
  return resources.FOOTER.LEGAL.NON_DISCRIMINATION_ENG;
};

var getNondiscriminationEs = function getNondiscriminationEs(_ref5) {
  var resources = _ref5.resources;
  return resources.FOOTER.LEGAL.NON_DISCRIMINATION_SPA;
};

var getNondiscriminationZh = function getNondiscriminationZh(_ref6) {
  var resources = _ref6.resources;
  return resources.FOOTER.LEGAL.NON_DISCRIMINATION_CHI;
};

var getLegalEntities = function getLegalEntities(_ref7) {
  var resources = _ref7.resources;
  return resources.FOOTER.LEGAL.PRELOGIN_EXTERNAL_URI;
};

var MrAwareAnchor = function MrAwareAnchor(props) {
  return React__default.createElement(ProfileConsumer, null, function (_ref8) {
    var profile = _ref8.profile;
    var target = profile && profile.currentUser.lineOfBusiness === LineOfBusiness.MR ? LinkTarget.Self : LinkTarget.Blank;
    return React__default.createElement(ConfiguredAnchor, _objectSpread({}, props, {
      target: target
    }));
  });
};

var CurrentLegal = function CurrentLegal() {
  return React__default.createElement("div", {
    className: "footer-bottom"
  }, React__default.createElement("div", {
    className: "legal-container"
  }, React__default.createElement("div", {
    className: "left pipe-delimited"
  }, React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.EI, LineOfBusiness.MR],
    showOnError: true
  }, React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement("li", null, "\xA9 ", getCurrentYear(), " United HealthCare Services, Inc.", ' ', React__default.createElement(Translate, {
    i18nKey: "FTR_RIGHTS"
  })), React__default.createElement(MrAwareAnchor, {
    getLink: getCompanyInfo$1,
    track: "about-united"
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_ABOUT_UNITED"
  }))), React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement("li", null, "\xA9 ", getCurrentYear(), " Rally Health, Inc.", ' ', React__default.createElement(Translate, {
    i18nKey: "FTR_RIGHTS"
  })), React__default.createElement("li", null, React__default.createElement(TargetAwareAnchor, {
    href: "https://www.rallyhealth.com",
    target: "_blank",
    track: "about-rally"
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_ABOUT_RALLY"
  })))), React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement(MrAwareAnchor, {
    track: "legal-entity",
    getLink: getLegalEntities
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_LEGAL_ENTITIES"
  })), React__default.createElement(MrAwareAnchor, {
    track: "privacy",
    getLink: getPrivacyLayout$1
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_PRIVACY"
  })), React__default.createElement(MrAwareAnchor, {
    track: "terms",
    getLink: getLegalLayout$1
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_TERMS"
  }))))), React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.CS]
  }, React__default.createElement(CSLegal, null)), React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.CS, LineOfBusiness.MR]
  }, React__default.createElement(LastUpdated, null), React__default.createElement(MaterialId, null)))), React__default.createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.EI, LineOfBusiness.MR],
    showOnError: true
  }, React__default.createElement("div", null, React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement(ConfiguredAnchor, {
    track: "nondiscrimination-en",
    getLink: getNondiscriminationEn,
    target: "_blank"
  }, "Language Assistance | Non-Discrimination Notice (PDF)"), React__default.createElement(ConfiguredAnchor, {
    track: "nondiscrimination-es",
    getLink: getNondiscriminationEs,
    target: "_blank"
  }, "Asistencia de Idiomas | Aviso de no Discriminaci\xF3n (PDF)"), React__default.createElement(ConfiguredAnchor, {
    track: "nondiscrimination-zh",
    getLink: getNondiscriminationZh,
    target: "_blank"
  }, "\u8A9E\u8A00\u5354\u52A9 | \u4E0D\u6B67\u8996\u901A\u77E5 (PDF)")))));
};

var PhaseTwoLegal = function PhaseTwoLegal() {
  return React__default.createElement("div", {
    className: "footer-bottom"
  }, React__default.createElement("div", {
    className: "legal-container"
  }, React__default.createElement("div", {
    className: "left pipe-delimited"
  }, React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement("li", null, "\xA9 ", getCurrentYear(), " United HealthCare Services, Inc.", ' ', React__default.createElement(Translate, {
    i18nKey: "FTR_RIGHTS"
  })), React__default.createElement(ConfiguredAnchor, {
    getLink: getCompanyInfo$1,
    track: "about-united"
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_ABOUT_UNITED"
  }))), React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement("li", null, "\xA9 ", getCurrentYear(), " Rally Health, Inc.", ' ', React__default.createElement(Translate, {
    i18nKey: "FTR_RIGHTS"
  })), React__default.createElement("li", null, React__default.createElement(TargetAwareAnchor, {
    href: "https://www.rallyhealth.com",
    target: "_blank",
    track: "about-rally"
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_ABOUT_RALLY"
  })))), React__default.createElement("ul", {
    className: "legal-links"
  }, React__default.createElement(ConfiguredAnchor, {
    track: "terms",
    getLink: getLegalLayout$1
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_TERMS"
  })), React__default.createElement(ConfiguredAnchor, {
    track: "privacy",
    getLink: getPrivacyLayout$1
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_PRIVACY"
  })), React__default.createElement(ConfiguredAnchor, {
    track: "legal-entity",
    getLink: getLegalEntities
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_LEGAL_ENTITIES"
  })), React__default.createElement(ConfiguredAnchor, {
    track: "about-united",
    getLink: getCompanyInfo$1
  }, React__default.createElement(Translate, {
    i18nKey: "FTR_ABOUT_UNITED"
  }))), React__default.createElement(LastUpdated, null), React__default.createElement(LastUpdated$1, null), React__default.createElement(LastUpdated$2, null), React__default.createElement(MaterialId, null))));
};

var FooterLegal = function FooterLegal() {
  return React__default.createElement("div", {
    className: "container footer-links"
  }, React__default.createElement(FeatureFlagGate, {
    flag: "isHeaderFooterPhaseTwoOn",
    flaggedFeature: React__default.createElement(PhaseTwoLegal, null),
    defaultFeature: React__default.createElement(CurrentLegal, null)
  }));
};

var MadeBy = function MadeBy() {
  return React__default.createElement("div", {
    className: "container"
  }, React__default.createElement("div", {
    className: "footer-logo-container"
  }, React__default.createElement("span", null, React__default.createElement(Translate, {
    i18nKey: "FTR_MADE_BY"
  })), React__default.createElement(Image, {
    alt: "Rally",
    className: "footer-logo rally-logo",
    src: keySrc(ImageKey.Rally)
  })));
};

var ActionButton = function ActionButton(_ref) {
  var action = _ref.action,
      track = _ref.track,
      props = _objectWithoutProperties(_ref, ["action", "track"]);

  return React__default.createElement(EventConsumer, null, function (_ref2) {
    var handleEvent = _ref2.handleEvent;
    return React__default.createElement(Button, _extends({}, props, {
      track: track,
      onClick: function onClick(e) {
        return handleEvent(action, {
          event: e
        });
      }
    }));
  });
};

var getEditedTextItem = function getEditedTextItem(item, products) {
  var lineInfo = getContactInfo(products, ProductKey.NurseLine);
  var chatInfo = getContactInfo(products, ProductKey.NurseChat);
  var phoneNum = lineInfo && lineInfo.phoneNum ? lineInfo.phoneNum : chatInfo ? chatInfo.phoneNum : "";
  var url = chatInfo && chatInfo.url ? chatInfo.url : lineInfo ? lineInfo.url : "";
  var textItem = {
    text: item.text,
    config: {
      phone: phoneNum,
      url: url
    }
  };

  if (url) {
    textItem.text = phoneNum ? 'FTR_NURSE_CHAT_WITH_PHONE' : 'FTR_NURSE_CHAT';
  }

  return textItem;
};

var getContactInfo = function getContactInfo(products, key) {
  var product = products[key];
  return product ? product.contactInformation : {};
};

var TextLinkItem = function TextLinkItem(_ref) {
  var classes = _ref.classes,
      item = _ref.item,
      props = _objectWithoutProperties(_ref, ["classes", "item"]);

  if (!(item.config && (item.config.phone || item.config.url))) {
    return React__default.createElement("li", null);
  } else if (item.text === 'FTR_NURSE_CHAT') {
    return React__default.createElement("li", null, React__default.createElement(TargetAwareAnchor, _extends({
      className: classes,
      href: item.config ? item.config.url : ""
    }, props)));
  }

  return React__default.createElement("li", null, React__default.createElement("span", _extends({
    className: classes
  }, props)));
};

var ButtonLinkItem = function ButtonLinkItem(_ref2) {
  var classes = _ref2.classes,
      item = _ref2.item,
      props = _objectWithoutProperties(_ref2, ["classes", "item"]);

  return React__default.createElement("li", null, React__default.createElement(ActionButton, _extends({
    className: classnames('link', classes),
    action: item.action,
    track: item.text
  }, props)));
};

var AnchorLinkItem = function AnchorLinkItem(_ref3) {
  var classes = _ref3.classes,
      item = _ref3.item,
      props = _objectWithoutProperties(_ref3, ["classes", "item"]);

  return React__default.createElement(ConfiguredAnchor, _extends({
    className: classes,
    dependentProducts: item.dependentProducts,
    getLink: item.getLink,
    target: item.target,
    track: item.text
  }, props));
};

var getFooterLinkItem = function getFooterLinkItem(item) {
  switch (item.type) {
    case LinkItemType.Text:
      return TextLinkItem;

    case LinkItemType.Button:
      return ButtonLinkItem;

    default:
      return AnchorLinkItem;
  }
};

var FooterLinkItemComponent = function FooterLinkItemComponent(_ref4) {
  var item = _ref4.item;
  var classes = classnames({
    'hide-mobile': item.desktopOnly
  });
  var LinkItem = getFooterLinkItem(item);
  return React__default.createElement(ProductConsumer, null, function (_ref5) {
    var products = _ref5.products;

    if (item.text === 'FTR_NURSE_LINE') {
      item = getEditedTextItem(item, products);
    }

    return React__default.createElement(FeatureConfigConsumer, null, function (_ref6) {
      var isFPC = _ref6.isFPC;

      // This would be great to extract to link-data with Hooks, but we don't support it yet
      if (item.text === 'FTR_PROVIDER_DIRECTORY' && !isFPC) {
        return null;
      } else {
        return React__default.createElement(LinkItem, {
          classes: classes,
          item: item
        }, React__default.createElement(Translate, {
          i18nKey: item.text,
          values: item.config || {}
        }));
      }
    });
  });
};

var FooterLink = function FooterLink(_ref) {
  var link = _ref.link;
  return React__default.createElement(React__default.Fragment, null, link.map(function (linkItem, index) {
    return React__default.createElement(FooterLinkItemComponent, {
      key: index,
      item: linkItem
    });
  }));
};

var profile = {
  rallyId: 'rallyId',
  currentUser: {
    lineOfBusiness: LineOfBusiness.EI,
    membershipCategory: MembershipCategory.UHC,
    memberFeatures: {
      activateEligible: false,
      hsaEligible: false,
      viewRestricted: false,
      pcpEligible: false,
      pcdEligible: false,
      hasPcpReferrals: false,
      premiumPaymentEligible: false,
      fpcEligible: false,
      isDsnp: false
    },
    planCoverages: [{
      planKey: '0',
      coverageType: CoverageType.Medical,
      coverageTypeCode: CoverageTypeCode.MA,
      additionalCoverageInfo: {},
      additionalCoverageTypes: [],
      policyNumber: '1234',
      planPeriod: {
        status: CoverageStatus.Active
      }
    }],
    userInfo: {
      firstName: 'No',
      lastName: 'One'
    }
  },
  clientInfo: {
    displayName: 'CVS Caremark',
    logo: 'static/media/cvs-caremark.4f76b3f1.svg'
  },
  dependents: []
};

var validItems = function validItems(itemList, profile$$1) {
  return itemList.filter(function (item) {
    return !shouldBeHidden(item, profile$$1);
  });
};

var shouldBeHidden = function shouldBeHidden(toValidate, profile$$1) {
  return !!toValidate.showForLob && toValidate.showForLob.indexOf(profile$$1.currentUser.lineOfBusiness) === -1 || !!toValidate.requiresEligibility && !profile$$1.currentUser.memberFeatures[toValidate.requiresEligibility];
};

var FooterLinkSection = function FooterLinkSection(_ref) {
  var section = _ref.section;
  return React__default.createElement(ProfileConsumer, null, function (_ref2) {
    var profile$$1 = _ref2.profile;
    var validProfile = profile$$1 || profile;
    var colClass = validProfile.currentUser.lineOfBusiness === LineOfBusiness.MR ? 'col-1-3' : 'col-1-4';

    if (shouldBeHidden(section, validProfile)) {
      return;
    }

    return React__default.createElement("div", {
      className: classnames('footer-section', colClass)
    }, React__default.createElement("h2", null, React__default.createElement(Translate, {
      i18nKey: section.header
    })), section.content.map(function (item, index) {
      return React__default.createElement("ul", {
        key: index,
        className: classnames({
          'split-column': section.content.length > 1
        })
      }, React__default.createElement(FooterLink, {
        link: validItems(item, validProfile)
      }));
    }));
  });
};

var FooterLinks = function FooterLinks(_ref) {
  var sections = _ref.sections;
  return React__default.createElement("div", {
    className: "container footer-links"
  }, sections.map(function (section) {
    return React__default.createElement(FooterLinkSection, {
      key: section.header,
      section: section
    });
  }));
};

var lodash_clonedeep = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;
});

var PopulatedLinksSection = function PopulatedLinksSection() {
  return React__default.createElement(ProfileConsumer, null, function (_ref) {
    var profile = _ref.profile;

    if (!profile) {
      var defaultSection = lodash_clonedeep(sectionsByLineOfBusiness[LineOfBusiness.EI]);
      var relevantLinks = defaultSection.map(function (section) {
        section.content = section.content.map(function (items) {
          return items.filter(function (item) {
            return item.showOnError !== false;
          });
        });
        return section;
      });
      return React__default.createElement(FooterLinks, {
        sections: relevantLinks
      });
    }

    var lob = profile ? profile.currentUser.lineOfBusiness : LineOfBusiness.EI;

    if (lob) {
      return React__default.createElement(FeatureFlagGate, {
        flag: "isHeaderFooterPhaseTwoOn",
        flaggedFeature: React__default.createElement(FooterLinks, {
          sections: phaseTwoSections
        }),
        defaultFeature: React__default.createElement(FooterLinks, {
          sections: sectionsByLineOfBusiness[lob]
        })
      });
    }
  });
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$1;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

var BackToTop =
/*#__PURE__*/
function (_Component) {
  _inherits(BackToTop, _Component);

  function BackToTop() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, BackToTop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BackToTop)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      show: true
    }, _this.debouncedCheckContentScroll = debounce_1(function () {
      _this.checkContentScroll();
    }, 100), _this.checkContentScroll = function () {
      var show = document.body.scrollHeight > window.innerHeight;

      _this.setState({
        show: show
      });
    }, _this.goToTop = function () {
      window.scrollTo(0, 0);
    }, _temp));
  }

  _createClass(BackToTop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.debouncedCheckContentScroll);
      this.checkContentScroll();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedCheckContentScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var show = this.state.show;
      return show ? React__default.createElement(FeatureFlagConsumer, null, function (_ref) {
        var isHeaderFooterPhaseTwoOn = _ref.isHeaderFooterPhaseTwoOn;
        return isHeaderFooterPhaseTwoOn ? React__default.createElement(Button, {
          className: "back-to-top",
          onClick: _this2.goToTop
        }, React__default.createElement("div", {
          className: "svg-arrow-down",
          "aria-hidden": "true"
        }, React__default.createElement("svg", {
          viewBox: "0 0 256 256",
          enableBackground: "new 0 0 256 256"
        }, React__default.createElement("path", {
          d: "M0.1,172.8L128,42.8l127.9,132.1l-38.4,38.4L128,121.5l-89.5,91.7L0.1,172.8L0.1,172.8z"
        }))), React__default.createElement("span", {
          className: "sr-only"
        }, React__default.createElement(Translate, {
          i18nKey: "FTR_BACK_TO_TOP"
        }))) : null;
      }) : null;
    }
  }]);

  return BackToTop;
}(Component);

var Footer = function Footer() {
  return React__default.createElement("div", {
    className: "arcade-chrome-root"
  }, React__default.createElement(FooterRaw, {
    hideMobile: true
  }));
};

var FooterRaw = function FooterRaw(_ref) {
  var _ref$hideMobile = _ref.hideMobile,
      hideMobile = _ref$hideMobile === void 0 ? false : _ref$hideMobile;
  var footerClassNames = classnames('arcade-footer-class', {
    'hide-mobile': hideMobile
  });
  return React__default.createElement(AccessibleOutlines, null, React__default.createElement(Feature, {
    feature: "footer"
  }, React__default.createElement("footer", {
    className: footerClassNames
  }, React__default.createElement(BackToTop, null), React__default.createElement(PopulatedLinksSection, null), React__default.createElement(FooterLegal, null), React__default.createElement(MadeBy, null))));
};
Footer.styles = css;

var isArcade = function isArcade(arcadeUrl, windowLocation) {
  var arcadeUrlAnchor = parseUrl(arcadeUrl);
  return arcadeUrlAnchor.hostname === windowLocation.hostname;
};

var getAllLocaleOptions = function getAllLocaleOptions(profile) {
  return (profile && profile.currentUser.lineOfBusiness) === LineOfBusiness.CS ? localeOptions.concat(additionalLocales) : localeOptions;
};

var LinkItems = function LinkItems() {
  return createElement(ProfileConsumer, null, function (_ref) {
    var profile = _ref.profile;
    return createElement(Fragment, null, linkItems.map(function (item) {
      return createElement(UnsafeWithConfiguredLink, {
        key: item.item.text,
        getLink: item.item.getLink,
        dependentProducts: item.item.dependentProducts
      }, function (_ref2) {
        var href = _ref2.href;

        if (!href || !profile || !shouldIncludeItem(profile, item)) {
          return null;
        }

        return createElement(TargetAwareAnchor, {
          href: href,
          target: item.item.target,
          track: item.item.text
        }, createElement(Translate, {
          i18nKey: item.item.text
        }));
      });
    }));
  });
};

var LocaleSelect$1 = function LocaleSelect$$1() {
  return createElement(EligibilityGate, {
    eligibleLobs: [LineOfBusiness.EI, LineOfBusiness.CS],
    predicate: function predicate(_ref3) {
      var currentUser = _ref3.profile.currentUser;
      return currentUser.membershipCategory !== MembershipCategory.EMPIRE;
    },
    showOnError: true
  }, createElement(Feature, {
    feature: "localeSelector"
  }, createElement("fieldset", null, createElement("h1", null, "LANGUAGE:"), createElement(EventConsumer, null, function (_ref4) {
    var handleEvent = _ref4.handleEvent;
    return createElement(ProfileConsumer, null, function (_ref5) {
      var profile = _ref5.profile;
      return createElement(LocaleConsumer, null, function (_ref6) {
        var locale = _ref6.locale;
        return createElement(Fragment, null, getAllLocaleOptions(profile).map(function (_ref7) {
          var label = _ref7.label,
              value = _ref7.value;
          return createElement("div", {
            key: value,
            className: "radio-link"
          }, createElement(Input, {
            id: "locale-radio-".concat(value),
            type: "radio",
            name: "locale",
            track: label,
            value: value,
            onChange: function onChange() {
              return handleEvent(ButtonAction.localeChanged, {
                locale: value
              });
            },
            checked: value === locale
          }), createElement("label", {
            htmlFor: "locale-radio-".concat(value)
          }, label));
        }));
      });
    });
  }))));
};

var MobileNav = function MobileNav(_ref8) {
  var isNavOpen = _ref8.isNavOpen;
  return createElement(UrlConsumer, null, function (_ref9) {
    var baseUrls = _ref9.baseUrls;
    var mobileNavClassNames = classnames('hide-desktop', 'mobile-nav', {
      'negative-z-index': isArcade(baseUrls.arcadeUrl, window.location)
    });
    return createElement("div", {
      className: mobileNavClassNames,
      tabIndex: -1,
      "aria-hidden": !isNavOpen
    }, createElement(HeaderNav, null), createElement(Feature, {
      feature: "utilityNav"
    }, createElement("nav", {
      className: "utility-nav",
      role: "navigation"
    }, createElement("span", {
      tabIndex: -1
    }, createElement(Help, null), createElement(LinkItems, null)), createElement(LocaleSelect$1, null))), createElement("span", {
      id: "footer-nav"
    }, createElement(FooterRaw, null)));
  });
};

var HeaderMobile =
/*#__PURE__*/
function (_React$Component) {
  _inherits(HeaderMobile, _React$Component);

  function HeaderMobile() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, HeaderMobile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HeaderMobile)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      isNavOpen: false
    }, _this.toggleNav = function () {
      return _this.setState(function (_ref10) {
        var isNavOpen = _ref10.isNavOpen;
        return {
          isNavOpen: !isNavOpen
        };
      });
    }, _this.getFocusedOption = function (e) {
      if (e.key === 'Tab') {
        var target = e.target;

        if (target instanceof Element) {
          var isShadowRoot = !!target.shadowRoot;

          if (isShadowRoot) {
            if (event && event.composedPath) {
              target = event.composedPath()[0];
            } else {
              // If your browser doesn't support composedPath, good luck.
              return;
            }
          }
        }

        var sharedHeader = document.getElementsByTagName('arcade-header')[0];
        var isChildOfMobileNav = !!_this.getClosest(target, '.mobile-nav');
        var _isNavOpen = _this.state.isNavOpen;
        var navToggle = new CustomEvent('arcade-action', {
          bubbles: true,
          detail: {
            action: 2,
            props: _isNavOpen
          }
        });

        if (!isChildOfMobileNav && _isNavOpen) {
          _this.toggleNav(); // fire a custom event for arcade-ui


          sharedHeader.dispatchEvent(navToggle);
        }
      }
    }, _this.getClosest = function (elem, selector) {
      for (; elem; elem = elem.parentNode) {
        if (elem.matches && elem.matches(selector)) {
          return elem;
        }
      }

      return null;
    }, _temp));
  }

  _createClass(HeaderMobile, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keyup', this.getFocusedOption);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keyup', this.getFocusedOption);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isNavOpen = this.state.isNavOpen;
      var hamburgerClass = classnames('hamburger', {
        open: isNavOpen
      });
      var navOpenClass = classnames({
        'nav-open': isNavOpen
      });
      return createElement(Feature, {
        feature: "headerMobile"
      }, createElement("span", {
        className: navOpenClass
      }, createElement("header", {
        className: "hide-desktop arcade-mobile-heading"
      }, createElement("div", {
        className: "mobile-header"
      }, createElement("div", {
        className: "white-label"
      }, createElement(ConnectedLogoList, null)), createElement(EventConsumer, null, function (_ref11) {
        var handleEvent = _ref11.handleEvent;
        return createElement(NamespacesConsumer, null, function (t) {
          return createElement(Button, {
            className: hamburgerClass,
            onClick: function onClick() {
              _this2.toggleNav();

              handleEvent(ButtonAction.toggleNav, {
                isNavOpen: !_this2.state.isNavOpen
              });
            },
            title: t(isNavOpen ? 'CLOSE_NAVIGATION_MENU' : 'OPEN_NAVIGATION_MENU'),
            track: "mobile-nav"
          }, createElement("span", null), createElement("span", null), createElement("span", null), createElement("span", null));
        });
      }))), createElement(MobileNav, {
        isNavOpen: isNavOpen
      })));
    }
  }]);

  return HeaderMobile;
}(Component);

var SkipToMain =
/*#__PURE__*/
function (_Component) {
  _inherits(SkipToMain, _Component);

  function SkipToMain() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, SkipToMain);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SkipToMain)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.skipToFocusableMainContent = function () {
      var possibleFirstMainFocusElement = document.querySelector('.possible-first-main-focus');

      if (possibleFirstMainFocusElement) {
        possibleFirstMainFocusElement.focus();
      }
    }, _temp));
  }

  _createClass(SkipToMain, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React__default.createElement(FeatureConfigConsumer, null, function (_ref) {
        var useA11ySkipToMain = _ref.useA11ySkipToMain;
        return useA11ySkipToMain && React__default.createElement(Button, {
          id: "skip-to-main",
          className: "inverse-btn",
          onClick: _this2.skipToFocusableMainContent,
          track: "skip-to-main"
        }, React__default.createElement(Translate, {
          i18nKey: "SKIP_TO_MAIN_CONTENT"
        }));
      });
    }
  }]);

  return SkipToMain;
}(Component);

var Header = function Header() {
  return createElement("div", {
    className: "arcade-chrome-root"
  }, createElement(AccessibleOutlines, null, createElement("div", {
    className: "arcade-header-class"
  }, createElement(HeaderDesktop, null), createElement(HeaderMobile, null))));
};

var HeaderDesktop = function HeaderDesktop() {
  return createElement(Feature, {
    feature: "headerDesktop"
  }, createElement("header", {
    className: "hide-mobile arcade-heading"
  }, createElement(SkipToMain, null), createElement("div", {
    className: "container utility-nav-container"
  }, createElement(ConnectedLogoList, null), createElement(Feature, {
    feature: "utilityNav"
  }, createElement("nav", {
    className: "utility-nav fade-in"
  }, createElement(Help, null), createElement(LocaleSelect, null), createElement(AccountDropdown, null)))), createElement(StickyHeaderNav, null)));
};
Header.styles = css;

var EventType;

(function (EventType) {
  EventType["Tracking"] = "tracking";
  EventType["Action"] = "action";
})(EventType || (EventType = {}));

var makeTrackHandler = function makeTrackHandler(handler) {
  return function (event) {
    handler({
      type: EventType.Tracking,
      payload: event
    });
  };
};

var makeEventHandler = function makeEventHandler(handler) {
  return function (action, props) {
    handler({
      type: EventType.Action,
      payload: {
        action: action,
        props: props
      }
    });
  };
};

var EventAdapter = function EventAdapter(_ref) {
  var handler = _ref.handler,
      children = _ref.children;
  return React__default.createElement(TrackingProvider, {
    value: {
      handleTrack: makeTrackHandler(handler)
    }
  }, React__default.createElement(EventProvider, {
    value: {
      handleEvent: makeEventHandler(handler)
    }
  }, children));
};

var baseUrls = {
  myUhcBaseUrl: 'https://test1.myuhc.com',
  myUhcLegacyEnBaseUrl: 'https://systest1.myuhc.com',
  myUhcLegacyEsBaseUrl: 'https://es-systest1.myuhc.com',
  connectUrl: 'https://connect.dev.werally.in',
  healthRecordUrl: 'https://ihr.dev.werally.in',
  engageUrl: 'https://dev.werally.in',
  surveyUrl: 'https://survey.dev.werally.in',
  rewardsUrl: 'https://rewards.dev.werally.in',
  rxUrl: 'https://rx.dev.werally.in',
  arcadeUrl: 'https://arcade.dev.werally.in/aarp'
};
var imageUrls = {
  Rally: 'static/media/rally.a701d1e5.svg',
  UnitedHealth: 'static/media/unitedhealth.38cbe77a.svg',
  AARP: 'static/media/aarp.82a5c074.svg',
  CDP: 'static/media/cdp.51f5b822.svg',
  CVSCaremark: 'static/media/cvs-caremark.4f76b3f1.svg',
  ERS: 'static/media/ers.52e47582.svg',
  ExpressScripts: 'static/media/express-scripts.237377df.svg',
  IconHelp: 'static/media/icon-help.b211f515.svg',
  Medica: 'static/media/medica.6c455c1f.svg',
  MedicaHealthcare: 'static/media/medicahealthcare.20023b55.svg',
  OptumBank: 'static/media/optum-bank.213be046.svg',
  OptumRx: 'static/media/optum-rx.f676a150.svg',
  PreferredCare: 'static/media/preferredcare.e911f2f1.svg',
  UHCCommunity: 'static/media/uhc-cs.d5a910da.svg',
  UHCGlobal: 'static/media/uhc-global.999d5309.svg',
  UHCOxford: 'static/media/uhc-oxford-logo.d7d82092.svg',
  UnitedHealthMobile: 'static/media/unitedhealth-small.7e443988.svg',
  Walgreens: 'static/media/walgreens.a9360eb9.svg'
};
var products = {
  rallyConnect: {
    productId: ProductType.RallyConnect
  },
  rallyEngage: {
    productId: ProductType.RallyConnect
  },
  nurseChat: {
    productId: ProductType.RallyConnect
  },
  nurseLine: {
    productId: ProductType.RallyConnect
  },
  easyConnect: {
    productId: ProductType.RallyConnect
  },
  clickToChat: {
    productId: ProductType.RallyConnect
  },
  secureMessage: {
    productId: ProductType.RallyConnect
  },
  medicalSupport: {
    productId: ProductType.RallyConnect
  },
  technicalSupport: {
    productId: ProductType.RallyConnect
  },
  rx: {
    productId: ProductType.RallyConnect
  },
  liveAndWorkWell: {
    productId: ProductType.RallyConnect
  },
  nurseHealthLine: {
    productId: ProductType.RallyConnect
  },
  silverSneakers: {
    productId: ProductType.RallyConnect
  },
  visionDiscount: {
    productId: ProductType.RallyConnect
  },
  atYourBest: {
    productId: ProductType.RallyConnect
  },
  dime: {
    productId: ProductType.RallyConnect
  },
  dime2: {
    productId: ProductType.RallyConnect
  },
  providerDiscountNetwork: {
    productId: ProductType.RallyConnect
  },
  myCarePath: {
    productId: ProductType.RallyConnect
  },
  individualHealthRecord: {
    productId: ProductType.RallyConnect
  }
};
var profile$1 = {
  rallyId: 'rallyId',
  currentUser: {
    lineOfBusiness: LineOfBusiness.EI,
    membershipCategory: MembershipCategory.UHC,
    memberFeatures: {
      activateEligible: true,
      hsaEligible: true,
      viewRestricted: true,
      pcpEligible: true,
      pcdEligible: true,
      hasPcpReferrals: true,
      premiumPaymentEligible: true,
      fpcEligible: true,
      isDsnp: true
    },
    planCoverages: [{
      planKey: '0',
      coverageType: CoverageType.Medical,
      coverageTypeCode: CoverageTypeCode.MA,
      additionalCoverageInfo: {},
      additionalCoverageTypes: [],
      policyNumber: '1234',
      planPeriod: {
        status: CoverageStatus.Active
      }
    }, {
      planKey: '1',
      coverageType: CoverageType.Medical,
      coverageTypeCode: CoverageTypeCode.MA,
      additionalCoverageInfo: {},
      additionalCoverageTypes: [],
      policyNumber: '1234',
      planPeriod: {
        status: CoverageStatus.Active
      }
    }, {
      planKey: '2',
      coverageType: CoverageType.Medical,
      coverageTypeCode: CoverageTypeCode.MA,
      additionalCoverageInfo: {},
      additionalCoverageTypes: [],
      policyNumber: '1234',
      planPeriod: {
        status: CoverageStatus.Active
      }
    }],
    userInfo: {
      firstName: 'Max',
      lastName: 'Power'
    }
  },
  clientInfo: {
    displayName: 'CVS Caremark',
    logo: 'static/media/cvs-caremark.4f76b3f1.svg'
  },
  dependents: []
};
var features = ['storybook-root'];
var featureFlags = defaultFeatureFlags;
var locale = Locale.enUS;

var handleEvent = function handleEvent() {// THIS BLOCK INTENTIONALLY EMPTY
};

var lastUpdatedDateTime = start_of_year(new Date());
var defaultProps = {
  baseUrls: baseUrls,
  imageUrls: imageUrls,
  products: products,
  profile: profile$1,
  features: features,
  featureFlags: featureFlags,
  locale: locale,
  handleEvent: handleEvent,
  lastUpdatedDateTime: lastUpdatedDateTime
};

var _typeof_1$1 = createCommonjsModule(function (module) {
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty$2 = _defineProperty$2;

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty$2(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread$1 = _objectSpread$2;

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck$1 = _classCallCheck$2;

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

var createClass$1 = _createClass$2;

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized$1 = _assertThisInitialized$2;

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof_1$1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized$1(self);
}

var possibleConstructorReturn$1 = _possibleConstructorReturn$2;

var getPrototypeOf$2 = createCommonjsModule(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

var setPrototypeOf$1 = createCommonjsModule(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf$1(subClass, superClass);
}

var inherits$1 = _inherits$2;

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var arrayWithoutHoles = _arrayWithoutHoles$1;

function _iterableToArray$1(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

var iterableToArray = _iterableToArray$1;

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var nonIterableSpread = _nonIterableSpread$1;

function _toConsumableArray$1(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray$1;

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, toConsumableArray(args));
  }
};

var Logger =
/*#__PURE__*/
function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    classCallCheck$1(this, Logger);

    this.init(concreteLogger, options);
  }

  createClass$1(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, objectSpread$1({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    classCallCheck$1(this, EventEmitter);

    this.observers = {};
  }

  createClass$1(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      var _this2 = this;

      if (!this.observers[event]) {
        return;
      }

      this.observers[event].forEach(function () {
        if (!listener) {
          delete _this2.observers[event];
        } else {
          var index = _this2.observers[event].indexOf(listener);

          if (index > -1) {
            _this2.observers[event].splice(index, 1);
          }
        }
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */

  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }

  return target;
}
function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/* eslint-disable */

var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}

var ResourceStore =
/*#__PURE__*/
function (_EventEmitter) {
  inherits$1(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    classCallCheck$1(this, ResourceStore);

    _this = possibleConstructorReturn$1(this, getPrototypeOf$2(ResourceStore).call(this));
    EventEmitter.call(assertThisInitialized$1(assertThisInitialized$1(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  createClass$1(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      /* eslint no-restricted-syntax: 0 */
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = objectSpread$1({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS; // COMPATIBILITY: remove extend in v2.1.0

      if (this.options.compatibilityAPI === 'v1') return objectSpread$1({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var Translator =
/*#__PURE__*/
function (_EventEmitter) {
  inherits$1(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    classCallCheck$1(this, Translator);

    _this = possibleConstructorReturn$1(this, getPrototypeOf$2(Translator).call(this));
    EventEmitter.call(assertThisInitialized$1(assertThisInitialized$1(_this))); // <=IE10 fix (unable to call parent constructor)

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, assertThisInitialized$1(assertThisInitialized$1(_this)));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  createClass$1(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator || this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options) {
      var _this2 = this;

      if (_typeof_1$1(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        /* eslint prefer-rest-params: 0 */
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {}; // non valid keys handling

      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)]; // separators

      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator; // get namespace(s)

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1]; // return key on CIMode

      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      } // resolve from store


      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays; // object

      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        } // if we got a separator we loop over children - else we just return object as is
        // as having it set to false means no hierarchy so no lookup for nested values


        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy$$1 = resTypeIsArray ? [] : {}; // apply child translation on a copy

          /* eslint no-restricted-syntax: 0 */

          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy$$1[m] = this.translate(deepKey, objectSpread$1({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy$$1[m] === deepKey) copy$$1[m] = res[m]; // if nothing found use orginal value as fallback
            }
          }

          res = copy$$1;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        // array special treatment
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options);
      } else {
        // string, empty or null
        var usedDefault = false;
        var usedKey = false; // fallback value

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        } // save missing


        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        } // extend


        res = this.extendTranslation(res, keys, options, resolved); // append namespace if still key

        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key); // parseMissingKeyHandler

        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      } // return


      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        // i18next.parsing
        if (options.interpolation) this.interpolator.init(objectSpread$1({}, options, {
          interpolation: objectSpread$1({}, this.options.interpolation, options.interpolation)
        })); // interpolate

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = objectSpread$1({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options); // nesting

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          return _this3.translate.apply(_this3, arguments);
        }, options);
        if (options.interpolation) this.interpolator.reset();
      } // post process


      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey; // plain key

      var exactUsedKey; // key with context / plural

      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys]; // forEach possible key

      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count); // fallback for plural if context not found

              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix); // get key for context if needed

              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context)); // get key for plural if needed

              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            } // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only


            var possibleKey;
            /* eslint no-cond-assign: 0 */

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil =
/*#__PURE__*/
function () {
  function LanguageUtil(options) {
    classCallCheck$1(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.whitelist || false;
    this.logger = baseLogger.create('languageUtils');
  }

  createClass$1(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      // http://www.iana.org/assignments/language-tags/language-tags.xhtml
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase(); // if lenght 2 guess it's a country

          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks.default || []; // asume we have an object defining fallbacks

      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks.default;
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this.isWhitelisted(c)) {
          codes.push(c);
        } else {
          _this.logger.warn("rejecting non-whitelisted language code: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

/* eslint-disable */

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver =
/*#__PURE__*/
function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    classCallCheck$1(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  createClass$1(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        // if (rule.numbers.length === 1) return ''; // only singular
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx]; // special treatment for lngs only having singular and plural

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        }; // COMPATIBILITY JSON
        // v1


        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (
        /* v2 */
        this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (
        /* v3 - gettext index */
        this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator =
/*#__PURE__*/
function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    classCallCheck$1(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.init(options, true);
  }
  /* eslint no-param-reassign: 0 */


  createClass$1(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var reset = arguments.length > 1 ? arguments[1] : undefined;

      if (reset) {
        this.options = options;

        this.format = options.interpolation && options.interpolation.format || function (value) {
          return value;
        };
      }

      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000; // the regexp

      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      // the regexp
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) return getPath(data, key);
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPath(data, k), f, lng);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      replaces = 0; // unescape if has unescapePrefix/Suffix

      /* eslint no-cond-assign: 0 */

      while (match = this.regexpUnescape.exec(str)) {
        value = handleFormat(match[1].trim());
        str = str.replace(match[0], value);
        this.regexpUnescape.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      replaces = 0; // regular escape on demand

      while (match = this.regexp.exec(str)) {
        value = handleFormat(match[1].trim());

        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            var temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else {
            this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }

        value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
        replaces++;

        if (replaces >= this.maxReplaces) {
          break;
        }
      }

      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = objectSpread$1({}, options);

      clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
      // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"

      function handleHasOptions(key, inheritedOptions) {
        if (key.indexOf(',') < 0) return key;
        var p = key.split(',');
        key = p.shift();
        var optionsString = p.join(',');
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = objectSpread$1({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.error("failed parsing options string in nesting for key ".concat(key), e);
        }

        return key;
      } // regular escape on demand


      while (match = this.nestingRegexp.exec(str)) {
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions); // is only the nesting key (key1 = '$(key2)') return the value without stringify

        if (value && match[0] === str && typeof value !== 'string') return value; // no string to include or empty

        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        } // Nested keys should not be escaped by default #854
        // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);


        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles$1 = _arrayWithHoles$2;

function _iterableToArrayLimit$2(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit$1 = _iterableToArrayLimit$2;

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest$1 = _nonIterableRest$2;

function _slicedToArray$2(arr, i) {
  return arrayWithHoles$1(arr) || iterableToArrayLimit$1(arr, i) || nonIterableRest$1();
}

var slicedToArray$1 = _slicedToArray$2;

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector =
/*#__PURE__*/
function (_EventEmitter) {
  inherits$1(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    classCallCheck$1(this, Connector);

    _this = possibleConstructorReturn$1(this, getPrototypeOf$2(Connector).call(this));
    EventEmitter.call(assertThisInitialized$1(assertThisInitialized$1(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  createClass$1(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      // find what needs to be loaded
      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2; // loaded
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1; // pending

            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var _name$split = name.split('|'),
          _name$split2 = slicedToArray$1(_name$split, 2),
          lng = _name$split2[0],
          ns = _name$split2[1];

      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      } // set loaded


      this.state[name] = err ? -1 : 2; // consolidated loading done in this run - only emit once for a loaded namespace

      var loaded = {}; // callback if ready

      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          // only do once per loaded -> this.emit('loaded', q.loaded);
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          /* eslint no-param-reassign: 0 */

          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      }); // emit consolidated loaded event

      this.emit('loaded', loaded); // remove done load requests

      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {}); // noting to load

      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data
        /* = retryFlag */
        && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now

        return null; // pendings will trigger callback
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var _name$split3 = name.split('|'),
          _name$split4 = slicedToArray$1(_name$split3, 2),
          lng = _name$split4[0],
          ns = _name$split4[1];

      this.read(lng, ns, 'read', null, null, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null
        /* unused callback */
        , objectSpread$1({}, options, {
          isUpdate: isUpdate
        }));
      } // write to store to avoid resending


      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    // string or array of namespaces
    whitelist: false,
    // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all',
    // | currentOnly | languageOnly
    preload: false,
    // array with preload languages
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    // allow bundling certain languages that are not remotely fetched
    saveMissing: false,
    // enable to send missing values
    updateMissing: false,
    // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback',
    // 'current' || 'all'
    saveMissingPlurals: true,
    // will save all forms not only singular key
    missingKeyHandler: false,
    // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false,
    // function(str, match)
    postProcess: false,
    // string or array of postProcessor names
    returnNull: true,
    // allows null value as valid translation
    returnEmptyString: true,
    // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false,
    // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {},
    // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false,
    // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof_1$1(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof_1$1(args[2]) === 'object' || _typeof_1$1(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop

    }
  };
}
/* eslint no-param-reassign: 0 */

function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS]; // extend whitelist with cimode

  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n$1 =
/*#__PURE__*/
function (_EventEmitter) {
  inherits$1(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    classCallCheck$1(this, I18n);

    _this = possibleConstructorReturn$1(this, getPrototypeOf$2(I18n).call(this));
    EventEmitter.call(assertThisInitialized$1(assertThisInitialized$1(_this))); // <=IE10 fix (unable to call parent constructor)

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return possibleConstructorReturn$1(_this, assertThisInitialized$1(assertThisInitialized$1(_this)));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  createClass$1(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      this.options = objectSpread$1({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      } // init services


      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options); // pipe events from backendConnector

        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options); // pipe events from translator

        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      } // append api


      var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var deferred = defer();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;

          _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)

          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
    /* eslint consistent-return: 0 */

  }, {
    key: "loadResources",
    value: function loadResources() {
      var _this3 = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!this.language) {
          // at least load fallbacks in this case
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(this.language);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, callback);
      } else {
        callback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve(); // not rejecting on err (as err is only a loading translation failed warning)

        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      var deferred = defer();

      var done = function done(err, l) {
        _this4.translator.changeLanguage(l);

        if (l) {
          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options = objectSpread$1({}, opts);

        if (_typeof_1$1(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this6 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      }); // Exit early if all given languages are already preloaded

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
    /* eslint class-methods-use-this: 0 */

  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this7 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = objectSpread$1({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this7[m];
      });
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options; // sync options

      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n$1();

var changeLanguage = i18next.changeLanguage.bind(i18next);
var cloneInstance = i18next.cloneInstance.bind(i18next);
var createInstance = i18next.createInstance.bind(i18next);
var dir = i18next.dir.bind(i18next);
var exists = i18next.exists.bind(i18next);
var getFixedT = i18next.getFixedT.bind(i18next);
var init = i18next.init.bind(i18next);
var loadLanguages = i18next.loadLanguages.bind(i18next);
var loadNamespaces$1 = i18next.loadNamespaces.bind(i18next);
var loadResources = i18next.loadResources.bind(i18next);
var off = i18next.off.bind(i18next);
var on = i18next.on.bind(i18next);
var setDefaultNamespace = i18next.setDefaultNamespace.bind(i18next);
var t$1 = i18next.t.bind(i18next);
var use = i18next.use.bind(i18next);

/* tslint:disable-next-line:no-floating-promises */

i18next.use(reactI18nextModule).init({
  fallbackLng: 'en-US',
  defaultNS: 'translations',
  interpolation: {
    // React already does escaping
    escapeValue: false
  },
  react: {
    wait: true
  }
});
i18next.addResourceBundle('en-US', 'translations', combined, true);

var EntryPoint =
/*#__PURE__*/
function (_Component) {
  _inherits(EntryPoint, _Component);

  function EntryPoint() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, EntryPoint);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(EntryPoint)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.changeI18nLanguage = function (locale) {
      var strLocale = locale.toString();

      if (!i18next.hasResourceBundle(strLocale, 'translations')) {
        i18next.addResourceBundle(strLocale, 'translations', loadTranslations(locale), true);
      }
      /* tslint:disable-next-line:no-floating-promises */


      i18next.changeLanguage(strLocale);
    }, _temp));
  }

  _createClass(EntryPoint, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.changeI18nLanguage(this.props.locale);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.locale !== this.props.locale) {
        this.changeI18nLanguage(this.props.locale);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          profileValidate = _this$props.profile,
          productsValidate = _this$props.products,
          featureConfig = _this$props.featureConfig;
      var profileIsInvalid = Object.keys(profileValidate).length === 0 && profileValidate.constructor === Object;
      var productsAreInvalid = Object.keys(productsValidate).length === 0 && productsValidate.constructor === Object;
      var defaultsActivated = featureConfig && featureConfig.devOnlyMockProfile && (profileIsInvalid || productsAreInvalid);

      if (defaultsActivated) {
        console.log('DEFAULT PROPS ACTIVATED. profileIsInvalid: ' + profileIsInvalid + ', productsAreInvalid: ' + productsAreInvalid + '\nDefaults are: ' + JSON.stringify(defaultProps));
      }

      var _ref = defaultsActivated ? defaultProps : this.props,
          baseUrls = _ref.baseUrls,
          imageUrls = _ref.imageUrls,
          products = _ref.products,
          profile = _ref.profile,
          _ref$features = _ref.features,
          features = _ref$features === void 0 ? [] : _ref$features,
          featureFlags = _ref.featureFlags,
          lastUpdatedDateTime = _ref.lastUpdatedDateTime,
          locale = _ref.locale,
          handleEvent = _ref.handleEvent;

      var featureFlagsContextValue = featureFlags !== undefined ? featureFlags : {};
      var featureConfigContextValue = featureConfig !== undefined ? featureConfig : {};
      var dateTime = lastUpdatedDateTime !== undefined ? parse_1(lastUpdatedDateTime) : set_minutes(start_of_year(new Date()), 1);

      if (profileIsInvalid && !(featureConfig && featureConfig.devOnlyMockProfile)) {
        return React__default.createElement(FeatureFlagProvider, {
          value: featureFlagsContextValue
        }, React__default.createElement(FeatureConfigProvider, {
          value: featureConfigContextValue
        }, React__default.createElement(UrlProvider, {
          value: {
            baseUrls: baseUrls,
            imageUrls: imageUrls
          }
        }, React__default.createElement(FeatureProvider, {
          value: {
            features: features
          }
        }, React__default.createElement(LocaleProvider, {
          value: {
            locale: locale
          }
        }, React__default.createElement(I18nextProvider, {
          i18n: i18next
        }, React__default.createElement(LastUpdatedProvider, {
          value: {
            dateTime: dateTime
          }
        }, React__default.createElement(EventAdapter, {
          handler: handleEvent
        }, React__default.createElement(StickyManager, null, children)))))))));
      }

      return React__default.createElement(FeatureFlagProvider, {
        value: featureFlagsContextValue
      }, React__default.createElement(FeatureConfigProvider, {
        value: featureConfigContextValue
      }, React__default.createElement(UrlProvider, {
        value: {
          baseUrls: baseUrls,
          imageUrls: imageUrls
        }
      }, React__default.createElement(ProductProvider, {
        value: {
          products: products
        }
      }, React__default.createElement(ProfileProvider, {
        value: {
          profile: profile
        }
      }, React__default.createElement(FeatureProvider, {
        value: {
          features: features
        }
      }, React__default.createElement(LocaleProvider, {
        value: {
          locale: locale
        }
      }, React__default.createElement(I18nextProvider, {
        i18n: i18next
      }, React__default.createElement(LastUpdatedProvider, {
        value: {
          dateTime: dateTime
        }
      }, React__default.createElement(EventAdapter, {
        handler: handleEvent
      }, React__default.createElement(StickyManager, null, children)))))))))));
    }
  }]);

  return EntryPoint;
}(Component);

export { Header, Footer, EntryPoint, ImageKey };
